(() => {
'use strict';

const app=document.getElementById('nj-app');
if(!app)return;

/* V14.3.1 · Anclaje único de preguntas en ordenador, tablet y móvil.
   En cada cambio de paso alinear el inicio de la tarjeta bajo la cabecera
   visible, sin enfoque al título, animación de desplazamiento ni espera
   de 70ms. Los clics de selección múltiple NO provocan desplazamiento. */
const njQuizTopOffset=()=>{
  const header=document.querySelector('sticky-header,.shopify-section-header-sticky');
  if(!header)return 18;
  const rect=header.getBoundingClientRect();
  const height=rect.top<=2 && rect.bottom>0 ? Math.min(160,Math.max(0,rect.bottom)) : 0;
  return height+18;
};
const njAlignNewStep=()=>{
  const anchor=app.querySelector('.nj-lux-question,.nj-lux-hero,.nj-receta__result')||app;
  const top=window.scrollY+anchor.getBoundingClientRect().top-njQuizTopOffset();
  const target=Math.max(0,Math.round(top));
  if(Math.abs(target-window.scrollY)>2)
    window.scrollTo({left:window.scrollX,top:target,behavior:'instant'});
};
const njStepObserver=new MutationObserver(records=>{
  if(records.some(r=>r.target===app && [...r.addedNodes].some(n=>n.nodeType===1))){
    njAlignNewStep();
  }
});
njStepObserver.observe(app,{childList:true});
if(!document.getElementById('nj-stable-step-css')){
  const css=document.createElement('style');
  css.id='nj-stable-step-css';
  css.textContent='#nj-receta,#nj-app{overflow-anchor:none}';
  document.head.appendChild(css);
}

if(!document.getElementById('nj-premium-ui-css')){const st=document.createElement('style');st.id='nj-premium-ui-css';st.textContent="#nj-app{--nj-ink:#292621;--nj-sand:#f7f4ee;--nj-line:#e6ded2;color:var(--nj-ink);max-width:980px;margin-inline:auto}#nj-app h3{font-family:Georgia,serif;font-weight:400;font-size:clamp(28px,4vw,42px);line-height:1.15;letter-spacing:-.025em;margin:16px 0 26px}#nj-app .nj-receta__progress,#nj-app .nj-receta__rlabel{font-size:11px;letter-spacing:.18em;color:#876e58;font-weight:600}#nj-app .nj-receta__options{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:12px;margin:22px 0}#nj-app .nj-receta__options button{min-height:64px;background:white;border:1px solid var(--nj-line);color:var(--nj-ink);text-align:left;padding:15px 18px;border-radius:2px;font-size:15px}#nj-app .nj-receta__options button:hover,#nj-app .nj-receta__options button[aria-pressed=true]{background:#f7f4ee;border-color:#a48b74}#nj-app button:focus-visible{outline:2px solid #90745e;outline-offset:3px}#nj-app .nj-receta__rh3{font:400 clamp(28px,4vw,43px)/1.2 Georgia,serif;letter-spacing:-.02em;display:block;margin:10px 0 22px}#nj-app .nj-premium-intro{background:#f7f4ee;padding:30px clamp(18px,4vw,45px);margin:20px 0 34px;border-block:1px solid #e6ded2}#nj-app .nj-premium-intro h2{font:400 clamp(26px,3vw,37px)/1.2 Georgia,serif;margin:10px 0}#nj-app .nj-premium-intro p{max-width:680px;line-height:1.7}#nj-app .nj-receta__block{padding-top:16px;margin:35px 0;border-top:1px solid #e6ded2}#nj-app .nj-receta__btitle{font-size:12px;letter-spacing:.18em;color:#78604e;font-weight:600}#nj-app .nj-step{display:grid;grid-template-columns:140px minmax(0,1fr);gap:25px;padding:22px 0;border-bottom:1px solid #e6ded2}#nj-app .nj-step img{width:100%;height:160px;object-fit:contain;background:#fbfaf8;padding:8px}#nj-app .nj-step>div>strong{font-size:11px;letter-spacing:.1em;color:#876e58}#nj-app .nj-step small{line-height:1.6;color:#6d665f}#nj-app .nj-premium-total{display:flex;justify-content:space-between;align-items:center;gap:16px;margin:25px 0 10px;padding:18px 0;border-block:1px solid #e6ded2}#nj-app .nj-premium-total strong{font-size:24px;font-weight:500}#nj-app .nj-premium-note{color:#706961;font-size:12px;line-height:1.6}#nj-app .nj-actions [data-cart]{background:#27231f;color:white;border-radius:2px;padding:15px 24px;letter-spacing:.1em}#nj-app .nj-receta__guidance{background:#faf8f4;padding:24px;margin:32px 0}@media(max-width:640px){#nj-app .nj-receta__options{grid-template-columns:1fr;gap:9px}#nj-app .nj-receta__options button{min-height:56px}#nj-app .nj-step{grid-template-columns:102px minmax(0,1fr);gap:14px}#nj-app .nj-step img{height:124px}#nj-app .nj-premium-intro{padding:20px 16px}#nj-app .nj-premium-total strong{font-size:21px}}";document.head.appendChild(st);}
if(!document.getElementById('nj-luxury-upgrade-v2')){const st=document.createElement('style');st.id='nj-luxury-upgrade-v2';st.textContent="#nj-app{--nj-ivory:#fbfaf7;--nj-cream:#f5f1eb;--nj-taupe:#8a7563;--nj-ink:#25231f;--nj-soft:#71695f;--nj-rule:#e3dbd0;font-family:inherit;max-width:1000px;margin:0 auto;line-height:1.65}#nj-app .nj-lux-eyebrow{font-size:10px!important;letter-spacing:.24em!important;text-transform:uppercase!important;color:#8c7866!important;font-weight:600}#nj-app .nj-lux-hero{position:relative;background:linear-gradient(133deg,#f5f1ea 0%,#fdfcf9 60%,#e9e1d7 100%);padding:clamp(30px,5vw,62px);margin:0 0 29px;border:1px solid #e8e1d7;text-align:center;overflow:hidden}#nj-app .nj-lux-hero:before{content:'';position:absolute;top:-70px;right:-35px;width:270px;height:270px;border-radius:50%;border:1px solid #d9c8b4;opacity:.45;pointer-events:none}#nj-app .nj-lux-hero h3{font:400 clamp(36px,5vw,60px)/1.08 Georgia,'Times New Roman',serif!important;letter-spacing:-.045em;margin:16px auto 20px;max-width:740px}#nj-app .nj-lux-hero .muted{margin-inline:auto;max-width:620px;font-size:15px}#nj-app .nj-lux-hero .nj-receta__options{max-width:560px;margin:28px auto 0}#nj-app .nj-lux-hero .nj-receta__options button{text-align:center}#nj-app .nj-lux-hero .nj-lux-signature{font:italic 18px Georgia,serif;color:#8a7563;margin-top:27px}#nj-app .nj-lux-question{padding:clamp(22px,4vw,44px);background:#fdfcf9;border:1px solid var(--nj-rule);margin:10px 0 24px}#nj-app .nj-lux-question h3{max-width:760px;margin:14px 0 18px!important;font-size:clamp(29px,4vw,45px)!important}#nj-app .nj-lux-question .nj-receta__options{gap:12px;margin-top:27px}#nj-app .nj-lux-question .nj-receta__options button{position:relative;padding:18px 45px 18px 19px;border-radius:0;box-shadow:0 3px 18px rgba(40,30,17,.025);transition:background .18s,border-color .18s,transform .18s}#nj-app .nj-lux-question .nj-receta__options button:after{content:'↗';position:absolute;right:17px;top:50%;transform:translateY(-50%);font-size:16px;color:#ac9b8c}#nj-app .nj-lux-question .nj-receta__options button:hover{transform:translateY(-2px);border-color:#9d8670}#nj-app .nj-lux-question .nj-receta__options button[aria-pressed=true]:after{content:'✓';color:#66513e}#nj-app .nj-lux-progress{height:3px;background:#e8e0d5;margin:17px 0 28px;overflow:hidden}#nj-app .nj-lux-progress span{display:block;height:100%;background:#8f7660}#nj-app .nj-premium-intro{background:linear-gradient(124deg,#f5f1eb,#fffdfa);padding:clamp(28px,5vw,56px);border:1px solid var(--nj-rule);margin:24px 0 34px}#nj-app .nj-premium-intro h2{font:400 clamp(32px,4vw,48px)/1.12 Georgia,serif;letter-spacing:-.04em;max-width:690px}#nj-app .nj-receta__result>.nj-receta__rlabel{color:#927d68!important}#nj-app .nj-receta__result>.nj-receta__rh3{font:400 clamp(23px,3.4vw,34px)/1.3 Georgia,serif!important;margin-bottom:19px}#nj-app .nj-receta__block{background:#fff;padding:25px clamp(16px,3vw,30px);border:1px solid #eee8df;margin:28px 0}#nj-app .nj-receta__btitle{color:#8c745d;margin:0 0 19px;font-size:11px;letter-spacing:.2em}#nj-app .nj-step{grid-template-columns:clamp(100px,16vw,180px) minmax(0,1fr);gap:clamp(14px,3vw,30px);padding:24px 0}#nj-app .nj-step img{height:clamp(140px,17vw,195px);object-fit:contain;background:#f8f6f3;padding:14px}#nj-app .nj-step>div>strong{color:#8c7562;letter-spacing:.11em;font-size:10px}#nj-app .nj-step>div>p a{font-size:clamp(15px,1.8vw,19px);line-height:1.35;display:inline-block}#nj-app .nj-step small{color:#6c655d}#nj-app .nj-step--shared{background:#fbf9f6;padding:14px 18px;margin:7px 0;border:1px solid #ede5db}#nj-app .nj-premium-total{background:#f8f5f0;padding:25px;margin:25px 0 10px}#nj-app .nj-premium-total strong{font:400 clamp(23px,3vw,32px) Georgia,serif}#nj-app .nj-actions{display:grid;grid-template-columns:repeat(3,1fr);gap:10px;margin:18px 0}#nj-app .nj-actions [data-cart]{grid-column:1/-1;min-height:58px;background:#27241f;color:white;letter-spacing:.11em}#nj-app .nj-actions .sec{border:1px solid var(--nj-rule);background:#fff;color:#514a42;padding:13px 8px;font-size:11px;letter-spacing:.05em}#nj-app .nj-receta__guidance{background:#faf8f5;border-left:2px solid #b39e88;padding:24px;margin:24px 0}#nj-app .nj-receta__firma{padding:32px 0;text-align:center;border-top:1px solid var(--nj-rule)}#nj-app button:focus-visible{outline:2px solid #886c52;outline-offset:3px}@media(max-width:640px){#nj-app .nj-lux-hero{padding:32px 20px}#nj-app .nj-lux-question{padding:22px 15px}#nj-app .nj-step{grid-template-columns:102px minmax(0,1fr);gap:14px}#nj-app .nj-step img{height:130px;padding:7px}#nj-app .nj-receta__block{padding:19px 14px}#nj-app .nj-actions{grid-template-columns:1fr 1fr}#nj-app .nj-actions [data-print]{display:none}#nj-app .nj-lux-hero .nj-receta__options{grid-template-columns:1fr}}@media(prefers-reduced-motion:reduce){#nj-app *,#nj-app *:before,#nj-app *:after{transition:none!important;animation:none!important}}";document.head.appendChild(st);}
if(!document.getElementById('nj-shop-experience-css')){const st=document.createElement('style');st.id='nj-shop-experience-css';st.textContent="#nj-app .nj-shop-editor{margin:30px 0;padding:clamp(20px,3.4vw,36px);background:#faf8f4;border:1px solid #e9e0d5}#nj-app .nj-shop-editor h3{font:400 clamp(27px,3.4vw,38px)/1.15 Georgia,serif;margin:10px 0 15px}#nj-app .nj-shop-tiers{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px;margin:25px 0}#nj-app .nj-shop-tiers button{padding:15px 8px;min-height:52px;border:1px solid #dbd0c3;background:white;color:#534b44;font-size:10px;letter-spacing:.08em;font-weight:600}#nj-app .nj-shop-tiers button[aria-pressed=true]{background:#28241e;color:white;border-color:#28241e}#nj-app .nj-shop-selection{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px}#nj-app .nj-shop-item{display:flex;gap:12px;align-items:start;padding:14px;border:1px solid #e9e1d7;background:#fff;cursor:pointer}#nj-app .nj-shop-item input{margin-top:5px;width:18px;height:18px;accent-color:#6b5848;flex-shrink:0}#nj-app .nj-shop-item strong{display:block;font-size:13px;line-height:1.4;font-weight:500}#nj-app .nj-shop-item small{display:block;font-size:12px;color:#73685d;margin-top:6px}#nj-app .nj-shop-hint{font-size:12px;line-height:1.65;color:#75695f;margin-top:16px}@media(max-width:640px){#nj-app .nj-shop-tiers{grid-template-columns:1fr;gap:7px}#nj-app .nj-shop-selection{grid-template-columns:1fr}}";document.head.appendChild(st);}
if(!document.getElementById('nj-product-editorial-css')){const st=document.createElement('style');st.id='nj-product-editorial-css';st.textContent="#nj-app .nj-lux-product{grid-template-columns:minmax(110px,190px) minmax(0,1fr);align-items:start;gap:clamp(18px,3vw,34px);padding:28px 0;border-bottom:1px solid #e9e1d7}#nj-app .nj-lux-photo{background:#f8f6f2;aspect-ratio:4/5;display:flex;align-items:center;justify-content:center;padding:15px}#nj-app .nj-lux-photo img{max-width:100%;width:100%;height:100%;max-height:220px;object-fit:contain;background:transparent;padding:0}#nj-app .nj-lux-step{font-size:10px;letter-spacing:.15em;text-transform:uppercase;color:#94795f;font-weight:600;margin:0 0 14px}#nj-app .nj-lux-vendor{font-size:10px;letter-spacing:.17em;color:#867c73;text-transform:uppercase;margin:0 0 5px}#nj-app .nj-lux-details h4{font:400 clamp(18px,2vw,24px)/1.28 Georgia,serif;letter-spacing:-.015em;margin:5px 0 14px}#nj-app .nj-lux-details h4 a{font:inherit;color:#29241f;text-decoration:none}#nj-app .nj-lux-details h4 a:hover{text-decoration:underline}#nj-app .nj-lux-meta{display:flex;align-items:center;flex-wrap:wrap;gap:12px;margin:13px 0 18px}#nj-app .nj-lux-price{font-size:17px;font-weight:600;color:#28231f}#nj-app .nj-lux-use{font-size:9px;font-weight:600;letter-spacing:.14em;color:#826b58;border:1px solid #e0d4c5;padding:6px 9px}#nj-app .nj-lux-rationale{font-size:13px;line-height:1.75;color:#5f5953;margin:15px 0}#nj-app .nj-lux-rationale span{display:block;font-size:10px;letter-spacing:.12em;font-weight:600;color:#8d765e;margin-bottom:6px}#nj-app .nj-lux-alt{border-left:2px solid #aa947b;background:#faf6ee;padding:13px;font-size:12px;line-height:1.7;color:#69594b}#nj-app .nj-lux-format,#nj-app .nj-lux-protocol{font-size:12px;color:#746a5f;line-height:1.6}#nj-app .nj-lux-product-link{font-size:12px;letter-spacing:.06em;text-decoration:none;border-bottom:1px solid #8b735d;padding-bottom:3px;color:#473c33;display:inline-flex;gap:12px;margin-top:12px}#nj-app .nj-lux-excluded{opacity:.47;filter:grayscale(.35)}#nj-app .nj-lux-excluded:after{content:'NO INCLUIDO EN LA COMPRA';grid-column:1/-1;font-size:10px;letter-spacing:.12em;color:#78685b}#nj-app .nj-shop-item:has(input:checked){border-color:#a9937b;background:#fffdf9}@media(max-width:640px){#nj-app .nj-lux-product{grid-template-columns:105px minmax(0,1fr);gap:14px;padding:22px 0}#nj-app .nj-lux-photo{padding:6px}#nj-app .nj-lux-details h4{font-size:18px}#nj-app .nj-lux-use{letter-spacing:.07em;font-size:8px}#nj-app .nj-lux-rationale{font-size:12px}}";document.head.appendChild(st);}
if(!document.getElementById('nj-top-cart-css')){const st=document.createElement('style');st.id='nj-top-cart-css';st.textContent="#nj-app .nj-top-cart{display:flex;align-items:center;justify-content:space-between;gap:16px;background:#29251f;padding:22px 24px;margin:25px 0 0;color:white}#nj-app .nj-top-cart>div{display:flex;flex-direction:column;gap:3px}#nj-app .nj-top-cart-label{font-size:9px;letter-spacing:.16em;color:#d8c8b7}#nj-app .nj-top-cart strong{font:400 27px Georgia,serif;color:white}#nj-app .nj-top-cart small{font-size:11px;color:#e1d8cf}#nj-app .nj-top-cart button{background:#f5eee5;border:1px solid #f5eee5;color:#25211d;padding:16px 22px;font-size:11px;letter-spacing:.08em;font-weight:600;min-height:52px}#nj-app .nj-top-cart button:disabled{opacity:.6;cursor:not-allowed}@media(max-width:620px){#nj-app .nj-top-cart{flex-direction:column;align-items:stretch;padding:18px}#nj-app .nj-top-cart button{width:100%}}";document.head.appendChild(st);}
if(!document.getElementById('nj-expert-lux-v3')){const st=document.createElement('style');st.id='nj-expert-lux-v3';st.textContent="#nj-app .nj-expert-insight{position:relative;padding:clamp(24px,4vw,43px);background:#f6f3ee;border-left:2px solid #8e785f;margin:25px 0}#nj-app .nj-expert-tag{font-size:10px;letter-spacing:.19em;color:#8a755e;font-weight:600}#nj-app .nj-expert-insight h4{font:400 clamp(25px,3vw,36px)/1.18 Georgia,serif;color:#322e29;margin:14px 0}#nj-app .nj-expert-insight p{max-width:700px;color:#615951;font-size:14px;line-height:1.8}#nj-app .nj-expert-insight .nj-expert-disclaimer{font-size:11px;color:#857a70;margin-top:18px}#nj-app .nj-shop-editor .nj-shop-item:hover{border-color:#96826e}#nj-app .nj-shop-editor .nj-shop-tiers button:focus-visible{outline:2px solid #8e785f;outline-offset:3px}";document.head.appendChild(st);}
if(!document.getElementById('nj-tiers-functional-v4')){const e=document.createElement('style');e.id='nj-tiers-functional-v4';e.textContent="#nj-app .nj-shop-v4 .nj-shop-tiers button{display:flex;flex-direction:column;justify-content:center;align-items:center;gap:5px;text-align:center;border-radius:2px;min-height:90px;padding:15px 9px}#nj-app .nj-shop-v4 .nj-shop-tiers button strong{font-size:11px;letter-spacing:.10em}#nj-app .nj-shop-v4 .nj-shop-tiers button small{font-size:11px;letter-spacing:0;line-height:1.5}#nj-app .nj-shop-v4 .nj-shop-tiers button:disabled{opacity:.38;cursor:not-allowed}#nj-app .nj-shop-v4 .nj-tier-explanation{font:italic 17px/1.5 Georgia,serif;color:#71675f;margin:0 0 20px}#nj-app .nj-shop-v4 .nj-upgrades{padding:20px;background:#fff;border:1px solid #e9e6e1;margin-top:19px}#nj-app .nj-shop-v4 .nj-upgrades[hidden]{display:none}#nj-app .nj-shop-v4 .nj-upgrades .nj-lux-product{margin-top:6px}#nj-app .nj-top-cart button:focus-visible{outline:2px solid #8c7560;outline-offset:3px}@media(max-width:680px){#nj-app .nj-shop-v4 .nj-shop-tiers{grid-template-columns:repeat(3,minmax(0,1fr));gap:5px}#nj-app .nj-shop-v4 .nj-shop-tiers button{min-height:88px;padding:11px 4px}#nj-app .nj-shop-v4 .nj-shop-tiers button strong{font-size:9px;letter-spacing:.02em}#nj-app .nj-shop-v4 .nj-shop-tiers button small{font-size:10px}}";document.head.appendChild(e);}
if(!document.getElementById('nj-fresh-editorial-v5')){const e=document.createElement('style');e.id='nj-fresh-editorial-v5';e.textContent="#nj-app{--nj-ivory:#fcfcfa;--nj-cream:#f5f8f4;--nj-taupe:#728678;--nj-ink:#28382d;--nj-rule:#e2e9e1;background:linear-gradient(180deg,#fff,#fcfcfa);color:#28382d}#nj-app .nj-lux-hero{background:linear-gradient(122deg,#eff5ef 0%,#fcfdfb 58%,#f2f5ef 100%);border:1px solid #e2eae2;box-shadow:none;padding:clamp(40px,6vw,84px) clamp(24px,6vw,78px)}#nj-app .nj-lux-hero:before{border-color:#b9cfc3;top:-45px;right:10px}#nj-app .nj-lux-hero h3{font-family:'Iowan Old Style',Baskerville,Georgia,serif!important;letter-spacing:-.055em}#nj-app .nj-lux-question{background:#fff;border-color:#e2e9e3;border-radius:4px}#nj-app .nj-lux-question .nj-receta__options button{border-color:#dfe7df;background:#fafcf9;border-radius:5px;box-shadow:none}#nj-app .nj-lux-question .nj-receta__options button:hover{border-color:#82988a;background:#f2f7f2}#nj-app .nj-lux-progress{background:#e6ebe6}#nj-app .nj-lux-progress span{background:#788e7f}#nj-app .nj-editorial-cover{position:relative;overflow:hidden;background:#f1f6f1!important;border:1px solid #e0e8df;border-radius:5px;padding:clamp(32px,5vw,65px)!important;margin:16px 0 30px;box-shadow:none}#nj-app .nj-editorial-cover:after{content:'';position:absolute;right:-80px;bottom:-140px;width:340px;height:340px;border:1px solid #b5cabb;border-radius:50%;opacity:.45;pointer-events:none}#nj-app .nj-editorial-edition{font-size:10px;letter-spacing:.22em;color:#6d8273;font-weight:600}#nj-app .nj-editorial-cover h2{font:400 clamp(38px,5vw,60px)/1.03 'Iowan Old Style',Baskerville,Georgia,serif!important;letter-spacing:-.055em;max-width:660px;color:#263c30;margin:20px 0}#nj-app .nj-editorial-cover h2 em{font-weight:400;color:#738b7a}#nj-app .nj-editorial-cover>p:not(.nj-receta__rlabel){max-width:620px;line-height:1.8;color:#536257}#nj-app .nj-editorial-profile{display:flex;flex-wrap:wrap;align-items:center;gap:10px;margin:31px 0 14px}#nj-app .nj-editorial-profile span{font-size:9px;letter-spacing:.15em;color:#617265}#nj-app .nj-editorial-profile strong{font-size:12px;font-weight:500;border:1px solid #bfcfc2;padding:8px 12px;color:#405e48;background:#f9fcf9}#nj-app .nj-editorial-signature{font:italic 18px Georgia,serif;color:#6f8475;margin:22px 0 0!important}#nj-app .nj-shop-v4{background:#f9fbf8;border-color:#e0e8df;border-radius:5px}#nj-app .nj-shop-v4 h3{letter-spacing:-.04em;color:#293d31}#nj-app .nj-shop-v4 .nj-shop-tiers button{border-color:#d9e4d9;border-radius:4px;background:#fff;color:#425248}#nj-app .nj-shop-v4 .nj-shop-tiers button[aria-pressed=true]{background:#324a3a;color:#fff;border-color:#324a3a}#nj-app .nj-top-cart{background:#31483a;border-radius:5px}#nj-app .nj-top-cart button{background:#f9fbf8;border:1px solid #f9fbf8;color:#304539;border-radius:3px}#nj-app .nj-expert-insight{background:#f3f6f1;border-color:#a7bda9;border-radius:5px}#nj-app .nj-lux-photo{background:#f5f8f5;border-radius:4px}#nj-app .nj-lux-price{color:#32483b}#nj-app .nj-lux-use{border-color:#d1dfd3;color:#51725c;background:#f7faf7;border-radius:3px}#nj-app .nj-lux-rationale span,#nj-app .nj-lux-synergy span{display:block;color:#5d7c65;font-size:10px;letter-spacing:.13em;font-weight:700;margin-bottom:7px}#nj-app .nj-lux-rationale,#nj-app .nj-lux-synergy{font-size:13px;line-height:1.75;color:#57655b;margin:15px 0}#nj-app .nj-lux-synergy{border-top:1px solid #e4ebe4;padding-top:13px}#nj-app .nj-lux-product-link{border-color:#738a79;color:#3a5942}#nj-app .nj-receta__block{border-color:#e4ebe4;background:#fff;border-radius:4px}#nj-app .nj-receta__btitle{color:#68806c}#nj-app .nj-premium-total{background:#f3f7f3;border-radius:4px}#nj-app .nj-actions [data-cart]{background:#324a3a;border-radius:4px}#nj-app .nj-receta__guidance{background:#f6f8f5;border-color:#96b19d}#nj-app button:focus-visible{outline-color:#3d7150}@media(max-width:640px){#nj-app .nj-editorial-cover{padding:31px 21px!important}#nj-app .nj-editorial-cover h2{font-size:38px!important}#nj-app .nj-lux-hero h3{font-size:38px!important}#nj-app .nj-lux-rationale,#nj-app .nj-lux-synergy{font-size:12px}}";document.head.appendChild(e);}

if(!document.getElementById('nj-quiz-v142-guidance-css')){
 const st=document.createElement('style');st.id='nj-quiz-v142-guidance-css';
 st.textContent='#nj-app .nj-shop-v4 .nj-shop-tiers button[aria-checked="true"]{background:#324a3a!important;color:#fff!important;border:2px solid #324a3a!important;box-shadow:inset 0 0 0 2px #fff!important}#nj-app .nj-shop-v4 .nj-shop-tiers button[aria-checked="true"]:after{content:"✓";display:inline-block;margin-left:5px;color:#fff}#nj-app .nj-usage-guide{border-left:3px solid #96b19d;margin:24px 0;padding:22px;background:#f6f8f5}#nj-app .nj-usage-guide h4{font-size:12px;letter-spacing:.08em;color:#34503d;font-weight:600;margin:18px 0 7px}#nj-app .nj-usage-guide ol{padding-left:23px;margin:6px 0 15px}#nj-app .nj-usage-guide li{padding:7px 0;line-height:1.55}#nj-app .nj-guide-usage{display:block;font-size:13px;color:#545e56;margin-top:4px}#nj-app .nj-usage-guide li a{display:inline-block;margin-top:4px;text-decoration:underline;font-size:12px;color:#34503d}#nj-app .nj-guide-note{font-size:12px;color:#6c746b;margin:15px 0 0;line-height:1.65}#nj-app .nj-guide-intro{font-size:13px;color:#5d665e}';document.head.appendChild(st);
}

const S={
  categoria:'',
  modalidad:'',
  singleRole:'',
  brandPreference:'',
  p1:'',
  p2:'',
  p3:'',
  p4:'',
  p5:'',
  nightCream:'recommend',
  eyeChoice:'No, prefiero no incluirlo',
  eyeNeed:'',
  extra:'',
  presupuesto:'none'
};

let CATALOG=null;

/* MOTOR V14 · LISTA PILOTO POR IDENTIFICADOR EXACTO
   Los metacampos profesionales de Shopify NO se exponen al cliente.
   Este subconjunto aprobado se revisa antes de ampliarse.
   El resto del catálogo no participa hasta su validación. */
const NJ_VERIFIED = {"8801052295493":{"category":"rostro","role":"cleanser","needs":["firmeza","hidratacion","antiedad"],"families":["cleansing"],"priority":90,"time":["am","pm"]},"8701635821893":{"category":"rostro","role":"cleanser","needs":["impurezas"],"families":["cleansing","blemish"],"priority":105,"time":["am","pm"]},"8801042596165":{"category":"rostro","role":"cleanser","needs":["sensibilidad"],"families":["cleansing","barrier"],"priority":110,"time":["am","pm"]},"14970365083973":{"category":"rostro","role":"cleanser","needs":["sensibilidad"],"families":["cleansing","barrier"],"priority":105,"time":["am","pm"]},"14939765670213":{"category":"rostro","role":"cleanser","needs":["hidratacion","antiedad"],"families":["cleansing"],"priority":80,"time":["am","pm"]},"15724476531013":{"category":"rostro","role":"cleanser","needs":["manchas"],"families":["cleansing"],"priority":95,"time":["am","pm"]},"16123692712261":{"category":"rostro","role":"cleanser","needs":["hidratacion","sensibilidad"],"families":["cleansing"],"priority":95,"time":["am","pm"]},"7080266924171":{"category":"rostro","role":"moisturizer","needs":["antiedad","hidratacion"],"families":["firming","antiage"],"priority":105,"time":["am","pm"],"skinTypes":["seca","normal"]},"7086930624651":{"category":"rostro","role":"moisturizer","needs":["firmeza","antiedad"],"families":["firming","antiage"],"priority":105,"time":["am","pm"],"skinTypes":["normal","seca"]},"6991410626699":{"category":"rostro","role":"moisturizer","needs":["impurezas"],"families":["blemish"],"priority":105,"time":["am","pm"],"skinTypes":["grasa","mixta"]},"15724438225221":{"category":"rostro","role":"moisturizer","needs":["sensibilidad","hidratacion"],"families":["barrier"],"priority":125,"time":["am","pm"]},"7064063574155":{"category":"rostro","role":"moisturizer","needs":["sensibilidad","hidratacion"],"families":["barrier"],"priority":130,"time":["am","pm"]},"8674869477701":{"category":"rostro","role":"moisturizer","needs":["impurezas"],"families":["blemish"],"priority":125,"time":["am","pm"],"skinTypes":["mixta","grasa"]},"15739735572805":{"category":"rostro","role":"moisturizer","needs":["firmeza","antiedad"],"families":["firming"],"priority":122,"time":["am","pm"]},"15724516409669":{"category":"rostro","role":"moisturizer","needs":["manchas","luminosidad"],"families":["brightening"],"priority":120,"time":["am","pm"]},"16130820931909":{"category":"rostro","role":"moisturizer","needs":["manchas"],"families":["brightening"],"priority":125,"time":["am","pm"]},"8350959501637":{"category":"rostro","role":"moisturizer","needs":["antiedad","hidratacion"],"families":["antiage","hydration"],"priority":120,"time":["am","pm"],"skinTypes":["seca","normal"]},"9733485691205":{"category":"rostro","role":"moisturizer","needs":["firmeza"],"families":["firming"],"priority":120,"time":["am","pm"]},"9234781405509":{"category":"rostro","role":"moisturizer","needs":["hidratacion"],"families":["hydrating"],"priority":128,"time":["am","pm"]},"14939775959365":{"category":"rostro","role":"moisturizer","needs":["hidratacion"],"families":["hydrating"],"priority":120,"time":["am","pm"]},"14939751514437":{"category":"rostro","role":"moisturizer","needs":["firmeza","antiedad"],"families":["firming"],"priority":115,"time":["am","pm"]},"9130070376773":{"category":"rostro","role":"moisturizer","needs":["antiedad","hidratacion"],"families":["antiage","hydration"],"priority":105,"time":["pm"]},"6996160577675":{"category":"rostro","role":"serum","needs":["firmeza"],"families":["firming"],"priority":138,"time":["am","pm"],"singleSerum":true},"6996124795019":{"category":"rostro","role":"serum","needs":["antiedad"],"families":["antiage"],"priority":100,"time":["am","pm"]},"14896415342917":{"category":"rostro","role":"serum","needs":["firmeza","antiedad"],"families":["firming"],"priority":137,"time":["am","pm"]},"8828486484293":{"category":"rostro","role":"serum","needs":["firmeza","antiedad"],"families":["firming"],"priority":124,"time":["am","pm"]},"9132567462213":{"category":"rostro","role":"serum","needs":["hidratacion"],"families":["hydrating"],"priority":130,"time":["am","pm"]},"9132558451013":{"category":"rostro","role":"serum","needs":["hidratacion"],"families":["hydrating"],"priority":123,"time":["am","pm"]},"16036974100805":{"category":"rostro","role":"serum","needs":["manchas"],"families":["brightening"],"priority":135,"time":["am","pm"]},"14939748434245":{"category":"rostro","role":"serum","needs":["hidratacion"],"families":["hydrating"],"priority":122,"time":["am","pm"]},"14939819442501":{"category":"rostro","role":"serum","needs":["antiedad"],"families":["antiage"],"priority":119,"time":["am","pm"]},"16123741765957":{"category":"rostro","role":"serum","needs":["impurezas"],"families":["blemish"],"priority":124,"time":["am","pm"]},"15724474007877":{"category":"rostro","role":"spf","needs":["manchas","antiedad","firmeza","impurezas","hidratacion","sensibilidad","luminosidad"],"families":[],"priority":130,"time":["am"]},"15724475253061":{"category":"rostro","role":"spf","needs":["hidratacion","manchas"],"families":["sun"],"priority":125,"time":["am"]},"9130039083333":{"category":"rostro","role":"spf","needs":["manchas","antiedad","firmeza","impurezas","hidratacion","sensibilidad","luminosidad"],"families":[],"priority":125,"time":["am"]},"7070903533707":{"category":"rostro","role":"spf","needs":["manchas","luminosidad"],"families":["sun"],"priority":120,"time":["am"]},"8826066731333":{"category":"rostro","role":"retinoid","needs":["antiedad"],"families":["renewal"],"priority":118,"time":["pm"],"actives":["retinal"],"noPregnancy":true,"noBarrier":true,"prioritySafety":"retinal_beginners","requiresRetinoidExperience":true,"intensity":"high"},"8826071908677":{"category":"rostro","role":"retinoid","needs":["antiedad"],"families":["renewal"],"priority":100,"time":["pm"],"actives":["retinal"],"noPregnancy":true,"noBarrier":true,"requiresRetinoidExperience":true,"intensity":"high"},"6990941323403":{"category":"rostro","role":"toner","needs":["impurezas","manchas","antiedad","firmeza"],"families":["exfoliation"],"priority":121,"time":["am","pm"],"actives":["aha"],"noBarrier":true,"protocol":"P50W: exfoliante progresivo. Introducir con prudencia y no mezclar esa noche con retinoides u otros ácidos."},"6991410921611":{"category":"rostro","role":"toner","needs":["manchas","luminosidad"],"families":["exfoliation","pigmentation"],"priority":126,"time":["am","pm"],"actives":["aha"],"noBarrier":true,"protocol":"P50 PIGM400: exfoliación cosmética gradual, evitar mezclar con retinoides y otros exfoliantes esa noche."},"6564092051595":{"category":"cabello","role":"cleanser","needs":["mechas"],"families":["color"],"priority":123,"time":["am","pm"]},"6564102111371":{"category":"cabello","role":"conditioner","needs":["mechas"],"families":["color"],"priority":123,"time":["am","pm"]},"6582625829003":{"category":"cabello","role":"cleanser","needs":["reparacion","hidratacion"],"families":["repair"],"priority":125,"time":["am","pm"]},"6582626877579":{"category":"cabello","role":"conditioner","needs":["reparacion","hidratacion"],"families":["repair"],"priority":125,"time":["am","pm"]},"6582627664011":{"category":"cabello","role":"mask","needs":["reparacion","hidratacion"],"families":["repair"],"priority":123,"time":["am","pm"]},"6693034098827":{"category":"cabello","role":"cleanser","needs":["hidratacion"],"families":["hydrating"],"priority":120,"time":["am","pm"]},"8713832431941":{"category":"cabello","role":"conditioner","needs":["frizz"],"families":["anti_frizz"],"priority":118,"time":["am","pm"]},"6693030592651":{"category":"cabello","role":"treatment","needs":["frizz"],"families":["anti_frizz"],"priority":121,"time":["am","pm"],"hairTypes":["fino","normal"],"noRoot":true},"8749972029765":{"category":"cabello","role":"cleanser","needs":["graso"],"families":["scalp_care"],"priority":140,"time":["am","pm"],"scalp":["graso"]},"14857596830021":{"category":"cabello","role":"cleanser","needs":["volumen"],"families":["volume"],"priority":135,"time":["am","pm"],"hairTypes":["fino"]},"6564706844811":{"category":"cabello","role":"cleanser","needs":["mechas"],"families":["color"],"priority":125,"time":["am","pm"]},"6564709695627":{"category":"cabello","role":"conditioner","needs":["mechas"],"families":["color"],"priority":125,"time":["am","pm"]},"6763995332747":{"category":"cabello","role":"cleanser","needs":["reparacion"],"families":["repair"],"priority":125,"time":["am","pm"]},"6763998675083":{"category":"cabello","role":"conditioner","needs":["reparacion"],"families":["repair"],"priority":126,"time":["am","pm"]},"6764041207947":{"category":"cabello","role":"mask","needs":["reparacion"],"families":["repair"],"priority":124,"time":["am","pm"]},"6790183682187":{"category":"cabello","role":"cleanser","needs":["reparacion"],"families":["repair"],"priority":142,"time":["am","pm"],"hairTypes":["fino","normal"]},"6790190956683":{"category":"cabello","role":"conditioner","needs":["reparacion"],"families":["repair"],"priority":142,"time":["am","pm"],"hairTypes":["fino","normal"]},"6790206292107":{"category":"cabello","role":"treatment","needs":["reparacion"],"families":["repair"],"priority":135,"time":["am","pm"]},"6790657867915":{"category":"cabello","role":"cleanser","needs":["sensible"],"families":["scalp_care"],"priority":135,"time":["am","pm"],"scalp":["sensible"]},"8617050702149":{"category":"cabello","role":"cleanser","needs":["graso"],"families":["scalp_care"],"priority":140,"time":["am","pm"],"scalp":["graso"]},"6764896288907":{"category":"cabello","role":"styling","needs":["volumen"],"families":["volume"],"priority":133,"time":["am","pm"]},"6764892684427":{"category":"cabello","role":"styling","needs":["frizz"],"families":["anti-frizz"],"priority":125,"time":["am","pm"],"protocol":"Spray de acabado antihumedad. No sustituye a un protector térmico."},"6764902908043":{"category":"cabello","role":"treatment","needs":["hidratacion"],"families":["hydrating"],"priority":110,"time":["am","pm"]},"7049662201995":{"category":"cabello","role":"scalp","needs":["caida"],"families":["density"],"priority":119,"time":["am","pm"],"protocol":"Cuidado cosmético del cuero cabelludo. La caída repentina, intensa o persistente requiere valoración dermatológica."},"6790625230987":{"category":"cabello","role":"cleanser","needs":["hidratacion"],"families":["hydration"],"priority":114,"time":["am","pm"]},"15251062587717":{"category":"cabello","role":"treatment","needs":["reparacion","mechas"],"families":["bond_repair"],"priority":160,"time":["am","pm"],"singleOnly":true,"protocol":"K18: lavar con champú, NO aplicar acondicionador antes, secar con toalla, repartir la mascarilla sin aclarar y esperar 4 minutos antes de otros productos."},"15251072057669":{"category":"cabello","role":"treatment","needs":["reparacion","mechas"],"families":["bond_repair"],"priority":160,"time":["am","pm"],"singleOnly":true,"protocol":"K18: lavar con champú, NO aplicar acondicionador antes, secar con toalla, repartir la mascarilla sin aclarar y esperar 4 minutos antes de otros productos."},"14947454746949":{"category":"cabello","role":"treatment","needs":["reparacion","mechas"],"families":["bond_repair"],"priority":160,"time":["am","pm"],"singleOnly":true,"protocol":"Epres: preparar el pulverizador según instrucciones, aplicar sobre cabello seco antes de lavar, dejar actuar un mínimo de 10 minutos y después lavar con champú."},"16279560290629":{"category":"cabello","role":"scalp","needs":["caida"],"families":["density","scalp_care"],"priority":160,"time":["am","pm"],"protocol":"Bruma cosmética para el cuidado del cuero cabelludo. No diagnostica ni trata la causa médica de la caída."},"16279740744005":{"category":"cabello","role":"cleanser","needs":["caida"],"families":["density","scalp_care"],"priority":132,"time":["am","pm"]},"16279756177733":{"category":"cabello","role":"treatment","needs":["caida"],"families":["scalp_care"],"priority":108,"time":["am","pm"],"singleOnly":true,"protocol":"Limpiador exfoliante de uso periódico, no sustituye al champú habitual. Evitar ante irritación activa."},"16279892754757":{"category":"cabello","role":"conditioner","needs":["caida","hidratacion"],"families":["scalp_care","hydration"],"priority":120,"time":["am","pm"]},"14804094189893":{"category":"cabello","role":"scalp","needs":["caida"],"families":["density"],"priority":123,"time":["am","pm"],"singleOnly":true,"protocol":"Sistema cosmético capilar: seguir instrucciones específicas; caída persistente o repentina requiere valoración dermatológica."},"9698072789317":{"category":"rostro","role":"toner","needs":["sensibilidad","hidratacion"],"families":["barrier"],"priority":121,"time":["am","pm"]},"7061563539595":{"category":"rostro","role":"toner","needs":["hidratacion","sensibilidad"],"families":["hydrating","barrier"],"priority":123,"time":["am","pm"]},"7070664032395":{"category":"rostro","role":"toner","needs":["luminosidad","hidratacion"],"families":["antioxidant"],"priority":115,"time":["am","pm"]},"6989553762443":{"category":"rostro","role":"toner","needs":["impurezas","manchas","antiedad"],"families":["exfoliation"],"priority":129,"time":["am","pm"],"actives":["aha"],"noBarrier":true,"requiresRetinoidExperience":true,"protocol":"Loción exfoliante P50: comenzar gradualmente según instrucciones. No combinar en la misma noche con retinoides ni otros exfoliantes."},"6990944403595":{"category":"rostro","role":"toner","needs":["antiedad","firmeza","impurezas"],"families":["exfoliation"],"priority":126,"time":["am","pm"],"actives":["aha"],"noBarrier":true,"requiresRetinoidExperience":true,"protocol":"P50V: comenzar gradualmente, evitar barrera alterada y combinar con otros exfoliantes o retinoides la misma noche."},"6766553596043":{"category":"cabello","role":"styling","needs":["brillo","reparacion"],"families":["repair"],"priority":153,"time":["am","pm"],"hairTypes":["normal","grueso"],"protocol":"Aceite de acabado para medios y puntas, evitar raíz y adaptar cantidad al grosor."},"6669203439755":{"category":"cabello","role":"styling","needs":["hidratacion","reparacion","frizz"],"families":["hydration_finish"],"priority":132,"time":["am","pm"],"protocol":"Aceite de acabado: pocas gotas en medios y puntas, especialmente en cabello fino."},"6593242595467":{"category":"cabello","role":"styling","needs":["reparacion","brillo"],"families":["repair"],"priority":138,"time":["am","pm"],"hairTypes":["normal","grueso"],"protocol":"Aceite cosmético para cabello tratado; aplicar en largos, evitando la raíz."},"6547729318027":{"category":"cabello","role":"styling","needs":["brillo","frizz"],"families":["anti-frizz"],"priority":125,"time":["am","pm"],"protocol":"Aceite ligero de acabado, ajustar dosis y aplicar en largos."},"6656763199627":{"category":"cabello","role":"cleanser","needs":["reparacion"],"families":["repair"],"priority":119,"time":["am","pm"]},"6656768770187":{"category":"cabello","role":"conditioner","needs":["volumen"],"families":["volume"],"priority":135,"time":["am","pm"],"hairTypes":["fino"]},"6655037538443":{"category":"cabello","role":"styling","needs":["volumen"],"families":["volume"],"priority":143,"time":["am","pm"],"hairTypes":["fino"]},"6917820645515":{"category":"cabello","role":"treatment","needs":["hidratacion","frizz"],"families":["hydrating"],"priority":126,"time":["am","pm"]},"8641451229509":{"category":"cabello","role":"conditioner","needs":["reparacion"],"families":["repair"],"priority":124,"time":["am","pm"]},"9598371168581":{"category":"cabello","role":"cleanser","needs":["hidratacion","frizz"],"families":["hydration"],"priority":117,"time":["am","pm"]},"9602221670725":{"category":"cabello","role":"cleanser","needs":["hidratacion","brillo"],"families":["hydrating"],"priority":119,"time":["am","pm"]},"9598398923077":{"category":"cabello","role":"conditioner","needs":["hidratacion","frizz"],"families":["hydration"],"priority":119,"time":["am","pm"]},"15653893243205":{"category":"cabello","role":"cleanser","needs":["hidratacion"],"families":["hydrating"],"priority":115,"time":["am","pm"]},"15653926797637":{"category":"cabello","role":"conditioner","needs":["hidratacion"],"families":["hydrating"],"priority":115,"time":["am","pm"]},"8825952502085":{"category":"rostro","role":"serum","needs":["luminosidad","antiedad"],"families":["antioxidant"],"priority":118,"time":["am","pm"]},"8825958170949":{"category":"rostro","role":"serum","needs":["luminosidad","antiedad"],"families":["antioxidant"],"priority":123,"time":["am","pm"]},"8825976914245":{"category":"rostro","role":"serum","needs":["luminosidad","antiedad"],"families":["antioxidant"],"priority":120,"time":["am","pm"]},"9132617466181":{"category":"rostro","role":"cleanser","needs":["impurezas"],"families":["cleansing"],"priority":120,"time":["am","pm"]},"9132650168645":{"category":"rostro","role":"toner","needs":["luminosidad"],"families":["exfoliation"],"priority":121,"time":["am","pm"],"actives":["pha"],"noBarrier":true},"9132672844101":{"category":"rostro","role":"toner","needs":["impurezas"],"families":["blemish"],"priority":115,"time":["am","pm"],"actives":["bha"],"noBarrier":true},"9135375581509":{"category":"rostro","role":"cleanser","needs":["impurezas"],"families":["cleansing"],"priority":129,"time":["am","pm"]},"9130016637253":{"category":"rostro","role":"spf","needs":["antiedad","manchas"],"families":["sun"],"priority":117,"time":["am"]},"16036825366853":{"category":"rostro","role":"serum","needs":["antiedad","luminosidad"],"families":["antioxidant"],"priority":121,"time":["am","pm"]},"15859682148677":{"category":"rostro","role":"serum","needs":["firmeza","antiedad"],"families":["firming"],"priority":132,"time":["am","pm"]},"15930264092997":{"category":"rostro","role":"serum","needs":["antiedad","hidratacion"],"families":["antiage"],"priority":122,"time":["am","pm"]},"15930246660421":{"category":"rostro","role":"moisturizer","needs":["antiedad","firmeza","hidratacion"],"families":["antiage"],"priority":118,"time":["am","pm"]},"15905185431877":{"category":"rostro","role":"moisturizer","needs":["sensibilidad","hidratacion"],"families":["barrier"],"priority":121,"time":["am","pm"]},"15724506579269":{"category":"rostro","role":"moisturizer","needs":["antiedad"],"families":["antiage"],"priority":127,"time":["am","pm"]},"6564105420939":{"category":"cabello","role":"mask","needs":["mechas"],"families":["color"],"priority":120,"time":["am","pm"]},"6564711596171":{"category":"cabello","role":"treatment","needs":["mechas","reparacion"],"families":["repair"],"priority":130,"time":["am","pm"]},"6564715626635":{"category":"cabello","role":"styling","needs":["mechas","brillo"],"families":["color"],"priority":120,"time":["am","pm"]},"6565194563723":{"category":"cabello","role":"treatment","needs":["hidratacion","brillo"],"families":["hydrating"],"priority":134,"time":["am","pm"]},"6567678181515":{"category":"cabello","role":"treatment","needs":["hidratacion","frizz"],"families":["hydration_finish"],"priority":114,"time":["am","pm"]},"6575899246731":{"category":"cabello","role":"styling","needs":["volumen"],"families":["volume"],"priority":130,"time":["am","pm"]},"6593225916555":{"category":"cabello","role":"scalp","needs":["caida"],"families":["density"],"priority":118,"time":["am","pm"],"protocol":"Tratamiento cosmético del cuero cabelludo; ante caída intensa o persistente, consultar con dermatología."},"6762950852747":{"category":"cabello","role":"cleanser","needs":["mechas","reparacion"],"families":["color"],"priority":132,"time":["am","pm"]},"6762955047051":{"category":"cabello","role":"conditioner","needs":["mechas","reparacion"],"families":["color"],"priority":130,"time":["am","pm"]},"6762959798411":{"category":"cabello","role":"cleanser","needs":["hidratacion","brillo"],"families":["hydrating"],"priority":120,"time":["am","pm"]},"6762964058251":{"category":"cabello","role":"conditioner","needs":["hidratacion","brillo"],"families":["hydrating"],"priority":122,"time":["am","pm"]},"6764001951883":{"category":"cabello","role":"cleanser","needs":["volumen"],"families":["volume"],"priority":139,"time":["am","pm"],"hairTypes":["fino","normal"]},"6764008407179":{"category":"cabello","role":"conditioner","needs":["volumen"],"families":["volume"],"priority":137,"time":["am","pm"],"hairTypes":["fino","normal"]},"6764018335883":{"category":"cabello","role":"cleanser","needs":["hidratacion"],"families":["hydrating"],"priority":115,"time":["am","pm"]},"6764021416075":{"category":"cabello","role":"conditioner","needs":["hidratacion"],"families":["hydrating"],"priority":116,"time":["am","pm"]},"6764031017099":{"category":"cabello","role":"treatment","needs":["reparacion","color"],"families":["color_protection","repair"],"priority":117,"time":["am","pm"]},"6764038094987":{"category":"cabello","role":"treatment","needs":["mechas","brillo"],"families":["color"],"priority":120,"time":["am","pm"]},"6764051005579":{"category":"cabello","role":"mask","needs":["hidratacion"],"families":["hydrating"],"priority":123,"time":["am","pm"]},"6764071256203":{"category":"cabello","role":"styling","needs":["hidratacion"],"families":["hydrating"],"priority":113,"time":["am","pm"]},"6764920930443":{"category":"cabello","role":"styling","needs":["reparacion"],"families":["protection"],"priority":122,"time":["am","pm"],"protocol":"Protección cosmética de acabado antes de herramientas térmicas, siguiendo instrucciones."},"6764924469387":{"category":"cabello","role":"styling","needs":["reparacion","frizz"],"families":["protection"],"priority":118,"time":["am","pm"]},"6764928729227":{"category":"cabello","role":"treatment","needs":["hidratacion","frizz"],"families":["hydration_finish"],"priority":121,"time":["am","pm"]},"6764060344459":{"category":"cabello","role":"styling","needs":["volumen"],"families":["volume"],"priority":118,"time":["am","pm"]},"6996208058507":{"category":"rostro","role":"moisturizer","needs":["antiedad","firmeza"],"skinTypes":["normal","seca"],"priority":92,"time":["am","pm"],"families":[]},"6991412134027":{"category":"rostro","role":"moisturizer","needs":["manchas","luminosidad"],"skinTypes":["normal","mixta"],"priority":92,"time":["am","pm"],"families":[]},"6996244562059":{"category":"rostro","role":"moisturizer","needs":["hidratacion","sensibilidad"],"skinTypes":["seca"],"priority":92,"time":["am","pm"],"families":[]},"14808695112005":{"category":"rostro","role":"moisturizer","needs":["hidratacion"],"skinTypes":["seca","normal"],"priority":92,"time":["am","pm"],"families":[]},"7080270463115":{"category":"rostro","role":"moisturizer","needs":["hidratacion","sensibilidad"],"skinTypes":["seca","normal"],"priority":92,"time":["am","pm"],"families":[]},"6996222279819":{"category":"rostro","role":"moisturizer","needs":["antiedad","hidratacion"],"skinTypes":["seca"],"priority":92,"time":["am","pm"],"families":[]},"6996230439051":{"category":"rostro","role":"moisturizer","needs":["sensibilidad","impurezas"],"skinTypes":["mixta","normal"],"priority":92,"time":["am","pm"],"families":[]},"6996213661835":{"category":"rostro","role":"moisturizer","needs":["antiedad","firmeza"],"skinTypes":["seca"],"priority":92,"time":["am","pm"],"families":[]},"9727866667333":{"category":"rostro","role":"moisturizer","needs":["sensibilidad","hidratacion"],"skinTypes":["seca","normal"],"priority":92,"time":["am","pm"],"families":[]},"6996240236683":{"category":"rostro","role":"moisturizer","needs":["antiedad","luminosidad"],"skinTypes":["normal","seca"],"priority":92,"time":["am","pm"],"families":[]},"6991410364555":{"category":"rostro","role":"moisturizer","needs":["luminosidad","hidratacion"],"skinTypes":["normal","mixta"],"priority":92,"time":["am","pm"],"families":[]},"6991535276171":{"category":"rostro","role":"eye","needs":["antiedad","firmeza"],"families":[],"priority":100,"time":["am","pm"],"protocol":"Aplicar una pequeña cantidad en el contorno de ojos siguiendo las instrucciones del fabricante y sin acercar el producto al interior del ojo."},"6991536324747":{"category":"rostro","role":"eye","needs":["sensibilidad","hidratacion"],"families":[],"priority":100,"time":["am","pm"],"protocol":"Aplicar una pequeña cantidad en el contorno de ojos siguiendo las instrucciones del fabricante y sin acercar el producto al interior del ojo."},"6991536783499":{"category":"rostro","role":"eye","needs":["luminosidad","hidratacion"],"families":[],"priority":100,"time":["am","pm"],"protocol":"Aplicar una pequeña cantidad en el contorno de ojos siguiendo las instrucciones del fabricante y sin acercar el producto al interior del ojo."},"7049653485707":{"category":"rostro","role":"eye","needs":["antiedad","firmeza"],"families":[],"priority":100,"time":["am","pm"],"protocol":"Aplicar una pequeña cantidad en el contorno de ojos siguiendo las instrucciones del fabricante y sin acercar el producto al interior del ojo."},"8828506571077":{"category":"rostro","role":"eye","needs":["antiedad","firmeza"],"families":[],"priority":100,"time":["am","pm"],"protocol":"Aplicar una pequeña cantidad en el contorno de ojos siguiendo las instrucciones del fabricante y sin acercar el producto al interior del ojo."},"15724510937413":{"category":"rostro","role":"eye","needs":["antiedad"],"families":[],"priority":100,"time":["am","pm"],"protocol":"Aplicar una pequeña cantidad en el contorno de ojos siguiendo las instrucciones del fabricante y sin acercar el producto al interior del ojo."},"15724519555397":{"category":"rostro","role":"eye","needs":["manchas","luminosidad"],"families":[],"priority":100,"time":["am","pm"],"protocol":"Aplicar una pequeña cantidad en el contorno de ojos siguiendo las instrucciones del fabricante y sin acercar el producto al interior del ojo."},"15739757166917":{"category":"rostro","role":"eye","needs":["firmeza","antiedad"],"families":[],"priority":100,"time":["am","pm"],"protocol":"Aplicar una pequeña cantidad en el contorno de ojos siguiendo las instrucciones del fabricante y sin acercar el producto al interior del ojo."},"8825964527941":{"category":"rostro","role":"eye","needs":["luminosidad","antiedad"],"families":[],"priority":100,"time":["am","pm"],"protocol":"Aplicar una pequeña cantidad en el contorno de ojos siguiendo las instrucciones del fabricante y sin acercar el producto al interior del ojo."},"9130078142789":{"category":"rostro","role":"eye","needs":["antiedad","hidratacion"],"families":["eye"],"priority":100,"time":["am","pm"],"protocol":"Aplicar una pequeña cantidad en el contorno de ojos siguiendo las instrucciones del fabricante y sin acercar el producto al interior del ojo."},"9130027483461":{"category":"rostro","role":"eye","needs":["antiedad","hidratacion"],"families":[],"priority":100,"time":["am","pm"],"protocol":"Aplicar una pequeña cantidad en el contorno de ojos siguiendo las instrucciones del fabricante y sin acercar el producto al interior del ojo."},"7061560164491":{"category":"rostro","role":"cleanser","needs":["hidratacion","sensibilidad"],"families":["cleansing","barrier"],"priority":90,"time":["am","pm"]},"7061958099083":{"category":"rostro","role":"spf","needs":["hidratacion"],"families":["sun"],"priority":90,"time":["am","pm"]},"7061961375883":{"category":"rostro","role":"eye","needs":["hidratacion","sensibilidad"],"families":["eye"],"priority":90,"time":["am","pm"]},"7062535569547":{"category":"rostro","role":"eye","needs":["antiedad","firmeza"],"families":["eye","retinoid"],"priority":90,"time":["pm"],"requiresRetinoidExperience":true,"noPregnancy":true,"noBarrier":true},"7062591570059":{"category":"rostro","role":"eye","needs":["antiedad","hidratacion"],"families":["eye"],"priority":90,"time":["am","pm"]},"7062665003147":{"category":"rostro","role":"cleanser","needs":["sensibilidad","hidratacion"],"families":["cleansing","barrier"],"priority":90,"time":["am","pm"]},"7063212982411":{"category":"rostro","role":"serum","needs":["sensibilidad","hidratacion"],"families":["barrier"],"priority":90,"time":["am","pm"]},"7064069243019":{"category":"rostro","role":"eye","needs":["hidratacion","sensibilidad"],"families":["eye","barrier"],"priority":90,"time":["am","pm"]},"7070662688907":{"category":"rostro","role":"moisturizer","needs":["luminosidad","antiedad"],"families":["brightening","antiage"],"priority":90,"time":["am","pm"]},"7076195762315":{"category":"rostro","role":"moisturizer","needs":["luminosidad","hidratacion"],"families":["hydrating"],"priority":90,"time":["am","pm"]},"7080191230091":{"category":"rostro","role":"serum","needs":["antiedad","firmeza"],"families":["antiage","firming"],"priority":90,"time":["am","pm"]},"7089990828171":{"category":"rostro","role":"cleanser","needs":["impurezas"],"families":["cleansing"],"priority":90,"time":["am","pm"]},"7090021826699":{"category":"rostro","role":"toner","needs":["impurezas","luminosidad"],"families":["exfoliation"],"priority":90,"time":["am","pm"]},"7093749612683":{"category":"rostro","role":"moisturizer","needs":["manchas","luminosidad"],"families":["brightening"],"priority":90,"time":["am","pm"]},"7093773271179":{"category":"rostro","role":"serum","needs":["manchas","luminosidad"],"families":["brightening"],"priority":90,"time":["am","pm"]},"7093779660939":{"category":"rostro","role":"spf","needs":["manchas"],"families":["sun","brightening"],"priority":90,"time":["am","pm"]},"15378271240517":{"category":"rostro","role":"moisturizer","needs":["antiedad","firmeza"],"families":["antiage","firming"],"priority":90,"time":["am","pm"]},"15628628885829":{"category":"rostro","role":"serum","needs":["impurezas","antiedad"],"families":["antiage","blemish"],"priority":90,"time":["am","pm"]},"15871646433605":{"category":"rostro","role":"serum","needs":["antiedad"],"families":["antiage"],"priority":90,"time":["am","pm"]},"6764026691723":{"category":"cabello","role":"cleanser","needs":["impurezas"],"families":["cleansing"],"priority":90,"time":["am","pm"]},"6776060706955":{"category":"cabello","role":"cleanser","needs":["mechas"],"families":["color"],"priority":90,"time":["am","pm"]},"6776072667275":{"category":"cabello","role":"conditioner","needs":["mechas"],"families":["color"],"priority":90,"time":["am","pm"]},"6621284368523":{"category":"cabello","role":"conditioner","needs":["hidratacion"],"families":["hydrating"],"priority":90,"time":["am","pm"]},"6621334831243":{"category":"cabello","role":"conditioner","needs":["hidratacion"],"families":["hydrating"],"priority":90,"time":["am","pm"]},"6621339680907":{"category":"cabello","role":"conditioner","needs":["hidratacion"],"families":["hydrating"],"priority":90,"time":["am","pm"]},"6636306038923":{"category":"cabello","role":"cleanser","needs":["reparacion"],"families":["repair"],"priority":90,"time":["am","pm"]},"6691507503243":{"category":"cabello","role":"cleanser","needs":["brillo","hidratacion"],"families":["hydrating"],"priority":90,"time":["am","pm"]},"6691508846731":{"category":"cabello","role":"conditioner","needs":["brillo","hidratacion"],"families":["hydrating"],"priority":90,"time":["am","pm"]},"6989545898123":{"category":"rostro","role":"cleanser","needs":["hidratacion","luminosidad"],"families":["cleansing"],"priority":86,"time":["am","pm"]},"8825946636613":{"category":"rostro","role":"moisturizer","needs":["luminosidad","antiedad"],"families":["antioxidant"],"priority":86,"time":["am","pm"]},"8827017331013":{"category":"rostro","role":"eye","needs":["antiedad"],"families":["eye"],"priority":86,"time":["pm"],"requiresRetinoidExperience":true,"noPregnancy":true,"noBarrier":true},"8827028504901":{"category":"rostro","role":"eye","needs":["antiedad"],"families":["eye"],"priority":86,"time":["pm"],"requiresRetinoidExperience":true,"noPregnancy":true,"noBarrier":true},"8828524200261":{"category":"rostro","role":"serum","needs":["manchas","luminosidad"],"families":["brightening"],"priority":86,"time":["am","pm"]},"9697863565637":{"category":"rostro","role":"serum","needs":["antiedad","sensibilidad"],"families":["antiage"],"priority":86,"time":["am","pm"]},"15086230176069":{"category":"rostro","role":"serum","needs":["luminosidad","antiedad"],"families":["antioxidant"],"priority":86,"time":["am","pm"]},"7061553512587":{"category":"rostro","role":"cleanser","needs":["manchas","luminosidad"],"families":["cleansing"],"priority":86,"time":["am","pm"]},"7062673653899":{"category":"rostro","role":"toner","needs":["sensibilidad"],"families":["barrier"],"priority":86,"time":["am","pm"]},"7064073011339":{"category":"rostro","role":"moisturizer","needs":["sensibilidad","hidratacion"],"families":["barrier"],"priority":86,"time":["am","pm"]},"8350925062469":{"category":"rostro","role":"eye","needs":["antiedad","firmeza"],"families":["eye"],"priority":86,"time":["am","pm"]},"8563125158213":{"category":"rostro","role":"eye","needs":["luminosidad","antiedad"],"families":["eye"],"priority":86,"time":["am","pm"]},"8624669655365":{"category":"rostro","role":"serum","needs":["firmeza","antiedad"],"families":["firming"],"priority":86,"time":["am","pm"]},"6593237713035":{"category":"cabello","role":"cleanser","needs":["caida"],"families":["scalp"],"priority":86,"time":["am","pm"]},"6621277520011":{"category":"cabello","role":"treatment","needs":["mechas"],"families":["color"],"priority":86,"time":["am","pm"]},"6621281648779":{"category":"cabello","role":"cleanser","needs":["hidratacion"],"families":["hydrating"],"priority":86,"time":["am","pm"]},"6621288104075":{"category":"cabello","role":"mask","needs":["hidratacion"],"families":["hydrating"],"priority":86,"time":["am","pm"]},"6766568669323":{"category":"cabello","role":"treatment","needs":["hidratacion"],"families":["hydrating"],"priority":86,"time":["am","pm"]},"7061558624395":{"category":"rostro","role":"mask","needs":["manchas","luminosidad"],"families":["mask"],"priority":85,"time":["pm"],"noBarrier":false,"protocol":"Uso ocasional, siguiendo la frecuencia y las indicaciones del fabricante."},"8353492500805":{"category":"rostro","role":"mask","needs":["antiedad","hidratacion"],"families":["mask"],"priority":85,"time":["pm"],"noBarrier":false,"protocol":"Uso ocasional, siguiendo la frecuencia y las indicaciones del fabricante."},"16123711816005":{"category":"rostro","role":"mask","needs":["sensibilidad","hidratacion"],"families":["mask"],"priority":85,"time":["pm"],"noBarrier":false,"protocol":"Uso ocasional, siguiendo la frecuencia y las indicaciones del fabricante."},"7090014388363":{"category":"rostro","role":"mask","needs":["impurezas"],"families":["mask"],"priority":85,"time":["pm"],"noBarrier":false,"protocol":"Uso ocasional, siguiendo la frecuencia y las indicaciones del fabricante."},"7062693707915":{"category":"rostro","role":"mask","needs":["luminosidad"],"families":["mask"],"priority":55,"time":["pm"],"noBarrier":true,"protocol":"Uso ocasional, siguiendo la frecuencia y las indicaciones del fabricante.","actives":["aha"],"requiresRetinoidExperience":true},"7061547876491":{"category":"rostro","role":"mask","needs":["luminosidad"],"families":["mask"],"priority":55,"time":["pm"],"noBarrier":true,"protocol":"Uso ocasional, siguiendo la frecuencia y las indicaciones del fabricante.","actives":["aha"],"requiresRetinoidExperience":true},"6537558130827":{"category":"cabello","role":"treatment","needs":["reparacion"],"families":["repair"],"priority":85,"time":["am","pm"]},"6791818412171":{"category":"cabello","role":"treatment","needs":["reparacion"],"families":["repair"],"priority":85,"time":["am","pm"]},"6976876380299":{"category":"cabello","role":"cleanser","needs":["reparacion"],"families":["cleansing"],"priority":85,"time":["am","pm"]},"8734153310533":{"category":"cabello","role":"styling","needs":["volumen"],"families":["volume"],"priority":85,"time":["am","pm"]},"16294777389381":{"category":"cabello","role":"treatment","needs":["reparacion"],"families":["repair"],"priority":85,"time":["am","pm"]},"16294903873861":{"category":"cabello","role":"styling","needs":["frizz","reparacion"],"families":["repair"],"priority":85,"time":["am","pm"]},"16294937231685":{"category":"cabello","role":"styling","needs":["brillo","reparacion"],"families":["repair"],"priority":85,"time":["am","pm"]},"16294970884421":{"category":"cabello","role":"cleanser","needs":["reparacion"],"families":["repair"],"priority":85,"time":["am","pm"]},"16294983696709":{"category":"cabello","role":"cleanser","needs":["volumen"],"families":["volume"],"priority":85,"time":["am","pm"]},"16294998409541":{"category":"cabello","role":"conditioner","needs":["reparacion"],"families":["repair"],"priority":85,"time":["am","pm"]},"16295011942725":{"category":"cabello","role":"conditioner","needs":["volumen"],"families":["volume"],"priority":85,"time":["am","pm"]},"15653948686661":{"category":"cabello","role":"treatment","needs":["reparacion"],"families":["repair"],"priority":85,"time":["am","pm"]},"15653961138501":{"category":"cabello","role":"cleanser","needs":["hidratacion"],"families":["hydrating"],"priority":85,"time":["am","pm"]},"15670346219845":{"category":"cabello","role":"conditioner","needs":["hidratacion","brillo"],"families":["hydrating"],"priority":85,"time":["am","pm"]},"15670347891013":{"category":"cabello","role":"mask","needs":["hidratacion","brillo"],"families":["hydrating"],"priority":85,"time":["am","pm"]},"15970618671429":{"category":"cabello","role":"conditioner","needs":["hidratacion"],"families":["hydrating"],"priority":85,"time":["am","pm"]},"14939822063941":{"category":"rostro","role":"eye","needs":["antiedad","firmeza"],"families":["eye"],"priority":85,"time":["am","pm"]},"14939902837061":{"category":"rostro","role":"moisturizer","needs":["antiedad","hidratacion"],"families":["antiage"],"priority":85,"time":["am","pm"]},"14940951085381":{"category":"rostro","role":"cleanser","needs":["hidratacion"],"families":["cleansing"],"priority":85,"time":["am","pm"]},"14970313998661":{"category":"rostro","role":"moisturizer","needs":["antiedad","hidratacion"],"families":["hydrating"],"priority":85,"time":["pm"]},"14970324484421":{"category":"rostro","role":"eye","needs":["luminosidad","antiedad"],"families":["eye"],"priority":85,"time":["am","pm"]},"14970395001157":{"category":"rostro","role":"eye","needs":["sensibilidad","firmeza"],"families":["eye","barrier"],"priority":85,"time":["am","pm"]},"14970414629189":{"category":"rostro","role":"moisturizer","needs":["hidratacion"],"families":["hydrating"],"priority":85,"time":["am","pm"]},"15595146215749":{"category":"rostro","role":"retinoid","needs":["antiedad"],"families":["renewal"],"priority":85,"time":["pm"],"requiresRetinoidExperience":true,"noPregnancy":true,"noBarrier":true},"15685311168837":{"category":"rostro","role":"serum","needs":["hidratacion"],"families":["hydrating"],"priority":85,"time":["am","pm"]},"16319757582661":{"category":"rostro","role":"moisturizer","needs":["antiedad"],"families":["antiage"],"priority":119,"time":["pm"],"noBarrier":true,"noPregnancy":true,"protocol":"Uso exclusivo de noche: sobre el rostro limpio, después del sérum compatible. No sustituye a la crema de día ni al fotoprotector solar. Evitar recomendar si la barrera cutánea está alterada."}};
const NJ_MAX_BUDGET=()=>S.presupuesto==='none'?Infinity:Math.max(0,Number(S.presupuesto)||0)*100;
const NJ_PREFERRED_FORMAT={
 '8801052295493':'150 ml',
 '8701635821893':'150ml',
 '6996160577675':'30ml',
 '6990941323403':'150ml',
 '6991410921611':'150ml'
};
const njIsBRMilk=raw=>/biologique recherche/i.test(raw.vendor||'') && /^(lait|leche)/i.test((raw.title||'').trim());
const nj150Variant=(raw,available)=>available.find(v=>/\b150\s*ml\b/i.test((v.title||'')+' '+((v.option1||'')+' '+(v.option2||''))))||null;
const njPreferredVariant=(raw,available)=>{
 if(njIsBRMilk(raw))return nj150Variant(raw,available);
 const wanted=NJ_PREFERRED_FORMAT[String(raw.id)];
 return available.find(x=>wanted&&norm(x.title).replace(/\s+/g,'')===norm(wanted).replace(/\s+/g,''))||available[0];
};

const norm=v=>(v||'')
  .toString()
  .toLowerCase()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g,'')
  .replace(/&nbsp;/g,' ')
  .replace(/\s+/g,' ')
  .trim();

const has=(v,...terms)=>{
  const text=norm(v);
  return terms.some(term=>text.includes(norm(term)));
};

const uniq=arr=>[
  ...new Set(
    (arr||[]).filter(Boolean)
  )
];

const esc=v=>String(v||'')
  .replace(/&/g,'&amp;')
  .replace(/</g,'&lt;')
  .replace(/>/g,'&gt;')
  .replace(/"/g,'&quot;')
  .replace(/'/g,'&#039;');

const njProductUrl=p=>'/products/'+encodeURIComponent(p?.handle||'')+
  (p?.variant?.id?'?variant='+encodeURIComponent(p.variant.id):'');

const strip=html=>{
  const div=document.createElement('div');
  div.innerHTML=html||'';
  return div.textContent||div.innerText||'';
};

const cents=p=>
  Math.round(
    Number(
      p?.variant?.price||0
    )*100
  );

const money=c=>
  (
    Number(c||0)/100
  ).toLocaleString(
    'es-ES',
    {
      style:'currency',
      currency:'EUR'
    }
  );

const img=p=>
  p?.images?.[0]?.src||
  p?.featured_image||
  '';

/* =========================================================
   PREGUNTAS
========================================================= */

const Q={

  cabello:[

    {
      k:'p1',
      e:'Tu prioridad',
      q:'¿Qué preocupaciones tienes? Puedes seleccionar varias.',
      multi:true,
      o:[
        'Cabello seco o deshidratado',
        'Cabello dañado o quebradizo',
        'Cabello fino y sin volumen',
        'Encrespamiento / frizz',
        'Cabello teñido',
        'Mechas / decoloración',
        'Caída o pérdida de densidad',
        'Cuero cabelludo graso',
        'Cuero cabelludo sensible'
      ]
    },

    {
      k:'p2',
      e:'Tu cabello',
      q:'¿Cómo describirías tu cabello?',
      o:[
        'Fino',
        'Normal',
        'Grueso'
      ]
    },

    {
      k:'p3',
      e:'Su historial',
      q:'¿Está tratado químicamente?',
      o:[
        'Natural',
        'Teñido',
        'Con mechas',
        'Decolorado',
        'Alisado / tratamiento químico'
      ]
    },

    {
      k:'p4',
      e:'El resultado que buscas',
      q:'¿Qué resultados te gustaría conseguir? Selecciona los que necesites.',
      multi:true,
      o:[
        'Hidratación',
        'Reparación',
        'Más volumen',
        'Control del frizz',
        'Brillo',
        'Proteger el color',
        'Fortalecer'
      ]
    },

    {
      k:'p5',
      e:'Tu cuero cabelludo',
      q:'¿Cómo es tu cuero cabelludo?',
      o:[
        'Normal',
        'Graso',
        'Seco',
        'Sensible',
        'Con tendencia a descamación'
      ]
    }
  ],

  rostro:[

    {
      k:'p1',
      e:'Tu prioridad',
      q:'¿Qué preocupaciones tienes sobre tu piel? Puedes seleccionar varias.',
      multi:true,
      o:[
        'Antiedad / arrugas',
        'Falta de firmeza',
        'Manchas / tono desigual',
        'Deshidratación',
        'Imperfecciones / exceso de grasa',
        'Sensibilidad / barrera alterada',
        'Falta de luminosidad'
      ]
    },

    {
      k:'p2',
      e:'Tu piel',
      q:'¿Cómo describirías tu piel?',
      o:[
        'Seca',
        'Normal',
        'Mixta',
        'Grasa',
        'Sensible'
      ]
    },

    {
      k:'p3',
      e:'Tu tolerancia',
      q:'¿Cómo tolera tu piel activos como ácidos o retinoides?',
      o:[
        'Bien, los utilizo habitualmente',
        'Algo, pero prefiero empezar poco a poco',
        'No / mi piel es muy sensible'
      ]
    },

    {
      k:'p4',
      e:'El resultado que buscas',
      q:'¿Qué te gustaría mejorar? Puedes seleccionar varias.',
      multi:true,
      o:[
        'Corregir',
        'Prevenir',
        'Hidratar',
        'Recuperar luminosidad',
        'Mejorar textura y poros'
      ]
    },

    {
      k:'p5',
      e:'Estado actual de tu piel',
      q:'¿Tienes actualmente irritación, descamación o sensibilidad intensa?',
      o:[
        'Sí',
        'No'
      ]
    },
    {k:'nightCream',e:'Tu ritual de noche',q:'¿Cómo prefieres cuidar tu piel por la noche?',o:['Quiero utilizar la misma crema de día y de noche','Prefiero dos cremas distintas, una para cada momento','Prefiero que Noelia me recomiende lo más adecuado']},
    {k:'eyeChoice',e:'Cuidado del contorno',q:'¿Quieres incorporar un producto específico para el contorno de ojos?',o:['No, prefiero no incluirlo','Sí, quiero cuidar el contorno de ojos']},
    {k:'eyeNeed',e:'Tu prioridad en la mirada',q:'¿Qué te gustaría mejorar principalmente en el contorno de ojos?',o:['Ojeras / aspecto apagado','Bolsas / aspecto cansado','Líneas de expresión / arrugas','Firmeza','Hidratación / confort']}
  ]
};

/* =========================================================
   MARCAS VISIBLES
========================================================= */

const BRAND={

  cabello:[
    ['oribe','Oribe'],
    ['davines','Davines'],
    ['k18','K18'],
    ['epres','Epres'],
    ['qiqi','Qiqi'],
    ['sebastian','Sebastian Professional'],
    ['calecim','CALECIM']
  ],

  rostro:[
    ['natura bisse','Natura Bissé'],
    ['perricone md','Perricone MD'],
    ['medik8','Medik8'],
    ['mesoestetic','Mesoestetic'],
    ['biologique recherche','Biologique Recherche']
  ]
};

const BL=Object.fromEntries(
  [
    ...BRAND.cabello,
    ...BRAND.rostro
  ]
);

const PACK=[
  'pack ',
  ' pack',
  'duo ',
  'dúo ',
  'trio ',
  'trío ',
  'cofre',
  'gift set',
  'travel set',
  'rutina completa',
  'estuche'
];

const BAD=[
  'sun lightening',
  'lightening mist'
];

/* =========================================================
   PRODUCTOS CURADOS
   Cada producto tiene UN SOLO rol estructural.
========================================================= */

const R=[

  /* ===========================
     ROSTRO · LIMPIEZA
  =========================== */

  [
    ['lait vip'],
    'rostro',
    'cleanser',
    ['cleansing'],
    ['antiedad','luminosidad','hidratacion'],
    85
  ],

  [
    ['lait e.v','lait ev'],
    'rostro',
    'cleanser',
    ['cleansing'],
    ['firmeza','hidratacion'],
    90
  ],

  [
    ['lait s.r','lait sr'],
    'rostro',
    'cleanser',
    ['cleansing','blemish'],
    ['impurezas'],
    95
  ],

  [
    ['lait dermo'],
    'rostro',
    'cleanser',
    ['cleansing','barrier'],
    ['sensibilidad'],
    100,
    'low',
    ['am','pm'],
    ['sensible']
  ],

  [
    ['hypoallergenic clean correction gentle cleanser'],
    'rostro',
    'cleanser',
    ['cleansing','barrier'],
    ['sensibilidad'],
    95,
    'low',
    ['am','pm'],
    ['sensible']
  ],

  /* ===========================
     ROSTRO · SÉRUMS
  =========================== */

  [
    ['liquid peptides'],
    'rostro',
    'serum',
    ['peptides','firming'],
    ['antiedad','firmeza'],
    120,
    'low',
    ['am','pm']
  ],

  [
    ['cold plasma plus+ face','cold plasma plus face'],
    'rostro',
    'serum',
    ['antiage','firming'],
    ['antiedad','firmeza'],
    118,
    'low',
    ['am','pm']
  ],

  [
    ['melan tran3x concentrate'],
    'rostro',
    'serum',
    ['pigmentation'],
    ['manchas'],
    125,
    'high',
    ['pm']
  ],

  [
    ['aox ferulic'],
    'rostro',
    'serum',
    ['antioxidant','brightening'],
    ['luminosidad','manchas','antiedad'],
    110,
    'low',
    ['am']
  ],

  [
    ['c-tetra','c tetra'],
    'rostro',
    'serum',
    ['antioxidant','brightening'],
    ['luminosidad','antiedad'],
    112,
    'low',
    ['am']
  ],

  [
    ['hydr8 b5'],
    'rostro',
    'serum',
    ['hydration'],
    ['hidratacion'],
    118,
    'low',
    ['am','pm']
  ],

  [
    ['hyaluronic intensive hydrating serum'],
    'rostro',
    'serum',
    ['hydration'],
    ['hidratacion'],
    116,
    'low',
    ['am','pm']
  ],

  /* BIOLOGIQUE RECHERCHE · SÉRUMS */

  [
    ['complexe iribiol'],
    'rostro',
    'serum',
    ['blemish'],
    ['impurezas'],
    125,
    'low',
    ['am','pm']
  ],

  [
    ['dermopore'],
    'rostro',
    'serum',
    ['blemish'],
    ['impurezas'],
    118,
    'low',
    ['am','pm']
  ],

  [
    ['amniotique vg','amniotique'],
    'rostro',
    'serum',
    ['hydration'],
    ['hidratacion'],
    118,
    'low',
    ['am','pm']
  ],

  [
    ['iso-placenta','iso placenta'],
    'rostro',
    'serum',
    ['recovery','antiage'],
    ['antiedad','sensibilidad'],
    108,
    'low',
    ['am','pm']
  ],

  [
    ['elastine'],
    'rostro',
    'serum',
    ['firming','antiage'],
    ['firmeza','antiedad'],
    115,
    'low',
    ['am','pm']
  ],

  [
    ['collagene natif','collagène natif'],
    'rostro',
    'serum',
    ['firming','antiage'],
    ['firmeza','antiedad'],
    116,
    'low',
    ['am','pm']
  ],

  [
    ['oligo-proteines marines','oligo protéines marines'],
    'rostro',
    'serum',
    ['brightening'],
    ['luminosidad','manchas'],
    108,
    'low',
    ['am','pm']
  ],

  [
    ['calmwise'],
    'rostro',
    'serum',
    ['barrier'],
    ['sensibilidad'],
    120,
    'low',
    ['am','pm'],
    ['sensible']
  ],

  [
    ['exopeptide serum'],
    'rostro',
    'serum',
    ['firming','antiage'],
    ['firmeza','antiedad'],
    116,
    'low',
    ['am','pm']
  ],

  /* ===========================
     ROSTRO · EXFOLIANTES
  =========================== */

  [
    ['p50 pigm'],
    'rostro',
    'exfoliant',
    ['exfoliation','pigmentation'],
    ['manchas','luminosidad'],
    122,
    'high',
    ['pm']
  ],

  [
    ['lotion p50v'],
    'rostro',
    'exfoliant',
    ['exfoliation','antiage'],
    ['antiedad','firmeza'],
    118,
    'high',
    ['pm']
  ],

  [
    ['lotion p50w'],
    'rostro',
    'exfoliant',
    ['exfoliation'],
    ['sensibilidad','antiedad'],
    110,
    'medium',
    ['pm']
  ],

  [
    ['lotion p50'],
    'rostro',
    'exfoliant',
    ['exfoliation','blemish'],
    ['impurezas'],
    122,
    'high',
    ['pm']
  ],

  /* ===========================
     ROSTRO · RETINOIDES
  =========================== */

  [
    ['crystal retinal 3'],
    'rostro',
    'retinoid',
    ['retinoid'],
    ['antiedad','firmeza','impurezas'],
    125,
    'medium',
    ['pm']
  ],

  [
    ['crystal retinal 6'],
    'rostro',
    'retinoid',
    ['retinoid'],
    ['antiedad','firmeza'],
    122,
    'high',
    ['pm']
  ],

  [
    ['skinretin 0,3','skinretin 0.3'],
    'rostro',
    'retinoid',
    ['retinoid'],
    ['antiedad','manchas'],
    120,
    'high',
    ['pm']
  ],

  /* ===========================
     ROSTRO · CREMAS FIRMEZA
  =========================== */

  [
    ['inhibit high definition lifting cream'],
    'rostro',
    'moisturizer',
    ['firming','antiage'],
    ['firmeza','antiedad'],
    140,
    'low',
    ['am','pm']
  ],

  [
    ['essential shock intense elastin cream'],
    'rostro',
    'moisturizer',
    ['firming','antiage'],
    ['firmeza','antiedad'],
    137,
    'low',
    ['am','pm']
  ],

  [
    ['pro-exo collagen cream'],
    'rostro',
    'moisturizer',
    ['firming','antiage'],
    ['firmeza','antiedad'],
    135,
    'low',
    ['am','pm']
  ],

  [
    ['diamond extreme cream'],
    'rostro',
    'moisturizer',
    ['antiage','firming','hydration'],
    ['antiedad','firmeza','hidratacion'],
    132,
    'low',
    ['am','pm']
  ],

  [
    ['neuropeptide firming moisturizer'],
    'rostro',
    'moisturizer',
    ['firming','antiage'],
    ['firmeza','antiedad'],
    142,
    'low',
    ['am','pm']
  ],

  [
    ['face finishing & firming moisturizer'],
    'rostro',
    'moisturizer',
    ['firming','hydration'],
    ['firmeza','antiedad'],
    138,
    'low',
    ['am','pm']
  ],

  [
    ['age element firming cream'],
    'rostro',
    'moisturizer',
    ['firming','antiage'],
    ['firmeza','antiedad'],
    125,
    'low',
    ['am','pm']
  ],

  [
    ['exopeptide cream'],
    'rostro',
    'moisturizer',
    ['firming','antiage'],
    ['firmeza','antiedad'],
    128,
    'low',
    ['am','pm']
  ],

  /* ===========================
     ROSTRO · MANCHAS/LUZ
  =========================== */

  [
    ['melan tran3x gel cream'],
    'rostro',
    'moisturizer',
    ['pigmentation','hydration'],
    ['manchas'],
    130,
    'low',
    ['am','pm']
  ],

  [
    ['age element brightening cream'],
    'rostro',
    'moisturizer',
    ['pigmentation','brightening'],
    ['manchas','luminosidad'],
    118,
    'low',
    ['am','pm']
  ],

  [
    ['c+c vitamin cream'],
    'rostro',
    'moisturizer',
    ['brightening','antioxidant'],
    ['luminosidad','antiedad'],
    125,
    'low',
    ['am','pm']
  ],

  /* ===========================
     ROSTRO · HIDRATACIÓN
  =========================== */

  [
    ['total moisture'],
    'rostro',
    'moisturizer',
    ['hydration'],
    ['hidratacion'],
    125,
    'low',
    ['am','pm']
  ],

  [
    ['hyaluronic intensive moisturizer'],
    'rostro',
    'moisturizer',
    ['hydration'],
    ['hidratacion'],
    122,
    'low',
    ['am','pm']
  ],

  /* ===========================
     ROSTRO · BARRERA
  =========================== */

  [
    ['fast skin repair'],
    'rostro',
    'moisturizer',
    ['barrier','recovery'],
    ['sensibilidad','hidratacion'],
    110,
    'low',
    ['am','pm'],
    ['sensible']
  ],

  [
    ['barrier repair nourishing moisturizer'],
    'rostro',
    'moisturizer',
    ['barrier','hydration'],
    ['sensibilidad','hidratacion'],
    128,
    'low',
    ['am','pm'],
    ['sensible']
  ],

  /* ===========================
     ROSTRO · IMPUREZAS
  =========================== */

  [
    ['stabilizing oil-free'],
    'rostro',
    'moisturizer',
    ['blemish','hydration'],
    ['impurezas'],
    125,
    'low',
    ['am','pm'],
    ['mixta','grasa']
  ],

  /* ===========================
     BIOLOGIQUE RECHERCHE · CREMAS
     BLOQUEADAS COMO CREMA
  =========================== */

  [
    ['creme dermopurifiante','crème dermopurifiante'],
    'rostro',
    'moisturizer',
    ['blemish'],
    ['impurezas'],
    135,
    'low',
    ['am','pm']
  ],

  [
    ['creme elastine','crème elastine'],
    'rostro',
    'moisturizer',
    ['antiage','firming'],
    ['antiedad','firmeza'],
    132,
    'low',
    ['am','pm']
  ],

  [
    ['creme splendide','crème splendide'],
    'rostro',
    'moisturizer',
    ['firming','antiage'],
    ['firmeza','antiedad'],
    138,
    'low',
    ['am','pm']
  ],

  [
    ['pto metamorphique','ptô métamorphique','pto métamorphique'],
    'rostro',
    'moisturizer',
    ['firming','antiage'],
    ['firmeza','antiedad'],
    140,
    'low',
    ['am','pm']
  ],

  [
    ["hydravit's",'hydravit s'],
    'rostro',
    'moisturizer',
    ['hydration'],
    ['hidratacion','luminosidad'],
    130,
    'low',
    ['am','pm']
  ],

  /* ===========================
     ROSTRO · SPF
  =========================== */

  [
    ['melan 130'],
    'rostro',
    'spf',
    ['photoprotection','pigmentation'],
    ['manchas'],
    145,
    'low',
    ['am']
  ],

  [
    ['diamond luminous oil-free spf 50'],
    'rostro',
    'spf',
    ['photoprotection','brightening'],
    ['luminosidad','manchas'],
    132,
    'low',
    ['am']
  ],

  [
    ['water veil spf50','water veil spf 50'],
    'rostro',
    'spf',
    ['photoprotection'],
    ['hidratacion'],
    125,
    'low',
    ['am']
  ],

  /* ===========================
     CABELLO
  =========================== */

  [
    ['rebalancing shampoo'],
    'cabello',
    'cleanser',
    ['scalp_balance'],
    ['graso'],
    140,
    'low',
    ['am','pm'],
    [],
    [],
    ['graso']
  ],

  [
    ['dermo-apaisant','dermo apaisant'],
    'cabello',
    'cleanser',
    ['scalp_soothing'],
    ['sensible'],
    140,
    'low',
    ['am','pm'],
    [],
    [],
    ['sensible']
  ],

  [
    ['energizing shampoo'],
    'cabello',
    'cleanser',
    ['density'],
    ['caida'],
    138
  ],

  [
    ['energizing superactive'],
    'cabello',
    'scalp',
    ['density'],
    ['caida'],
    145
  ],

  [
    ['calecim advanced hair'],
    'cabello',
    'scalp',
    ['density'],
    ['caida'],
    138
  ],

  [
    ['k18 molecular repair'],
    'cabello',
    'treatment',
    ['bond_repair'],
    ['reparacion','mechas'],
    150
  ],

  [
    ['epres bond repair spray'],
    'cabello',
    'treatment',
    ['bond_repair'],
    ['reparacion','mechas'],
    148
  ],

  [
    ['hair alchemy fortifying treatment serum','bond building elixir'],
    'cabello',
    'treatment',
    ['bond_repair','anti_breakage'],
    ['reparacion','mechas'],
    142,
    'low',
    ['am','pm'],
    [],
    ['fino','normal']
  ],

  [
    ['gold lust repair & restore shampoo','gold lust repair restore shampoo'],
    'cabello',
    'cleanser',
    ['repair'],
    ['reparacion','hidratacion'],
    140
  ],

  [
    ['gold lust repair & restore conditioner','gold lust repair restore conditioner'],
    'cabello',
    'conditioner',
    ['repair','conditioning'],
    ['reparacion','hidratacion'],
    140
  ],

  [
    ['gold lust transformative masque'],
    'cabello',
    'mask',
    ['repair'],
    ['reparacion','hidratacion'],
    142
  ],

  [
    ['bright blonde shampoo'],
    'cabello',
    'cleanser',
    ['blonde','color_protection'],
    ['mechas','color'],
    140
  ],

  [
    ['bright blonde conditioner'],
    'cabello',
    'conditioner',
    ['blonde','color_protection'],
    ['mechas','color'],
    140
  ],

  [
    ['heart of glass rich conditioner'],
    'cabello',
    'conditioner',
    ['blonde','conditioning'],
    ['mechas','hidratacion'],
    136
  ],

  [
    ['heart of glass intense treatment'],
    'cabello',
    'treatment',
    ['blonde','repair'],
    ['mechas','reparacion'],
    138
  ],

  [
    ['love smoothing shampoo'],
    'cabello',
    'cleanser',
    ['anti_frizz'],
    ['frizz'],
    142
  ],

  [
    ['love smoothing conditioner'],
    'cabello',
    'conditioner',
    ['anti_frizz','conditioning'],
    ['frizz','hidratacion'],
    142
  ],

  [
    ['love smoothing lightweight milk'],
    'cabello',
    'treatment',
    ['anti_frizz'],
    ['frizz'],
    145,
    'low',
    ['am','pm'],
    [],
    ['fino','normal']
  ],

  [
    ['straight away'],
    'cabello',
    'styling',
    ['anti_frizz','heat_protection'],
    ['frizz'],
    140,
    'low',
    ['am','pm'],
    [],
    ['normal','grueso']
  ],

  [
    ['impermeable','imperméable'],
    'cabello',
    'styling',
    ['humidity_protection'],
    ['frizz'],
    148
  ],

  [
    ['qiqi all out blowout'],
    'cabello',
    'styling',
    ['heat_protection','anti_frizz'],
    ['frizz'],
    132
  ],

  [
    ['shampoo for magnificent volume'],
    'cabello',
    'cleanser',
    ['volume'],
    ['volumen'],
    145,
    'low',
    ['am','pm'],
    [],
    ['fino']
  ],

  [
    ['conditioner for magnificent volume'],
    'cabello',
    'conditioner',
    ['volume','conditioning'],
    ['volumen'],
    145,
    'low',
    ['am','pm'],
    [],
    ['fino']
  ],

  [
    ['maximista thickening spray','maximista'],
    'cabello',
    'styling',
    ['volume'],
    ['volumen'],
    148,
    'low',
    ['am','pm'],
    [],
    ['fino']
  ],

  [
    ['liquid spell'],
    'cabello',
    'treatment',
    ['volume'],
    ['volumen'],
    145,
    'low',
    ['am','pm'],
    [],
    ['fino']
  ],

  [
    ['beautiful color shampoo'],
    'cabello',
    'cleanser',
    ['color_protection'],
    ['color'],
    145
  ],

  [
    ['beautiful color conditioner'],
    'cabello',
    'conditioner',
    ['color_protection','conditioning'],
    ['color'],
    145
  ],

  [
    ['supershine moisturizing cream'],
    'cabello',
    'styling',
    ['hydration_finish','anti_frizz'],
    ['hidratacion','frizz'],
    138,
    'low',
    ['am','pm'],
    [],
    ['normal','grueso']
  ],

  [
    ['supershine light'],
    'cabello',
    'styling',
    ['hydration_finish','anti_frizz'],
    ['hidratacion','frizz'],
    138,
    'low',
    ['am','pm'],
    [],
    ['fino','normal']
  ],

  [
    ['oi all in one milk'],
    'cabello',
    'treatment',
    ['hydration','detangling'],
    ['hidratacion'],
    132
  ]
];

/* =========================================================
   MARCAS
========================================================= */

function vendorKey(value){

  const text=norm(value);

  if(has(text,'natura bisse','natura bissé'))
    return'natura bisse';

  if(has(text,'perricone'))
    return'perricone md';

  if(has(text,'biologique'))
    return'biologique recherche';

  if(has(text,'mesoestetic'))
    return'mesoestetic';

  if(has(text,'medik8'))
    return'medik8';

  if(has(text,'comfort zone'))
    return'comfort zone';

  if(has(text,'oribe'))
    return'oribe';

  if(has(text,'davines'))
    return'davines';

  if(has(text,'k18'))
    return'k18';

  if(has(text,'epres'))
    return'epres';

  if(has(text,'qiqi'))
    return'qiqi';

  if(has(text,'calecim'))
    return'calecim';

  return text;
}

/* =========================================================
   CATEGORÍA
========================================================= */

function inferCategory(text){

  const hair=[
    'hair',
    'cabello',
    'shampoo',
    'champu',
    'conditioner',
    'acondicionador',
    'masque',
    'mask',
    'scalp',
    'mousse'
  ]
    .filter(x=>has(text,x))
    .length;

  const face=[
    'skin',
    'facial',
    'rostro',
    'serum',
    'sérum',
    'cream',
    'crema',
    'retinal',
    'retinol',
    'spf',
    'lotion',
    'lait',
    'moisturizer',
    'cleanser'
  ]
    .filter(x=>has(text,x))
    .length;

  return hair>face
    ?'cabello'
    :face>hair
      ?'rostro'
      :'';
}

/* =========================================================
   ROL DURO POR TÍTULO
========================================================= */

function hardRole(
  title,
  category,
  vendor
){

  const text=norm(title);

  /*
   * BIOLOGIQUE RECHERCHE
   * Lógica propia.
   *
   * Una crema JAMÁS puede
   * convertirse en sérum.
   */

  if(
    vendor===
    'biologique recherche'
  ){

    if(
      has(
        text,
        'lait '
      )
    )
      return'cleanser';

    if(
      has(
        text,
        'lotion p50'
      )
    )
      return'exfoliant';

    if(
      has(
        text,
        'creme ',
        'crème ',
        'cream'
      )
    )
      return'moisturizer';

    if(
      has(
        text,
        'serum ',
        'sérum ',
        'complexe ',
        'amniotique',
        'dermopore',
        'iso-placenta',
        'iso placenta',
        'elastine',
        'collagene',
        'collagène',
        'oligo-proteines',
        'oligo protéines'
      )
    )
      return'serum';
  }

  if(
    category===
    'rostro'
  ){

    if(
      has(
        text,
        'spf',
        'sunscreen',
        'protector solar',
        'fotoprotector'
      )
    )
      return'spf';

    if(
      has(
        text,
        'retinal',
        'retinol',
        'skinretin'
      )
    )
      return'retinoid';

    if(
      has(
        text,
        'lotion p50',
        'micropeel'
      )
    )
      return'exfoliant';

    if(
      has(
        text,
        'cleanser',
        'limpiador',
        'lait '
      )
    )
      return'cleanser';

    if(
      has(
        text,
        'serum',
        'sérum',
        'concentrate',
        'concentrado'
      )
    )
      return'serum';

    if(
      has(
        text,
        'cream',
        'crema',
        'moisturizer',
        'moisturiser'
      )
    )
      return'moisturizer';
  }

  if(
    category===
    'cabello'
  ){

    if(
      has(
        text,
        'shampoo',
        'champu',
        'champú'
      )
    )
      return'cleanser';

    if(
      has(
        text,
        'conditioner',
        'acondicionador'
      )
    )
      return'conditioner';

    if(
      has(
        text,
        'mask',
        'masque',
        'mascarilla'
      )
    )
      return'mask';

    if(
      has(
        text,
        'superactive',
        'scalp serum',
        'hair system'
      )
    )
      return'scalp';

    if(
      has(
        text,
        'spray',
        'mousse',
        'styling',
        'blowout',
        'maximista',
        'impermeable',
        'imperméable',
        'supershine'
      )
    )
      return'styling';
  }

  return'';
}

/* =========================================================
   NECESIDADES SEMÁNTICAS
========================================================= */

function semantic(product){

  const text=
    product.semantic;

  if(
    has(
      text,
      'hydrate',
      'hydration',
      'moisture',
      'hidrat',
      'nourish'
    )
  )
    product.needs.push(
      'hidratacion'
    );

  if(
    has(
      text,
      'repair',
      'bond',
      'damage',
      'repara',
      'breakage',
      'rotura'
    )
  )
    product.needs.push(
      'reparacion'
    );

  if(
    has(
      text,
      'volume',
      'volu',
      'volumen',
      'thickening'
    )
  )
    product.needs.push(
      'volumen'
    );

  if(
    has(
      text,
      'frizz',
      'smoothing',
      'anti-humidity',
      'antihumedad',
      'smooth'
    )
  )
    product.needs.push(
      'frizz'
    );

  if(
    has(
      text,
      'color protection',
      'color safe',
      'beautiful color',
      'color treated'
    )
  )
    product.needs.push(
      'color'
    );

  if(
    has(
      text,
      'blonde',
      'bleach',
      'mechas',
      'decolor'
    )
  )
    product.needs.push(
      'mechas'
    );

  if(
    has(
      text,
      'energizing',
      'density',
      'densidad',
      'hair loss',
      'caida',
      'caída'
    )
  )
    product.needs.push(
      'caida'
    );

  if(
    has(
      text,
      'anti-age',
      'antiage',
      'wrinkle',
      'arruga',
      'peptide',
      'retinal',
      'retinol'
    )
  )
    product.needs.push(
      'antiedad'
    );

  if(
    has(
      text,
      'firming',
      'firmness',
      'firmeza',
      'lifting',
      'elastin',
      'collagen'
    )
  )
    product.needs.push(
      'firmeza'
    );

  if(
    has(
      text,
      'pigment',
      'melan',
      'tranex',
      'mancha',
      'brightening'
    )
  )
    product.needs.push(
      'manchas'
    );

  if(
    has(
      text,
      'acne',
      'blemish',
      'imperfection',
      'iribiol',
      'oil-free',
      'sebum'
    )
  )
    product.needs.push(
      'impurezas'
    );

  if(
    has(
      text,
      'calm',
      'sensitive',
      'barrier',
      'dermo'
    )
  )
    product.needs.push(
      'sensibilidad'
    );

  if(
    has(
      text,
      'glow',
      'radiance',
      'luminos',
      'vitamin c',
      'vitamina c'
    )
  )
    product.needs.push(
      'luminosidad'
    );

  if(
    has(
      text,
      'retinal',
      'retinaldehyde'
    )
  )
    product.actives.push(
      'retinal'
    );

  if(
    has(
      text,
      'retinol',
      'retinoid'
    )
  )
    product.actives.push(
      'retinol'
    );

  if(
    has(
      text,
      'glycolic acid',
      'lactic acid',
      'mandelic acid',
      'aha'
    )
  )
    product.actives.push(
      'aha'
    );

  if(
    has(
      text,
      'salicylic acid',
      'bha'
    )
  )
    product.actives.push(
      'bha'
    );

  if(
    has(
      text,
      'gluconolactone',
      'pha'
    )
  )
    product.actives.push(
      'pha'
    );

  if(
    has(
      text,
      'vitamin c',
      'vitamina c',
      'ascorbic'
    )
  )
    product.actives.push(
      'vitamina_c'
    );

  if(
    has(
      text,
      'tranexamic',
      'tranexamico',
      'tranexámico'
    )
  )
    product.actives.push(
      'tranexamico'
    );

  product.needs=
    uniq(
      product.needs
    );

  product.actives=
    uniq(
      product.actives
    );
}

/* =========================================================
   REGLA CURADA
========================================================= */

function curated(product){

  const matches=
    R
      .filter(
        rule=>
          rule[0]
            .some(
              term=>
                has(
                  product.semantic,
                  term
                )
            )
      )
      .sort(
        (a,b)=>
          Math.max(
            ...b[0]
              .map(
                x=>
                  norm(x)
                    .length
              )
          )
          -
          Math.max(
            ...a[0]
              .map(
                x=>
                  norm(x)
                    .length
              )
          )
      );

  if(
    !matches.length
  )
    return;

  const rule=
    matches[0];

  product.curated=
    true;

  product.category=
    rule[1];

  product.primaryRole=
    rule[2];

  product.roles=[
    rule[2]
  ];

  product.families=
    rule[3].slice();

  product.needs=
    uniq(
      [
        ...product.needs,
        ...rule[4]
      ]
    );

  product.priority=
    rule[5]||0;

  product.intensity=
    rule[6]||
    'low';

  product.time=
    rule[7]||
    [
      'am',
      'pm'
    ];

  product.skinTypes=
    rule[8]||
    [];

  product.hairTypes=
    rule[9]||
    [];

  product.scalp=
    rule[10]||
    [];
}

/* =========================================================
   NORMALIZACIÓN
========================================================= */

/* Filtro conservador para nuevas referencias: solo tipología explícita,
   categorías cosméticas habituales y sin aparatos, packs ni claims clínicos. */
function njCatalogRule(raw){
 const text=norm([raw.title,raw.product_type].join(' '));
 const name=norm(raw.title||'');
 const vendor=norm(raw.vendor||'');
 const blacklist=/pack|cofre|set de|kit |estuche|regalo|navidad|duo|bundle|muestra|sample|toalla|cepillo|plancha|secador|tenacilla|ghd |boquilla|dosificador|recambio|corpor|body|piernas|manos|pies|labios|lip |ojos|eye |contorno|pestanas|cejas|mascara de pestanas|maquillaje|colonia|perfume|bronceador|esmalte|bano|ducha|depil|tratamiento nj|servicio|sesion|ampolla iny|microneedling|peeling profesional|cosmelan 1|pigment control profesional/;
 if(blacklist.test(text))return null;
 const hairBrands=/oribe|davines|sebastian|olaplex|k18|epres|sweet professional|qiqi|wella|redken|icon |iconic|kerastase|living proof|miriam quevedo|calecim|moroccanoil|color wow|schwarzkopf|nioxin/;
 const faceBrands=/medik8|mesoestetic|natura bisse|biologique recherche|perricone|is clinical|endocare|sesderma|skinceuticals|babor|valmont|calecim/;
 const face=/facial|rostro|piel|skin care|skincare|serum|crema|cleanser|cleansing|toner|tonico|lotion p50|protector solar|spf ?[345]|sunscreen|antiedad|hidratante facial|face /;
 const hair=/cabello|capilar|pelo|hair|champu|shampoo|acondicionador|conditioner|mascarilla|hair mask|styling|spray de|aceite|oil/;
 let category,role,needs=[],families=[],time=['am','pm'],priority=83,extra={};
 if(hairBrands.test(vendor) && hair.test(text) && !/facial|rostro|piel facial/.test(text)){
   category='cabello';
   if(/champu|shampoo/.test(name))role='cleanser';
   else if(/acondicionador|conditioner/.test(name))role='conditioner';
   else if(/mascarilla|hair mask|masque/.test(name))role='mask';
   else if(/scalp|cuero cabelludo|anticaida|anticaida|density|densidad/.test(name))role='scalp';
   else if(/serum|tratamiento|treatment|leave.in|milk|primer|crema capilar/.test(name))role='treatment';
   else if(/spray|hairspray|mousse|aceite| oil|styling|gel|wax|pomada/.test(name))role='styling';
   if(!role)return null;
   if(/volumen|volume|volupt|magnificent|thicken|densifying/.test(text))needs.push('volumen');
   if(/repair|repar|penetraitt|bond|strength|fortalec|damage|danad|quebrad|hair alchemy/.test(text))needs.push('reparacion');
   if(/hydrat|hidrat|nourish|nutri|moisture|momo|oi |supershine|soft/.test(text))needs.push('hidratacion');
   if(/frizz|smooth|alisad|antihum|humidity|love smoothing/.test(text))needs.push('frizz');
   if(/color|colou|minu|beautiful color/.test(text))needs.push('color');
   if(/blond|rubio|mecha|purple|violet|heart of glass/.test(text))needs.push('mechas');
   if(/caida|densidad|density|energizing|scalp activat/.test(text))needs.push('caida');
   if(/graso|oil control|sebo/.test(text))needs.push('graso');
   if(/sensible|soothing|calming scalp/.test(text))needs.push('sensible');
   if(!needs.length)return null;
   if(role==='scalp'&&!needs.some(x=>['caida','graso','sensible'].includes(x)))return null;
   if(/fino|fine hair|thin hair/.test(text))extra.hairTypes=['fino'];
 }else if(faceBrands.test(vendor) && face.test(text)){
   category='rostro';
   if(/protector solar|spf ?[345]|sunscreen|sun protection/.test(name)){role='spf';time=['am'];}
   else if(/limpiad|cleanser|cleansing|gel limpiador|espuma limpiadora|lait |micellar/.test(name))role='cleanser';
   else if(/locion|lotion p50|tonico|toner|essence/.test(name))role='toner';
   else if(/serum|serum|concentrate|ampoule/.test(name))role='serum';
   else if(/crema|cream|moisturiz|emulsion/.test(name))role='moisturizer';
   if(!role)return null;
   if(/mancha|pigment|brighten|melan|lumino/.test(text))needs.push('manchas','luminosidad');
   if(/firm|lift|reafirm|elastic/.test(text))needs.push('firmeza','antiedad');
   if(/wrinkl|retinol|retinal|retino|age|antiedad|anti.age/.test(text))needs.push('antiedad');
   if(/hydrat|hidrat|moisture|nourish|nutri|hyaluron|b5|colostrum/.test(text))needs.push('hidratacion');
   if(/sensible|sensitive|calm|sooth|barrier|recovery|tolerance/.test(text))needs.push('sensibilidad');
   if(/blemish|purif|sebo|acne|imperfec|poros|pore/.test(text))needs.push('impurezas');
   if(/glow|radiance|luminos|vitamin c|antioxidant|tetra/.test(text))needs.push('luminosidad');
   if(role==='spf')needs=['manchas','antiedad','firmeza','impurezas','hidratacion','sensibilidad','luminosidad'];
   if(role==='cleanser'&&!needs.length)needs=['hidratacion','antiedad','firmeza','luminosidad'];
   if(role==='toner'&&!needs.length)needs=['hidratacion'];
   if(!needs.length)return null;
   if(/p50|glycol|aha|bha|retinol|retinal|retinoate|trr|sleep glycolic|press & clear|peeling|acid/.test(name))return null;
   if(role==='moisturizer'&&/spf ?[345]/.test(name))return null;
 }else return null;
 const cleanNeeds=[...new Set(needs)];
 return {category,role,needs:cleanNeeds,families,priority,time,...extra,autoClassified:true};
}

function normalizeProduct(
  raw
){

  const NJ_RULE=NJ_VERIFIED[String(raw.id)]||njCatalogRule(raw);
  if(!NJ_RULE) return null;
  if(njIsBRMilk(raw) && !nj150Variant(raw,(raw.variants||[]).filter(v=>v.available!==false)))return null;

  const variants=
    (
      raw.variants||
      []
    )
      .filter(
        variant=>
          variant.available
          !==
          false
      );

  if(
    !variants.length
  )
    return null;

  const tags=
    Array.isArray(
      raw.tags
    )
      ?raw.tags
      :String(
          raw.tags||
          ''
        )
          .split(',')
          .map(
            x=>x.trim()
          )
          .filter(Boolean);

  const structural=
    norm(
      [
        raw.title,
        raw.product_type,
        tags.join(' ')
      ]
        .join(' ')
    );

  const semanticText=
    norm(
      [
        raw.title,
        raw.vendor,
        raw.product_type,
        tags.join(' '),
        strip(
          raw.body_html
        )
      ]
        .join(' ')
    );

  const product={

    id:
      raw.id,

    title:
      raw.title||
      '',

    handle:
      raw.handle||
      '',

    vendor:
      raw.vendor||
      '',

    vendorKey:
      vendorKey(
        raw.vendor||
        ''
      ),

    productType:
      raw.product_type||
      '',

    tags,

    structural,

    semantic:
      semanticText,

    images:
      raw.images||
      [],

    featured_image:
      raw.images?.[0]?.src||
      '',

    variant:
      njPreferredVariant(raw,variants),

    category:
      inferCategory(
        structural
      ),

    primaryRole:
      '',

    roles:
      [],

    families:
      [],

    needs:
      [],

    actives:
      [],

    hairTypes:
      [],

    skinTypes:
      [],

    scalp:
      [],

    time:[
      'am',
      'pm'
    ],

    intensity:
      'low',

    priority:
      0,

    curated:
      false,

    excluded:
      false,

    isPack:
      false
  };

  semantic(
    product
  );

  curated(
    product
  );

  if(
    !product.primaryRole
  ){

    const role=
      hardRole(
        product.title,
        product.category,
        product.vendorKey
      );

    if(role){

      product.primaryRole=
        role;

      product.roles=[
        role
      ];
    }
  }

  product.isPack=
    PACK
      .some(
        term=>
          has(
            product.structural,
            term
          )
      );

  product.excluded=
    BAD
      .some(
        term=>
          has(
            product.semantic,
            term
          )
      );

  /* Identidad y papel validados por ID: jamás por título o descripción. */
  product.category=NJ_RULE.category;
  product.primaryRole=NJ_RULE.role;
  product.roles=[NJ_RULE.role];
  product.families=[...(NJ_RULE.families||[])];
  product.needs=[...(NJ_RULE.needs||[])];
  product.time=[...(NJ_RULE.time||['am','pm'])];
  product.priority=NJ_RULE.priority||0;
  product.intensity='low';
  product.actives=[...(NJ_RULE.actives||[])];
  product.skinTypes=[...(NJ_RULE.skinTypes||[])];
  product.hairTypes=[...(NJ_RULE.hairTypes||[])];
  product.scalp=[...(NJ_RULE.scalp||[])];
  product.curated=true;
  product.isPack=false;
  product.excluded=false;
  product.njAuthorized=true;
  product.njVerified=!!NJ_VERIFIED[String(raw.id)];
  product.njRule=NJ_RULE;
  return product;
}

/* =========================================================
   CATÁLOGO
========================================================= */

  // Davines professional litre sizes are sold by direct link only.
  const njPrivateDavinesLiter = p => {
    const variants = Array.isArray(p?.variants) ? p.variants : (p?.variants?.nodes || []);
    const text = [p?.title, p?.handle, ...variants.map(v => v?.title || '')]
      .join(' ').replace(/[-_]/g, ' ');
    return /davines/i.test(String(p?.vendor || '') + ' ' + text) &&
      /(?:^|[^\d])(?:1\s*(?:l|litros?)\b|1[.,]000\s*ml\b|1000\s*ml\b|litros?\b)/i.test(text);
  };

async function fetchCatalog(){

  if(CATALOG)
    return CATALOG;

  try{

    const cached=
      sessionStorage
        .getItem(
          'nj_catalog_v163_meso_night_verified'
        );

    if(cached){

      const parsed=
        JSON.parse(
          cached
        );

      if(
        parsed?.timestamp
        &&
        Date.now()
        -
        parsed.timestamp
        <
        900000
        &&
        Array.isArray(
          parsed.products
        )
      ){

        CATALOG=
          parsed.products.filter(p => !njPrivateDavinesLiter(p));

        return CATALOG;
      }
    }

  }catch(e){}

  const all=[];

  for(
    let page=1;
    page<=20;
    page++
  ){

    try{

      const response=
        await fetch(
          `/products.json?limit=250&page=${page}`
        );

      if(
        !response.ok
      )
        break;

      const data=
        await response
          .json();

      const products=
        data?.products||
        [];

      if(
        !products.length
      )
        break;

      all.push(
        ...products
      );

      if(
        products.length
        <
        250
      )
        break;

    }catch(e){

      break;
    }
  }

  CATALOG=
    all
      .filter(p => !njPrivateDavinesLiter(p))
      .map(
        normalizeProduct
      )
      .filter(Boolean);

  try{

    sessionStorage
      .setItem(
        'nj_catalog_v163_meso_night_verified',
        JSON.stringify(
          {
            timestamp:
              Date.now(),

            products:
              CATALOG
          }
        )
      );

  }catch(e){}

  return CATALOG;
}

/* =========================================================
   CONTEXTO EXTRA
========================================================= */

function extra(){

  const text=
    norm(
      S.extra
    );

  return{

    retinoid:
      has(
        text,
        'retinol',
        'retinal',
        'tretinoina',
        'retinoide'
      ),

    acids:
      has(
        text,
        'acido',
        'ácido',
        'glicolico',
        'salicilico',
        'aha',
        'bha',
        'p50'
      ),

    dermatologist:
      has(
        text,
        'dermatologo',
        'tratamiento dermatologico',
        'medicacion',
        'isotretinoina'
      ),

    pregnancy:
      has(
        text,
        'embarazo',
        'embarazada',
        'lactancia'
      ),

    swimming:
      has(
        text,
        'natacion',
        'piscina',
        'cloro'
      ),

    heat:
      has(
        text,
        'plancha',
        'secador',
        'tenacilla',
        'calor'
      )
  };
}

/* =========================================================
   PERFIL CABELLO
========================================================= */

function hairProfile(){

  const scores={
    hidratacion:0,
    reparacion:0,
    volumen:0,
    frizz:0,
    color:0,
    mechas:0,
    caida:0
  };

  if(
    has(
      S.p1,
      'seco',
      'deshidratado'
    )
  )
    scores.hidratacion+=
      50;

  if(
    has(
      S.p1,
      'dañado',
      'quebradizo'
    )
  )
    scores.reparacion+=
      50;

  if(
    has(
      S.p1,
      'fino',
      'volumen'
    )
  )
    scores.volumen+=
      50;

  if(
    has(
      S.p1,
      'frizz',
      'encrespamiento'
    )
  )
    scores.frizz+=
      50;

  if(
    has(
      S.p1,
      'teñido'
    )
  )
    scores.color+=
      50;

  if(
    has(
      S.p1,
      'mechas',
      'decoloración'
    )
  )
    scores.mechas+=
      50;

  if(
    has(
      S.p1,
      'caída',
      'densidad'
    )
  )
    scores.caida+=
      50;

  if(
    has(
      S.p2,
      'fino'
    )
  )
    scores.volumen+=
      12;

  if(
    has(
      S.p3,
      'teñido'
    )
  ){
    scores.color+=
      22;

    scores.reparacion+=
      8;
  }

  if(
    has(
      S.p3,
      'mechas'
    )
  ){
    scores.mechas+=
      28;

    scores.reparacion+=
      22;
  }

  if(
    has(
      S.p3,
      'decolorado'
    )
  ){
    scores.mechas+=
      32;

    scores.reparacion+=
      32;
  }

  if(
    has(
      S.p3,
      'alisado'
    )
  )
    scores.reparacion+=
      28;

  if(
    has(
      S.p4,
      'hidratación'
    )
  )
    scores.hidratacion+=
      18;

  if(
    has(
      S.p4,
      'reparación',
      'fortalecer'
    )
  )
    scores.reparacion+=
      18;

  if(
    has(
      S.p4,
      'volumen'
    )
  )
    scores.volumen+=
      18;

  if(
    has(
      S.p4,
      'frizz'
    )
  )
    scores.frizz+=
      18;

  if(
    has(
      S.p4,
      'color'
    )
  )
    scores.color+=
      18;

  const context=
    extra();

  if(
    context.swimming
  ){
    scores.reparacion+=
      12;

    scores.hidratacion+=
      10;
  }

  if(
    context.heat
  )
    scores.reparacion+=
      10;

  const sorted=
    Object.entries(
      scores
    )
      .sort(
        (a,b)=>
          b[1]-a[1]
      );

  return{

    needs:njSelectedNeeds('cabello'),

    category:
      'cabello',

    principal:
      sorted[0][0],

    secundaria:
      sorted[1][1]>=22
        ?sorted[1][0]
        :null,

    hairType:
      has(
        S.p2,
        'fino'
      )
        ?'fino'
        :has(
            S.p2,
            'grueso'
          )
          ?'grueso'
          :'normal',

    scalp:
      has(
        S.p5,
        'graso'
      )
        ?'graso'
        :has(
            S.p5,
            'sensible',
            'descamación'
          )
          ?'sensible'
          :has(
              S.p5,
              'seco'
            )
            ?'seco'
            :'normal',

    highlights:
      has(
        S.p3,
        'mechas',
        'decolorado'
      ),

    extra:
      context
  };
}

/* =========================================================
   PERFIL ROSTRO
========================================================= */

function faceProfile(){

  const context=
    extra();

  const barrier=
    S.p5==='Sí'
    ||
    has(
      S.p1,
      'sensibilidad',
      'barrera'
    );

  const tolerance=
    has(
      S.p3,
      'habitualmente'
    )
      ?'high'
      :has(
          S.p3,
          'poco a poco'
        )
        ?'medium'
        :'low';

  const skinType=
    has(
      S.p2,
      'seca'
    )
      ?'seca'
      :has(
          S.p2,
          'mixta'
        )
        ?'mixta'
        :has(
            S.p2,
            'grasa'
          )
          ?'grasa'
          :has(
              S.p2,
              'sensible'
            )
            ?'sensible'
            :'normal';

  if(barrier){

    return{

      needs:njSelectedNeeds('rostro'),

      category:
        'rostro',

      principal:
        'sensibilidad',

      secundaria:
        null,

      barrier:
        true,

      tolerance,

      skinType,

      extra:
        context
    };
  }

  const scores={
    antiedad:0,
    firmeza:0,
    manchas:0,
    hidratacion:0,
    impurezas:0,
    luminosidad:0
  };

  if(
    has(
      S.p1,
      'antiedad',
      'arrugas'
    )
  )
    scores.antiedad+=
      50;

  if(
    has(
      S.p1,
      'firmeza'
    )
  )
    scores.firmeza+=
      50;

  if(
    has(
      S.p1,
      'manchas'
    )
  )
    scores.manchas+=
      50;

  if(
    has(
      S.p1,
      'deshidratación'
    )
  )
    scores.hidratacion+=
      50;

  if(
    has(
      S.p1,
      'imperfecciones',
      'grasa'
    )
  )
    scores.impurezas+=
      50;

  if(
    has(
      S.p1,
      'luminosidad'
    )
  )
    scores.luminosidad+=
      50;

  if(
    skinType===
    'seca'
  )
    scores.hidratacion+=
      14;

  if(
    skinType===
    'grasa'
  )
    scores.impurezas+=
      16;

  if(
    skinType===
    'mixta'
  )
    scores.impurezas+=
      8;

  if(
    has(
      S.p4,
      'prevenir'
    )
  )
    scores.antiedad+=
      12;

  if(
    has(
      S.p4,
      'hidratar'
    )
  )
    scores.hidratacion+=
      16;

  if(
    has(
      S.p4,
      'luminosidad'
    )
  )
    scores.luminosidad+=
      18;

  if(
    has(
      S.p4,
      'textura',
      'poros'
    )
  )
    scores.impurezas+=
      18;

  const sorted=
    Object.entries(
      scores
    )
      .sort(
        (a,b)=>
          b[1]-a[1]
      );

  return{

    needs:njSelectedNeeds('rostro'),

    category:
      'rostro',

    principal:
      sorted[0][0],

    secundaria:
      sorted[1][1]>=22
        ?sorted[1][0]
        :null,

    barrier:
      false,

    tolerance,

    skinType,

    extra:
      context
  };
}

const profile=()=>
  S.categoria===
  'cabello'
    ?hairProfile()
    :faceProfile();

/* =========================================================
   COMPATIBILIDAD
========================================================= */

const isRet=product=>
  product?.primaryRole===
  'retinoid'
  ||
  product?.actives
    ?.some(
      active=>
        [
          'retinal',
          'retinol',
          'retinoid'
        ]
          .includes(
            active
          )
    );

const acids=product=>
  product?.actives
    ?.some(
      active=>
        [
          'aha',
          'bha'
        ]
          .includes(
            active
          )
    );

function compatible(
  product,
  selected,
  profile,
  moment
){

  if(
    !product.time
      .includes(
        moment
      )
  )
    return false;

  if(
    profile.barrier
    &&
    (
      isRet(product)
      ||
      acids(product)
      ||
      product.intensity===
      'high'
    )
  )
    return false;

  if(
    profile.tolerance===
    'low'
    &&
    (
      isRet(product)
      ||
      product.intensity===
      'high'
    )
  )
    return false;

  if(
    profile.extra?.retinoid
    &&
    isRet(product)
  )
    return false;

  if(
    profile.extra?.acids
    &&
    acids(product)
  )
    return false;

  if(
    (
      profile.extra?.pregnancy
      ||
      profile.extra?.dermatologist
    )
    &&
    isRet(product)
  )
    return false;

  for(
    const existing
    of selected
  ){

    if(
      (
        isRet(product)
        &&
        acids(existing)
      )
      ||
      (
        acids(product)
        &&
        isRet(existing)
      )
      ||
      (
        acids(product)
        &&
        acids(existing)
      )
    )
      return false;
  }

  return true;
}

/* =========================================================
   FAMILIAS DE NECESIDAD
========================================================= */

const FACE_F={

  antiedad:[
    'antiage',
    'peptides',
    'firming'
  ],

  firmeza:[
    'firming',
    'peptides',
    'antiage'
  ],

  manchas:[
    'pigmentation',
    'brightening'
  ],

  hidratacion:[
    'hydration'
  ],

  impurezas:[
    'blemish'
  ],

  sensibilidad:[
    'barrier',
    'recovery'
  ],

  luminosidad:[
    'brightening',
    'antioxidant'
  ]
};

const HAIR_F={

  hidratacion:[
    'hydration',
    'hydration_finish'
  ],

  reparacion:[
    'bond_repair',
    'repair',
    'anti_breakage'
  ],

  volumen:[
    'volume'
  ],

  frizz:[
    'anti_frizz',
    'humidity_protection',
    'heat_protection'
  ],

  color:[
    'color_protection'
  ],

  mechas:[
    'blonde',
    'bond_repair',
    'repair'
  ],

  caida:[
    'density'
  ]
};

/* Necesidades simultáneas identificadas, sin confundir grasa de raíz con sequedad de largos. */
function njSelectedNeeds(category){
  const raw=(S.p1||'')+' | '+(S.p4||'');
  const dictionary=category==='cabello'
    ?[['hidratacion',['seco','deshidratado','hidratación']],['reparacion',['dañado','quebradizo','reparación','fortalecer']],['volumen',['fino','volumen']],['frizz',['frizz','encrespamiento']],['color',['teñido','proteger el color']],['mechas',['mechas','decoloración']],['caida',['caída','densidad']]]
    :[['antiedad',['antiedad','arrugas','prevenir']],['firmeza',['firmeza']],['manchas',['manchas']],['hidratacion',['deshidratación','hidratar']],['impurezas',['imperfecciones','grasa','poros']],['sensibilidad',['sensibilidad','barrera']],['luminosidad',['luminosidad']]];
  return dictionary.filter(([key,terms])=>terms.some(term=>has(raw,term))).map(([key])=>key);
}

/* =========================================================
   AJUSTE A NECESIDAD
========================================================= */

function fit(
  product,
  profile
){

  if(
    product.needs
      .includes(
        profile.principal
      )
  )
    return 100;

  const families=
    profile.category===
    'rostro'
      ?FACE_F[
          profile.principal
        ]||[]
      :HAIR_F[
          profile.principal
        ]||[];

  if(
    families
      .some(
        family=>
          product.families
            .includes(
              family
            )
      )
  )
    return 70;

  if(
    profile.secundaria
    &&
    product.needs
      .includes(
        profile.secundaria
      )
  )
    return 20;

  return 0;
}

/* =========================================================
   ELEGIBILIDAD
========================================================= */

function eligible(
  product,
  profile,
  role,
  moment=''
){

  if(!product?.njAuthorized || (product.njRule?.singleOnly && S.modalidad!=='producto')) return false;
  if(product.njRule?.noPregnancy && profile.extra?.pregnancy) return false;
  if(product.njRule?.noBarrier && profile.barrier) return false;
  if(product.njRule?.requiresRetinoidExperience && profile.tolerance!=='high') return false;
  if(product.skinTypes?.length && ['moisturizer','serum'].includes(role) && !product.skinTypes.includes(profile.skinType)) return false;
  if(profile.category==='rostro' && ['serum','moisturizer'].includes(role) &&
     !(profile.needs||[profile.principal]).some(n=>product.needs.includes(n)) &&
     !(profile.principal==='luminosidad' && product.needs.includes('antiedad')) &&
     !(profile.principal==='sensibilidad' && product.needs.includes('hidratacion'))) return false;
  if(profile.category==='cabello' && ['treatment','scalp','styling'].includes(role) &&
     !(profile.needs||[profile.principal]).some(n=>product.needs.includes(n)) &&
     !(profile.principal==='mechas' && product.needs.includes('reparacion'))) return false;

  if(
    !product
    ||
    product.excluded
    ||
    product.isPack
    ||
    product.category
    !==
    profile.category
    ||
    product.primaryRole
    !==
    role
    ||
    (
      moment
      &&
      !product.time
        .includes(
          moment
        )
    )
  )
    return false;

  /*
   * FIRMEZA
   * Una crema hidratante general
   * NO sirve como crema reafirmante.
   */

  if(
    profile.category===
    'rostro'
    &&
    profile.principal===
    'firmeza'
    &&
    role===
    'moisturizer'
    &&
    !product.needs
      .includes(
        'firmeza'
      )
    &&
    !product.families
      .some(
        family=>
          [
            'firming',
            'antiage'
          ]
            .includes(
              family
            )
      )
  )
    return false;

  if(
    profile.category===
    'rostro'
    &&
    profile.principal===
    'firmeza'
    &&
    role===
    'serum'
    &&
    !product.needs
      .includes(
        'firmeza'
      )
    &&
    !product.families
      .some(
        family=>
          [
            'firming',
            'peptides',
            'antiage'
          ]
            .includes(
              family
            )
      )
  )
    return false;

  if(
    profile.category===
    'rostro'
    &&
    profile.principal===
    'manchas'
    &&
    role===
    'serum'
    &&
    !product.needs
      .includes(
        'manchas'
      )
    &&
    !product.families
      .includes(
        'pigmentation'
      )
  )
    return false;

  if(
    profile.category===
    'rostro'
    &&
    profile.principal===
    'impurezas'
    &&
    [
      'serum',
      'moisturizer'
    ]
      .includes(
        role
      )
    &&
    !product.needs
      .includes(
        'impurezas'
      )
    &&
    !product.families
      .includes(
        'blemish'
      )
  )
    return false;

  if(
    profile.category===
    'rostro'
    &&
    profile.principal===
    'sensibilidad'
    &&
    [
      'serum',
      'moisturizer'
    ]
      .includes(
        role
      )
    &&
    !product.needs
      .includes(
        'sensibilidad'
      )
    &&
    !product.families
      .some(
        family=>
          [
            'barrier',
            'recovery'
          ]
            .includes(
              family
            )
      )
  )
    return false;

  return true;
}

/* =========================================================
   SCORE
========================================================= */

function score(
  product,
  profile,
  role,
  moment=''
){

  if(
    !eligible(
      product,
      profile,
      role,
      moment
    )
  )
    return -99999;

  let total=
    (
      product.curated
        ?120
        :0
    )
    +
    product.priority
    +
    fit(
      product,
      profile
    );
  if(profile.needs?.length){
    for(const n of profile.needs){
      if(n===profile.principal)continue;
      if(product.needs.includes(n))total+=32;
      else if((profile.category==='cabello'?HAIR_F:FACE_F)[n]?.some(f=>product.families.includes(f)))total+=20;
    }
  }

  if(
    profile.category===
    'rostro'
    &&
    product.skinTypes
      .includes(
        profile.skinType
      )
  )
    total+=20;

  if(
    profile.category===
    'cabello'
    &&
    product.hairTypes
      .includes(
        profile.hairType
      )
  )
    total+=20;

  if(
    profile.category===
    'cabello'
    &&
    profile.scalp!==
    'normal'
    &&
    product.scalp
      .includes(
        profile.scalp
      )
  )
    total+=80;

  if(
    profile.category===
    'cabello'
    &&
    profile.highlights
    &&
    product.needs
      .some(
        need=>
          [
            'reparacion',
            'mechas'
          ]
            .includes(
              need
            )
      )
  )
    total+=30;

  /* V14.2: priorizar fibra fina sin equiparar finura a dano. */
  if(profile.category==='cabello' && profile.hairType==='fino'){
    const id=String(product.id);
    if(['6763995332747','6763998675083','6764041207947','6582625829003','6582626877579','6582627664011'].includes(id)) total-=95;
    if(['6790183682187','6790190956683','6790206292107'].includes(id) && ['reparacion','mechas'].includes(profile.principal)) total+=85;
  }
  if(profile.category==='cabello' && profile.principal==='caida'){
    if(['16279560290629','16279740744005','16279892754757'].includes(String(product.id))) total+=65;
  }

  /*
   * Fast Skin Repair
   * solo barrera/sensibilidad.
   */

  if(
    has(
      product.title,
      'fast skin repair'
    )
    &&
    profile.principal!==
    'sensibilidad'
  )
    total-=400;

  return total;
}

/* =========================================================
   CANDIDATOS
========================================================= */

/* Puntuación contextual de las cremas: afinidad de piel y sinergias.
   No altera elegibilidad, contraindicaciones ni stock. */
function njCreamContext(product,profile,selected=[]){
 if(profile.category!=='rostro'||product.primaryRole!=='moisturizer')return 0;
 const title=norm(product.title);
 let score=0;
 const needs=profile.needs||[profile.principal];
 const matched=needs.filter(n=>product.needs.includes(n)).length;
 score+=matched*34;
 if(product.skinTypes?.length){
   score+=product.skinTypes.includes(profile.skinType)?75:-85;
 }
 if(profile.barrier){
   if(product.needs.includes('sensibilidad'))score+=105;
   else score-=75;
   if(product.actives?.length)score-=120;
 }
 if(profile.skinType==='grasa' && /rich|riche|rl |msr.h|nutritive|nourishing|grande creme/.test(title))score-=95;
 if(profile.skinType==='seca' && /dermopurifiante|matifiant|oil free/.test(title))score-=90;
 if(profile.principal==='manchas' && /pigm|bright|lumino|vitamin c/.test(title))score+=65;
 if(profile.principal==='impurezas' && /dermopurifiante|purif|clarifying/.test(title))score+=65;
 if(profile.principal==='firmeza' && /splendide|firm|lifting|biofixine/.test(title))score+=55;
 if(profile.principal==='hidratacion' && /hydra|dermo.rl|vg derm|msr.h/.test(title))score+=55;
 if(/elastine/.test(title))score-=115;
 const already=selected.filter(Boolean);
 const related=already.filter(p=>p.needs?.some(n=>needs.includes(n)&&product.needs.includes(n)));
 score+=Math.min(55,related.length*15);
 const activeCount=already.filter(p=>(p.actives||[]).length).length;
 if(activeCount && (product.actives||[]).length)score-=45*activeCount;
 return score;
}
function njBestCream(catalog,profile,moment,selected,brand,budget){
 const candidates=base(catalog,profile,'moisturizer',moment).filter(x=>!brand||x.p.vendorKey===brand);
 const ranked=candidates.map(x=>({p:x.p,s:x.s+njCreamContext(x.p,profile,selected)}))
  .sort((a,b)=>b.s-a.s || cents(a.p)-cents(b.p));
 return best(ranked,selected,profile,moment,budget);
}
function base(
  catalog,
  profile,
  role,
  moment=''
){

  return catalog

    .filter(
      product=>
        eligible(
          product,
          profile,
          role,
          moment
        )
    )

    .map(
      product=>({
        p:
          product,

        s:
          score(
            product,
            profile,
            role,
            moment
          )
      })
    )

    .filter(
      item=>
        item.s>0
    )

    .sort(
      (a,b)=>
        b.s-a.s
        ||
        b.p.priority
        -
        a.p.priority
    );
}

/* =========================================================
   MARCA PREFERIDA
========================================================= */

function aware(catalog,profile,role,moment=''){
 const all=base(catalog,profile,role,moment);
 if(!S.brandPreference)return all;
 return [...all.filter(x=>x.p.vendorKey===S.brandPreference),...all.filter(x=>x.p.vendorKey!==S.brandPreference)];
}
/* UTILIDADES DE PRESUPUESTO · EN CÉNTIMOS */
function njTotal(products){return [...new Map(products.filter(Boolean).map(x=>[x.variant.id,x])).values()].reduce((s,p)=>s+cents(p),0);}
function njReduceFace(plan,profile,catalog){
  const max=NJ_MAX_BUDGET();
  const essential=['cleanser','moisturizer','spf'];
  const current=()=>njTotal([...plan.morning,...plan.night].map(x=>x.product));
  if(current()<=max && essential.every(role=>plan.morning.some(x=>x.role===role)))return true;
  if(max===Infinity || !catalog?.length)return false;

  // No se sacrifican limpieza, tratamiento hidratante y SPF para encajar un sérum caro.
  if(S.brandPreference==='biologique recherche')return true;
  const clean=base(catalog,profile,'cleanser','am').filter(x=>
    S.brandPreference
      ?x.p.vendorKey===S.brandPreference
      :x.p.vendorKey==='biologique recherche' && /^(lait|leche)/i.test((x.p.title||'').trim())
  ).slice(0,12);
  const cream=aware(catalog,profile,'moisturizer','am').slice(0,12);
  const spf=aware(catalog,profile,'spf','am').slice(0,12);
  let winner=null;
  for(const c of clean){
    for(const m of cream){
      for(const u of spf){
        const products=[c.p,m.p,u.p];
        if(new Set(products.map(x=>x.id)).size!==3)continue;
        const amount=njTotal(products);
        if(amount>max)continue;
        const score=c.s+m.s+u.s+[
          c,m,u
        ].filter(x=>S.brandPreference&&x.p.vendorKey===S.brandPreference).length*30;
        if(!winner || score>winner.score || (score===winner.score && amount<winner.amount)){
          winner={products,score,amount};
        }
      }
    }
  }
  if(!winner)return false;
  const [cleanser,moisturizer,protector]=winner.products;
  const baseline=[
    {role:'cleanser',product:cleanser,label:''},
    {role:'moisturizer',product:moisturizer,label:''},
    {role:'spf',product:protector,label:''}
  ];
  // Añadir un único sérum cuando tenga encaje profesional y presupuesto.
  const affordableSerum=best(aware(catalog,profile,'serum','am'),winner.products,profile,'am',max-winner.amount);
  if(affordableSerum)baseline.splice(1,0,{role:'serum',product:affordableSerum,label:''});
  plan.morning=baseline;
  plan.night=baseline.filter(x=>x.role!=='spf' && x.product.time.includes('pm'));
  plan.budgetNote='Con este presupuesto priorizamos limpieza, hidratación y protección solar; si no se incluye sérum o tónico, puedes ampliar la rutina posteriormente.';
  plan.budgetReduced=true;
  validate(plan);renumber(plan.morning);renumber(plan.night);
  return njTotal(plan.uniqueProducts)<=max && essential.every(role=>plan.morning.some(x=>x.role===role));
}
function njReduceHair(routine,profile){
  const max=NJ_MAX_BUDGET();
  if(max===Infinity)return routine;
  let items=[...routine];
  const total=()=>njTotal(items.map(x=>x.product));
  for(const role of ['styling','treatment']){
    if(total()<=max)break;
    if(role==='treatment'&&['reparacion','mechas','caida'].includes(profile.principal))continue;
    items=items.filter(x=>x.role!==role);
  }
  if(total()>max || !items.some(x=>x.role==='cleanser') ||
     !items.some(x=>['conditioner','mask'].includes(x.role)))return [];
  items.forEach((x,i)=>{x.label='PASO '+(i+1)+' · '+({cleanser:'LIMPIAR',conditioner:'ACONDICIONAR',mask:'TRATAR',treatment:'TRATAR',scalp:'CUIDAR EL CUERO CABELLUDO',styling:'FINALIZAR'}[x.role]||'CUIDAR')});
  items.brandFallbacks=routine.brandFallbacks||[];
  return items;
}
/* =========================================================
   MEJOR PRODUCTO
========================================================= */

function best(
  list,
  selected,
  profile,
  moment='',
  budget=Infinity
){

  for(
    const item
    of list
  ){

    const product=
      item.p;

    if(
      selected
        .some(
          existing=>
            existing.variant.id
            ===
            product.variant.id
        )
    )
      continue;

    if(
      cents(product)
      >
      budget
    )
      continue;

    if(
      profile.category===
      'rostro'
      &&
      moment
      &&
      !compatible(
        product,
        selected,
        profile,
        moment
      )
    )
      continue;

    return product;
  }

  return null;
}

/* =========================================================
   PRODUCTO ÚNICO
========================================================= */

function autoRole(
  profile
){

  if(
    profile.category===
    'rostro'
  ){

    return(
      {
        antiedad:
          'serum',

        firmeza:
          'serum',

        manchas:
          'serum',

        hidratacion:
          'serum',

        impurezas:
          'serum',

        sensibilidad:
          'moisturizer',

        luminosidad:
          'serum'
      }[
        profile.principal
      ]
      ||
      'serum'
    );
  }

  return(
    {
      hidratacion:
        'treatment',

      reparacion:
        'treatment',

      volumen:
        'styling',

      frizz:
        'treatment',

      color:
        'conditioner',

      mechas:
        'treatment',

      caida:
        'scalp'
    }[
      profile.principal
    ]
    ||
    'treatment'
  );
}

async function single(
  catalog,
  profile
){

  const role=
    S.singleRole===
    'auto'
      ?autoRole(
          profile
        )
      :S.singleRole;

  const budget=
    S.presupuesto===
    'none'
      ?Infinity
      :Number(
          S.presupuesto
        )
        *
        100;

  const moment=
    role===
    'spf'
      ?'am'
      :role===
        'retinoid'
        ?'pm'
        :'';

  return best(
    aware(
      catalog,
      profile,
      role,
      moment
    ),
    [],
    profile,
    moment,
    budget
  );
}

async function singleAlternatives(catalog,profile,first){
  const role=S.singleRole==='auto'?autoRole(profile):S.singleRole;
  const moment=role==='spf'?'am':role==='retinoid'?'pm':'';
  const budget=NJ_MAX_BUDGET();
  const ranked=base(catalog,profile,role,moment);
  const alternative=best(ranked.filter(x=>x.p.vendorKey!==first.vendorKey),[first],profile,moment,budget);
  return alternative?[first,alternative]:[first];
}

/* =========================================================
   UTILIDADES DE MARCA
========================================================= */

function byBrand(catalog,brand,role,profile,moment=''){
 const all=base(catalog,profile,role,moment);
 return [...all.filter(x=>x.p.vendorKey===brand),...all.filter(x=>x.p.vendorKey!==brand)];
}
/* =========================================================
   PROTOCOLO BIOLOGIQUE RECHERCHE
========================================================= */

function brExfoliant(catalog,profile){
  if(profile.barrier || profile.tolerance==='low' || profile.extra?.acids ||
     profile.extra?.retinoid || profile.extra?.pregnancy || profile.extra?.dermatologist)return null;
  const choices=catalog.filter(p=>p.vendorKey==='biologique recherche' &&
    p.primaryRole==='toner' && p.actives.includes('aha') &&
    (!p.njRule?.requiresRetinoidExperience || profile.tolerance==='high') &&
    p.variant && compatible(p,[],profile,'pm'));
  const needs=profile.needs||[profile.principal];
  const preferred=needs.includes('manchas')?'p50 pigm':needs.includes('impurezas')?'lotion p50':needs.includes('firmeza')||needs.includes('antiedad')?(profile.tolerance==='high'?'p50v':'p50w'):'p50w';
  return choices.find(p=>has(p.title,preferred))||choices.find(p=>has(p.title,'p50w'))||null;
}

async function brPlan(
  catalog,
  profile
){

  const plan={

    morning:
      [],

    night:
      [],

    uniqueProducts:
      [],

    brandFallbacks:
      []
  };

  const remember=
    product=>{

      if(
        product
        &&
        !plan.uniqueProducts
          .some(
            existing=>
              existing.variant.id
              ===
              product.variant.id
          )
      )
        plan.uniqueProducts
          .push(
            product
          );
    };

  const push=(
    target,
    role,
    product
  )=>{

    if(
      !product
    )
      return;

    target.push(
      {
        role,
        product,
        label:''
      }
    );

    remember(
      product
    );
  };

  /* Limpieza BR estricta: únicamente leches limpiadoras Biologique Recherche. */
  const brMilks=base(catalog,profile,'cleanser','am').filter(x=>
    x.p.vendorKey==='biologique recherche' &&
    /^(lait|leche|leche limpiadora)/i.test((x.p.title||'').trim())
  );
  const cleanser=best(brMilks,[],profile,'am');
  if(cleanser){
    push(plan.morning,'cleanser',cleanser);
    if(cleanser.time.includes('pm'))push(plan.night,'cleanser',cleanser);
  }else{
    plan.brandFallbacks.push('No hemos encontrado una leche limpiadora Biologique Recherche adecuada y disponible; no la sustituimos por otro limpiador.');
  }

  /* La Lotion P50 es una loción tónica microexfoliante: puede usarse
     por la mañana y/o noche según tolerancia y protocolo individual. */
  const brP50=brExfoliant(catalog,profile);
  const gentle=best(
    base(catalog,profile,'toner','am').filter(x=>x.p.vendorKey==='biologique recherche' && !(x.p.actives||[]).length),
    plan.morning.map(x=>x.product),profile,'am'
  );
  const lotion=brP50||gentle;
  if(lotion){
    push(plan.morning,'toner',lotion);
    if(lotion.time.includes('pm'))push(plan.night,'toner',lotion);
  }
  /* Las indicaciones de P50 se muestran en la ficha del producto, no en avisos de marca. */

  /* SÉRUM */

  const serumBR=
    best(
      byBrand(
        catalog,
        'biologique recherche',
        'serum',
        profile,
        'am'
      ),
      [],
      profile,
      'am'
    );

  const serum=
    serumBR
    ||
    best(
      byBrand(catalog,'biologique recherche','serum',profile,'am'
      ),
      [],
      profile,
      'am'
    );

  push(
    plan.morning,
    'serum',
    serum
  );

  if(
    serum?.time
      .includes(
        'pm'
      )
  ){

    push(
      plan.night,
      'serum',
      serum
    );

  }else{

    const pmSerum=
      best(
        byBrand(
          catalog,
          'biologique recherche',
          'serum',
          profile,
          'pm'
        ),
        plan.night
          .map(
            item=>
              item.product
          ),
        profile,
        'pm'
      )
      ||
      best(
        byBrand(
          catalog,
          'biologique recherche',
          profile,
          'serum',
          'pm'
        ),
        plan.night
          .map(
            item=>
              item.product
          ),
        profile,
        'pm'
      );

    push(
      plan.night,
      'serum',
      pmSerum
    );
  }

  /* CREMA: selección contextual de la receta completa */
  const selectedBR=plan.morning.concat(plan.night).map(x=>x.product);
  const cream=njBestCream(catalog,profile,'am',selectedBR,'biologique recherche',Infinity)
    ||njBestCream(catalog,profile,'am',selectedBR,null,Infinity);
  push(plan.morning,'moisturizer',cream);
  if(cream?.time.includes('pm'))push(plan.night,'moisturizer',cream);
  else {
    const pm=njBestCream(catalog,profile,'pm',selectedBR, 'biologique recherche',Infinity)
      ||njBestCream(catalog,profile,'pm',selectedBR,null,Infinity);
    push(plan.night,'moisturizer',pm);
  }

  /*
   * SPF:
   * No intentamos convertir
   * un producto BR en solar.
   */

  /* Marca estricta: BR no se sustituye por otro fabricante sin permiso.
     El paso de fotoprotección se explica fuera de los productos seleccionados. */
  const spf=best(byBrand(catalog,'biologique recherche','spf',profile,'am'),
    plan.morning.map(x=>x.product),profile,'am');
  push(plan.morning,'spf',spf);
  if(!spf)plan.brandFallbacks.push('No hay fotoprotector Biologique Recherche verificado para este perfil. La rutina de día necesita un SPF adecuado, pero no añadimos otra marca sin tu autorización.');

  validate(
    plan
  );

  renumber(
    plan.morning
  );

  renumber(
    plan.night
  );

  return plan;
}

/* =========================================================
   RUTINA FACIAL GENERAL
========================================================= */

async function facePlan(
  catalog,
  profile
){

  /*
   * Biologique Recherche
   * usa protocolo propio.
   */

  if(
    S.brandPreference===
    'biologique recherche'
  )
    return brPlan(
      catalog,
      profile
    );

  const plan={

    morning:
      [],

    night:
      [],

    uniqueProducts:
      [],

    brandFallbacks:
      []
  };

  const remember=
    product=>{

      if(
        product
        &&
        !plan.uniqueProducts
          .some(
            existing=>
              existing.variant.id
              ===
              product.variant.id
          )
      )
        plan.uniqueProducts
          .push(
            product
          );
    };

  const add=(
    target,
    role,
    moment
  )=>{

    const product=
      best(
        aware(
          catalog,
          profile,
          role,
          moment
        ),
        target
          .map(
            item=>
              item.product
          ),
        profile,
        moment,
        NJ_MAX_BUDGET()-njTotal(plan.uniqueProducts)
      );

    if(
      !product
    )
      return null;

    target.push(
      {
        role,
        product,
        label:''
      }
    );

    remember(
      product
    );

    if(
      S.brandPreference
      &&
      product.vendorKey
      !==
      S.brandPreference
    ){

      plan.brandFallbacks
        .push(
          `Hemos mantenido ${
            BL[
              S.brandPreference
            ]
            ||
            S.brandPreference
          } siempre que era técnicamente adecuado, pero para ${role} hemos elegido ${product.vendor} porque cumple mejor la función necesaria.`
        );
    }

    return product;
  };

  /* Limpieza: sin preferencia, leche Biologique Recherche;
     con marca expresa, únicamente limpiadores de esa marca. */
  const options=base(catalog,profile,'cleanser','am').filter(x=>
    S.brandPreference
      ?x.p.vendorKey===S.brandPreference
      :x.p.vendorKey==='biologique recherche' && /^(lait|leche)/i.test((x.p.title||'').trim())
  );
  const cleanser=best(options,[],profile,'am',NJ_MAX_BUDGET()-njTotal(plan.uniqueProducts));
  if(cleanser){
    plan.morning.push({role:'cleanser',product:cleanser,label:''});
    if(cleanser.time.includes('pm'))plan.night.push({role:'cleanser',product:cleanser,label:''});
    remember(cleanser);
  }else plan.brandFallbacks.push(S.brandPreference
    ?'No hay un limpiador adecuado y disponible de la marca seleccionada; no lo sustituimos por otra marca.'
    :'No hay una leche limpiadora Biologique Recherche adecuada y disponible; no la sustituimos por otro limpiador.');

  /* UN SOLO PASO DE LOCIÓN. P50 y P50W son lociones tónicas
     microexfoliantes y sustituyen al tónico estándar, no se añaden encima. */
  const safeP50=profile.tolerance!=='low' && !profile.barrier &&
    !profile.extra?.acids && !profile.extra?.retinoid &&
    !profile.extra?.pregnancy && !profile.extra?.dermatologist;
  const p50Choices=safeP50?aware(catalog,profile,'toner','am').filter(x=>
    x.p.vendorKey==='biologique recherche' && x.p.actives?.includes('aha')):[];
  const preferredP50=best(p50Choices,plan.morning.map(x=>x.product),profile,'am',
    NJ_MAX_BUDGET()-njTotal(plan.uniqueProducts));
  const normalToner=preferredP50?null:add(plan.morning,'toner','am');
  if(preferredP50){
    plan.morning.push({role:'toner',product:preferredP50,label:''});
    remember(preferredP50);
  }
  const chosenToner=preferredP50||normalToner;
  if(chosenToner?.time.includes('pm')){
    plan.night.push({role:'toner',product:chosenToner,label:''});
    remember(chosenToner);
  }
  /* P50: consejo de aplicación solo junto a su ficha. */

  /* SÉRUM */

  const serum=
    add(
      plan.morning,
      'serum',
      'am'
    );

  /* Sérum mañana/noche: no cambiar por cambiar. Diferenciar si cubre
     una segunda necesidad real, sin superar presupuesto. */
  const secondaryNeeds=(profile.needs||[]).filter(n=>n!==profile.principal);
  const distinctPmSerum=secondaryNeeds.length ? best(
    aware(catalog,profile,'serum','pm').filter(x=>
      x.p.id!==serum?.id && secondaryNeeds.some(n=>x.p.needs.includes(n))
    ),
    plan.night.map(x=>x.product),profile,'pm',
    NJ_MAX_BUDGET()-njTotal(plan.uniqueProducts)
  ) : null;
  if(distinctPmSerum){
    plan.night.push({role:'serum',product:distinctPmSerum,label:''});remember(distinctPmSerum);
  }else if(serum?.time.includes('pm')){
    plan.night.push({role:'serum',product:serum,label:''});
  }else add(plan.night,'serum','pm');

  /* RETINOIDE
     Solo antiedad + corregir
     + tolerancia alta.
  */

  const canRetinoid=
    profile.principal===
    'antiedad'
    &&
    has(
      S.p4,
      'corregir'
    )
    &&
    profile.tolerance===
    'high'
    &&
    !profile.barrier
    &&
    !profile.extra?.retinoid
    &&
    !profile.extra?.pregnancy
    &&
    !profile.extra?.dermatologist;

  if(
    canRetinoid
    &&
    !plan.night
      .some(item=>acids(item.product))
  )
    add(
      plan.night,
      'retinoid',
      'pm'
    );

  /* EXFOLIANTE
     Solo impurezas + textura/poros.
  */

  const doExfoliant=
    profile.principal===
    'impurezas'
    &&
    has(
      S.p4,
      'textura',
      'poros'
    )
    &&
    profile.tolerance!==
    'low'
    &&
    !profile.barrier
    &&
    !profile.extra?.acids;

  if(
    doExfoliant
    &&
    !plan.night
      .some(
        item=>
          isRet(
            item.product
          )
          ||
          acids(
            item.product
          )
      )
  ){

    const exfoliant=
      best(
        aware(
          catalog,
          profile,
          'exfoliant',
          'pm'
        ),
        plan.night
          .map(
            item=>
              item.product
          ),
        profile,
        'pm'
      );

    if(
      exfoliant
    ){

      plan.night
        .splice(
          1,
          0,
          {
            role:
              'exfoliant',

            product:
              exfoliant,

            label:''
          }
        );

      remember(
        exfoliant
      );
    }
  }

  /* CREMA: contexto global de limpieza, loción y sérum */
  const selection=plan.morning.concat(plan.night).map(x=>x.product);
  const cream=njBestCream(catalog,profile,'am',selection,S.brandPreference||null,Infinity)
    ||njBestCream(catalog,profile,'am',selection,null,Infinity);
  if(cream){plan.morning.push({role:'moisturizer',product:cream,label:''});remember(cream);}
  if(cream?.time.includes('pm'))plan.night.push({role:'moisturizer',product:cream,label:''});
  else{
    const night=njBestCream(catalog,profile,'pm',selection,S.brandPreference||null,Infinity)
      ||njBestCream(catalog,profile,'pm',selection,null,Infinity);
    if(night){plan.night.push({role:'moisturizer',product:night,label:''});remember(night);}
  }

  /* SPF */

  add(
    plan.morning,
    'spf',
    'am'
  );

  validate(
    plan
  );

  renumber(
    plan.morning
  );

  renumber(
    plan.night
  );

  return plan;
}

/* =========================================================
   VALIDACIÓN FACIAL
========================================================= */

function njEyePreference(plan,catalog,profile){
 if(S.eyeChoice!=='Sí, quiero cuidar el contorno de ojos')return plan;
 const selected=plan.morning.concat(plan.night).map(x=>x.product);
 const budget=NJ_MAX_BUDGET();
 const remaining=budget===Infinity?Infinity:Math.max(0,budget-njTotal(selected));
 const need=S.eyeNeed||'';
 const eyeMatch=p=>{
   const title=norm(p.title||'');
   if(need.startsWith('Ojeras'))return /pigment|bright|vitamin c|vip o2|oligo|lumi|oxygen|dark circle/.test(title)||p.needs.includes('luminosidad');
   if(need.startsWith('Bolsas'))return /puff|bag|bolsa|vip o2|liposmose|caffeine|eyelift|drain/.test(title);
   if(need.startsWith('Líneas'))return /wrinkle|retinal|biofixine|peptide|arruga|anti.age/.test(title)||p.needs.includes('antiedad');
   if(need.startsWith('Firmeza'))return /firm|lifting|eyelift|biofixine|peptide/.test(title)||p.needs.includes('firmeza');
   if(need.startsWith('Hidratación'))return /hydra|b5|biosensible|moisture|nourish|advanced night/.test(title)||p.needs.includes('hidratacion');
   return false;
 };
 const eyeOptions=catalog.filter(p=>p.primaryRole==='eye'&&p.category==='rostro'&&p.variant).map(p=>({
   p,s:score(p,profile,'eye','am')+(eyeMatch(p)?180:-160)+(p.needs.includes(profile.principal)?25:0)+(S.brandPreference&&p.vendorKey===S.brandPreference?250:0)
 })).filter(x=>x.s>0).sort((a,b)=>b.s-a.s);
 const chosen=best(eyeOptions,selected,profile,'am',remaining);
 if(!chosen){
  plan.brandFallbacks=plan.brandFallbacks||[];
  plan.brandFallbacks.push('No hemos incluido un contorno de ojos porque no encontramos una opción compatible y disponible dentro del presupuesto restante.');
  return plan;
 }
 plan.morning.push({role:'eye',product:chosen,label:''});
 if(chosen.time.includes('pm'))plan.night.push({role:'eye',product:chosen,label:''});
 validate(plan);renumber(plan.morning);renumber(plan.night);
 return plan;
}
function njNightCreamPreference(plan,catalog,profile){
 const mode=S.nightCream||'recommend';
 if(!plan?.morning?.length)return plan;
 const day=plan.morning.find(x=>x.role==='moisturizer')?.product;
 if(!day)return plan;
 const existing=plan.night.find(x=>x.role==='moisturizer');
 const same=existing&&String(existing.product.variant.id)===String(day.variant.id);
 if(mode.startsWith('Quiero utilizar')){
   if(day.time.includes('pm')){
     plan.night=plan.night.filter(x=>x.role!=='moisturizer');
     plan.night.push({role:'moisturizer',product:day,label:''});
   }
 }else if(mode.startsWith('Prefiero dos')){
   const options=aware(catalog,profile,'moisturizer','pm').filter(x=>x.p.variant && String(x.p.variant.id)!==String(day.variant.id));
   const budget=NJ_MAX_BUDGET();
    const selected=plan.morning.concat(plan.night).filter(x=>x.role!=='moisturizer').map(x=>x.product).concat(day);
    const remaining=budget===Infinity?Infinity:Math.max(0,budget-njTotal(plan.morning.concat(plan.night).filter(x=>x.role!=='moisturizer').map(x=>x.product).concat(day)));
    /* V14.24 · Mesoestetic Age Element Anti-Wrinkle Night Cream 50 ml.
       Solo para antiedad, cuando se solicitan dos cremas distintas.
       Preferencia no comercial: respetar marca elegida, stock, presupuesto,
       compatibilidad, barrera cutánea y exclusiones de la ficha verificada. */
    const nightSpecial=profile.principal==='antiedad' &&
       (!S.brandPreference || S.brandPreference==='mesoestetic')
       ?best(options.filter(x=>String(x.p.id)==='16319757582661'),selected,profile,'pm',remaining)
       :null;
    const other=nightSpecial||best(options,selected,profile,'pm',remaining);
   if(other){
     plan.night=plan.night.filter(x=>x.role!=='moisturizer');
     plan.night.push({role:'moisturizer',product:other,label:''});
   }else{
     plan.brandFallbacks=plan.brandFallbacks||[];
     plan.brandFallbacks.push('No hemos encontrado una segunda crema nocturna adecuada dentro de los criterios y presupuesto indicados; no añadimos otra por obligación.');
     if(!existing&&day.time.includes('pm'))plan.night.push({role:'moisturizer',product:day,label:''});
   }
 }else if(!existing&&day.time.includes('pm')){
   plan.night.push({role:'moisturizer',product:day,label:''});
 }
 validate(plan);
 renumber(plan.morning);
 renumber(plan.night);
 return plan;
}

function validate(
  plan
){

  const dedupe=
    items=>{

      const seen=
        new Set();

      return items
        .filter(
          item=>{

            if(
              seen.has(
                item.role
              )
            )
              return false;

            seen.add(
              item.role
            );

            return true;
          }
        );
    };

  plan.morning=
    dedupe(
      plan.morning
    )
      .filter(
        item=>
          ![
            'retinoid',
            'exfoliant'
          ]
            .includes(
              item.role
            )
      );

  plan.night=
    dedupe(
      plan.night
    );
  /* Una loción P50 no puede aparecer como un exfoliante extra junto al tónico. */
  const isP50=item=>/\bp50(?:w|v)?\b/i.test(item.product?.title||'') || /pigm.?400/i.test(item.product?.title||'');
  for(const period of ['morning','night']){
    const steps=plan[period];
    const p50=steps.find(isP50);
    if(p50){
      plan[period]=steps.filter(item=>!(['toner','exfoliant'].includes(item.role)) || item===p50);
      p50.role='toner';
    }
  }


  /*
   * Nunca ácido fuerte + retinal
   * automáticamente.
   */

  if(
    plan.night
      .some(
        item=>
          item.role===
          'retinoid'
      )
    &&
    plan.night
      .some(
        item=>
          item.role===
          'exfoliant'
      )
  )
    plan.night=
      plan.night
        .filter(
          item=>
            item.role
            !==
            'exfoliant'
        );

  const amOrder={
    toner:2,
    eye:3,
    cleanser:1,
    serum:2,
    moisturizer:3,
    spf:4
  };

  const pmOrder={
    toner:2,
    cleanser:1,
    exfoliant:2,
    serum:3,
    eye:4,
    retinoid:4,
    moisturizer:5
  };

  plan.morning
    .sort(
      (a,b)=>
        (
          amOrder[
            a.role
          ]
          ||
          99
        )
        -
        (
          amOrder[
            b.role
          ]
          ||
          99
        )
    );

  plan.night
    .sort(
      (a,b)=>
        (
          pmOrder[
            a.role
          ]
          ||
          99
        )
        -
        (
          pmOrder[
            b.role
          ]
          ||
          99
        )
    );

  plan.uniqueProducts=
    [
      ...new Map(
        [
          ...plan.morning,
          ...plan.night
        ]
          .map(
            item=>[
              item.product
                .variant.id,
              item.product
            ]
          )
      )
        .values()
    ];

  plan.brandFallbacks=
    uniq(
      plan.brandFallbacks||
      []
    );
}

function renumber(
  items
){

  const labels={

    cleanser:
      'LIMPIAR',

    exfoliant:
      'RENOVAR',

    toner:
      'TONIFICAR / RENOVAR SEGÚN TOLERANCIA',

    serum:
      'TRATAR',

    eye:
      'CUIDAR EL CONTORNO DE OJOS',

    retinoid:
      'RENOVAR',

    moisturizer:
      'HIDRATAR Y TRATAR',

    spf:
      'PROTEGER'
  };

  items
    .forEach(
      (
        item,
        index
      )=>

        item.label=
          `PASO ${
            index+1
          } · ${
            labels[
              item.role
            ]
            ||
            ''
          }`
    );
}

/* =========================================================
   CABELLO
========================================================= */

async function hairRoutine(
  catalog,
  profile
){

  const routine=[];
  const selected=[];
  const fallbacks=[];

  const add=
    role=>{

      const product=
        best(
          aware(
            catalog,
            profile,
            role
          ),
          selected,
          profile,
          '',
          NJ_MAX_BUDGET()-njTotal(selected)
        );

      if(
        !product
      )
        return null;

      routine.push(
        {
          role,
          product,
          label:''
        }
      );

      selected.push(
        product
      );

      if(
        S.brandPreference
        &&
        product.vendorKey
        !==
        S.brandPreference
      ){

        fallbacks.push(
          `Hemos mantenido ${
            BL[
              S.brandPreference
            ]
            ||
            S.brandPreference
          } siempre que era la mejor opción, pero hemos completado un paso con ${product.vendor} porque era más específico para esta necesidad.`
        );
      }

      return product;
    };

  /*
   * CUERO CABELLUDO
   * tiene prioridad.
   */

  if(
    [
      'graso',
      'sensible'
    ]
      .includes(
        profile.scalp
      )
  ){

    const need=
      profile.scalp===
      'graso'
        ?'graso'
        :'sensible';

    const special=
      catalog
        .filter(
          product=>
            product.category===
            'cabello'
            &&
            product.primaryRole===
            'cleanser'
            &&
            product.njAuthorized
            &&
            eligible(product,profile,'cleanser')
            &&
            !product.excluded
            &&
            !product.isPack
            &&
            (
              product.needs
                .includes(
                  need
                )
              ||
              product.scalp
                .includes(
                  profile.scalp
                )
            )
        )
        .map(
          product=>({
            p:
              product,

            s:
              score(
                product,
                profile,
                'cleanser'
              )
              +
              180
          })
        )
        .sort(
          (a,b)=>
            b.s-a.s
        );

    const product=
      best(
        special,
        selected,
        profile,
        '',
        NJ_MAX_BUDGET()-njTotal(selected)
      );

    if(product){

      routine.push(
        {
          role:
            'cleanser',

          product,

          label:''
        }
      );

      selected.push(
        product
      );

    }else{

      add(
        'cleanser'
      );
    }

  }else{

    add(
      'cleanser'
    );
  }

  /*
   * Acondicionador O mascarilla.
  */

  if(
    profile.highlights
    ||
    [
      'reparacion',
      'mechas'
    ]
      .includes(
        profile.principal
      )
    ||
    profile.hairType===
    'grueso'
  ){

    if(
      !add(
        'mask'
      )
    )
      add(
        'conditioner'
      );

  }else{

    add(
      'conditioner'
    );
  }

  /*
   * Tratamiento.
  */

  if(
    profile.principal===
    'caida'
  )
    add(
      'scalp'
    );

  else if(
    profile.highlights
    ||
    [
      'reparacion',
      'mechas'
    ]
      .includes(
        profile.principal
      )
  )
    add(
      'treatment'
    );

  else if(
    [
      'hidratacion',
      'volumen',
      'frizz'
    ]
      .includes(
        profile.principal
      )
  )
    add(
      'treatment'
    );

  /*
   * Styling.
  */

  if(
    [
      'frizz',
      'volumen'
    ]
      .includes(
        profile.principal
      )
  )
    add(
      'styling'
    );

  /* Aceite de acabado: opción adicional en nutrición, reparación y largos secos. */
  if(['hidratacion','reparacion','mechas','frizz'].some(n=>(profile.needs||[profile.principal]).includes(n)) &&
     !['volumen','caida'].includes(profile.principal) &&
     profile.hairType!=='fino' &&
     !routine.some(item=>item.role==='styling')){
    const oils=aware(catalog,profile,'styling').filter(x=>['6766553596043','6669203439755','6593242595467','6547729318027'].includes(String(x.p.id)));
    const oil=best(oils,selected,profile,'',NJ_MAX_BUDGET()-njTotal(selected));
    if(oil){routine.push({role:'styling',product:oil,label:'ACEITE DE ACABADO · MEDIOS Y PUNTAS'});selected.push(oil);}
  }

  const seen=
    new Set();

  const filtered=
    routine
      .filter(
        item=>{

          if(
            seen.has(
              item.role
            )
          )
            return false;

          seen.add(
            item.role
          );

          return true;
        }
      );

  const labels={

    cleanser:
      'LIMPIAR',

    conditioner:
      'ACONDICIONAR',

    mask:
      'ACONDICIONAR Y TRATAR',

    treatment:
      'TRATAR',

    scalp:
      'TRATAR EL CUERO CABELLUDO',

    styling:
      'FINALIZAR Y PROTEGER'
  };

  filtered
    .forEach(
      (
        item,
        index
      )=>

        item.label=
          `PASO ${
            index+1
          } · ${
            labels[
              item.role
            ]
            ||
            ''
          }`
    );

  filtered.brandFallbacks=
    uniq(
      fallbacks
    );

  return njReduceHair(filtered,profile);
}

/* =========================================================
   TEXTOS
========================================================= */

const NEED={

  hidratacion:
    'hidratación',

  reparacion:
    'reparación',

  volumen:
    'volumen y ligereza',

  frizz:
    'control del encrespamiento',

  color:
    'protección del color',

  mechas:
    'cabello con mechas o decoloración',

  caida:
    'caída y densidad',

  antiedad:
    'antiedad',

  firmeza:
    'firmeza',

  manchas:
    'manchas y tono desigual',

  impurezas:
    'imperfecciones',

  sensibilidad:
    'recuperación de la barrera',

  luminosidad:
    'luminosidad'
};

const need=
  key=>
    NEED[key]
    ||
    key
    ||
    '';

function summary(
  profile
){

  if(
    profile.category===
    'cabello'
  ){

    return[
      S.p2,

      !has(
        S.p3,
        'natural'
      )
        ?S.p3
        :'',

      profile.scalp!==
      'normal'
        ?S.p5
        :''
    ]
      .filter(Boolean)
      .join(
        ' · '
      );
  }

  return[
    `Piel ${
      S.p2
        .toLowerCase()
    }`,

    need(
      profile.principal
    ),

    profile.barrier
      ?'barrera sensibilizada'
      :''
  ]
    .filter(Boolean)
    .join(
      ' · '
    );
}

function reason(product,profile){
 const role=product.primaryRole;
 const needs=(profile.needs||[profile.principal]).filter(Boolean);
 const matched=needs.filter(n=>(product.needs||[]).includes(n)).slice(0,2);
 const target=matched.length?matched.map(n=>need(n)).join(' y '):need(profile.principal);
 if(profile.category==='cabello'){
  if(role==='cleanser')return 'Primer paso de limpieza capilar, elegido según el cabello y el cuero cabelludo descritos. Prepara los largos para el acondicionador o tratamiento posterior.';
  if(role==='conditioner')return 'Complementa la limpieza y facilita el cuidado de medios y puntas. No es necesario aplicarlo automáticamente sobre el cuero cabelludo.';
  if(role==='mask')return 'Tratamiento de aclarado que completa el acondicionamiento cuando la necesidad prioritaria es '+target+'.';
  if(role==='scalp')return 'Paso específico para el cuero cabelludo, independiente del cuidado de medios y puntas. Seleccionado por su afinidad con '+target+'.';
  if(role==='styling')return 'Paso de acabado que complementa el lavado y el tratamiento sin sustituirlos. Se ha elegido pensando en '+target+'.';
  if(role==='treatment')return 'Tratamiento complementario al champú y al acondicionamiento, orientado a '+target+'.';
 }
 if(role==='cleanser')return 'Limpieza facial adaptada a tus respuestas. Prepara la piel para recibir la loción y los tratamientos posteriores sin duplicar su función.';
 if(role==='toner')return (product.actives||[]).length?'Loción de tratamiento seleccionada por su afinidad con '+target+'. Su frecuencia de uso debe adaptarse a la tolerancia y a las instrucciones del fabricante.':'Loción que complementa la limpieza y precede a los tratamientos posteriores; seleccionada teniendo en cuenta '+target+'.';
 if(role==='serum')return 'Tratamiento concentrado dirigido a '+target+'. La crema posterior aporta el paso de confort y cuidado complementario de la rutina.';
 if(role==='moisturizer')return 'Crema elegida por su afinidad con '+target+' y el tipo de piel indicado. Completa el cuidado iniciado con la limpieza, la loción y el sérum, si está incluido.';
 if(role==='spf')return 'Protección solar diaria que completa el ritual de mañana y acompaña los tratamientos cosméticos utilizados en la rutina.';
 if(role==='eye')return 'Cuidado específico del contorno de ojos, incluido por tu elección y seleccionado según la preocupación indicada para esa zona.';
 if(role==='retinoid'||role==='exfoliant')return 'Paso de renovación cosmética sujeto a tolerancia y a las indicaciones del fabricante. No combinar automáticamente con otros tratamientos renovadores.';
 return 'Producto seleccionado por su adecuación al objetivo '+target+' y por su papel complementario en la rutina.';
}

function njUseWindow(product){
 if(product.primaryRole==='spf')return 'MAÑANA';
 if(product.time?.length===1)return product.time[0]==='pm'?'NOCHE':'MAÑANA';
 return 'MAÑANA Y NOCHE';
}
function njSynergyCopy(product,profile){
 const role=product.primaryRole;
 if(profile.category==='rostro'){
  if(role==='cleanser')return 'Abre la rutina y prepara la piel para los siguientes tratamientos.';
  if(role==='toner')return 'Se aplica entre la limpieza y el sérum. Si es una loción exfoliante, adapta su uso a la tolerancia y al resto de activos.';
  if(role==='serum')return 'Concentra el tratamiento de una de tus prioridades, que la crema completa con cuidado y confort.';
  if(role==='moisturizer')return 'Completa el sérum, si está presente. Por la mañana precede al fotoprotector.';
  if(role==='spf')return 'Termina el cuidado de mañana con fotoprotección diaria adecuada.';
  if(role==='mask')return 'Cuidado complementario ocasional seleccionado según tu objetivo. Consulta la frecuencia y forma de aplicación indicadas por el fabricante.';
  if(role==='eye')return 'Es un paso opcional y específico, orientado a la preocupación que has indicado.';
  if(role==='mask')return 'Complemento ocasional del ritual, sin sustituir los cuidados diarios.';
  if(role==='retinoid')return 'Tratamiento nocturno que requiere introducción gradual y atención a la compatibilidad con otros renovadores.';
 }else{
  if(role==='cleanser')return 'Prepara el cabello y el cuero cabelludo para el acondicionamiento.';
  if(role==='conditioner')return 'Complementa el champú y se alterna con otros tratamientos de aclarado según las necesidades.';
  if(role==='mask')return 'Paso de cuidado intensivo que puede alternarse con el acondicionador.';
  if(role==='treatment')return 'Refuerza la rutina más allá de la limpieza y el acondicionamiento.';
  if(role==='scalp')return 'Actúa en el cuidado del cuero cabelludo, distinto del tratamiento de medios y puntas.';
  if(role==='styling')return 'Finaliza la rutina sin reemplazar los pasos de limpieza y tratamiento.';
 }
 return 'Acompaña el resto de la selección con una función propia.';
}
function renderProduct(item,profile){
 const product=item.product||item;
 const image=img(product);
 const label=item.label||'SELECCIÓN PROFESIONAL';
 const alt=S.brandPreference&&product.vendorKey!==S.brandPreference;
 const use=profile.category==='cabello'
  ? ({cleanser:'EN EL LAVADO',conditioner:'EN EL LAVADO',mask:'MASCARILLA',scalp:'CUERO CABELLUDO',styling:'ACABADO',treatment:'TRATAMIENTO'}[product.primaryRole]||'CUIDADO CAPILAR')
  : njUseWindow(product);
 return `
 <article class="nj-step nj-lux-product" data-nj-product-id="${esc(String(product.variant.id))}">
  <div class="nj-lux-photo">${image?'<img src="'+esc(image)+'" alt="'+esc(product.title)+'" loading="lazy">':''}</div>
  <div class="nj-lux-details">
   <p class="nj-lux-step">${esc(label)}</p>
   <p class="nj-lux-vendor">${esc(product.vendor||'SELECCIÓN NOELIA JIMÉNEZ')}</p>
   <h4><a href="${esc(njProductUrl(product))}">${esc(product.title)}</a></h4>
   <div class="nj-lux-meta"><span class="nj-lux-price">${money(cents(product))}</span><span class="nj-lux-use">${esc(use)}</span></div>
   <p class="nj-lux-rationale"><span>POR QUÉ LO ELEGIMOS</span>${esc(reason(product,profile))}</p>
   <p class="nj-lux-synergy"><span>CÓMO ENCAJA EN TU RITUAL</span>${esc(njSynergyCopy(product,profile))}</p>
   ${alt?'<p class="nj-lux-alt"><strong>COMPLEMENTO DE OTRA MARCA</strong> · Hemos seleccionado '+esc(product.vendor)+' como alternativa para cubrir esta función de la rutina.</p>':''}
   ${product.variant.title&&product.variant.title!=='Default Title'?'<p class="nj-lux-format">Formato: '+esc(product.variant.title)+'</p>':''}
   ${product.njRule?.protocol?'<p class="nj-lux-protocol"><strong>Uso profesional:</strong> '+esc(product.njRule.protocol)+'</p>':''}
   <a class="nj-lux-product-link" href="${esc(njProductUrl(product))}">Descubrir el producto <span aria-hidden="true">↗</span></a>
  </div>
 </article>`;
}
/* =========================================================
   MARCA
========================================================= */

function brandText(){

  if(
    !S.brandPreference
  )
    return'';

  return`
    <p class="nj-receta__objetivo">
      Hemos tomado ${
        esc(
          BL[
            S.brandPreference
          ]
          ||
          S.brandPreference
        )
      } como primera opción. Cuando no cubra un paso, mostraremos otra marca con una explicación visible.
    </p>
  `;
}

function fallbackHtml(fallbacks,selectedProducts=[]){
 const selected=selectedProducts.filter(Boolean);
 const notes=[...new Set((fallbacks||[]).filter(Boolean))]
   .filter(note=>!(/\bp50\b|lotion p50|locion p50/i.test(note)))
   .filter(note=>!(/limpiador|limpieza|leche limpiadora/i.test(note) && selected.some(p=>p.primaryRole==='cleanser')))
   .filter(note=>!(/contorno de ojos/i.test(note) && selected.some(p=>p.primaryRole==='eye')));
 if(!notes.length)return '';
 const brandNotes=notes.filter(note=>/marca|fabricante|otra marca|biologique recherche|medik8|mesoestetic|natura bisse/i.test(note));
 const otherNotes=notes.filter(note=>!brandNotes.includes(note));
 const panel=(title,entries)=>entries.length?'<div class="nj-receta__guidance"><p class="nj-receta__btitle">'+title+'</p>'+entries.map(note=>'<p>'+esc(note)+'</p>').join('')+'</div>':'';
 return panel('SOBRE TU PREFERENCIA DE MARCA',brandNotes)+panel('NOTAS SOBRE TU RUTINA',otherNotes);
}

/* =========================================================
   ACCIONES
========================================================= */

function actions(
  single=false
){

  return`
    <div class="nj-actions">

      <button
        class="primary"
        type="button"
        data-cart
      >
        ${
          single
            ?'AÑADIR AL CARRITO'
            :'AÑADIR LA SELECCIÓN'
        }
      </button>

      <button
        class="sec"
        type="button"
        data-copy
      >
        COPIAR / COMPARTIR
      </button>

      <button
        class="sec"
        type="button"
        data-print
      >
        IMPRIMIR
      </button>

      <button
        class="sec"
        type="button"
        data-restart
      >
        REPETIR CONSULTA
      </button>

    </div>
  `;
}

function bind(
  products
){

  const clean=
    [
      ...new Map(
        products
          .filter(Boolean)
          .map(
            product=>[
              product.variant.id,
              product
            ]
          )
      )
        .values()
    ];

  const cart=
    app.querySelector(
      '[data-cart]'
    );

  if(cart){

    cart.onclick=
      async()=>{

        cart.disabled=
          true;

        cart.textContent=
          'AÑADIENDO…';
        const upper=app.querySelector('[data-nj-top-cart]');
        if(upper){upper.disabled=true;upper.textContent='AÑADIENDO…';}

        try{

          const response=
            await fetch(
              '/cart/add.js',
              {
                method:
                  'POST',

                headers:{
                  'Content-Type':
                    'application/json'
                },

                body:
                  JSON.stringify(
                    {
                      items:
                        clean
                          .map(
                            product=>({
                              id:
                                product.variant.id,

                              quantity:
                                1
                            })
                          )
                    }
                  )
              }
            );

          if(
            !response.ok
          )
            throw Error();

          location.href=
            '/cart';

        }catch(e){

          cart.disabled=false;
          const upper=app.querySelector('[data-nj-top-cart]');
          if(upper){upper.disabled=false;upper.textContent='AÑADIR MI RITUAL AL CARRITO';}

          cart.textContent=
            clean.length===
            1
              ?'AÑADIR AL CARRITO'
              :'AÑADIR LA SELECCIÓN';
        }
      };
  }

  const copy=
    app.querySelector(
      '[data-copy]'
    );

  if(copy){

    copy.onclick=
      async()=>{

        try{

          await navigator
            .clipboard
            .writeText(
              clean
                .map(
                  (
                    product,
                    index
                  )=>
                    `${
                      index+1
                    }. ${
                      product.title
                    }${product.variant.title&&product.variant.title!=='Default Title'?' · '+product.variant.title:''} — ${
                      money(
                        cents(product)
                      )
                    }`
                )
                .join(
                  '\n'
                )+'\n\n'+(app.querySelector('[data-nj-guide]')?.innerText||app.querySelector('[data-nj-guide]')?.textContent||'').trim()
            );

          alert(
            'Recomendación copiada.'
          );

        }catch(e){}
      };
  }

  const print=
    app.querySelector(
      '[data-print]'
    );

  if(print)
    print.onclick=
      ()=>window.print();

  const restart=
    app.querySelector(
      '[data-restart]'
    );

  if(restart)
    restart.onclick=
      start;
}


/* V14.2 · Guía de uso vinculada a los IDs realmente seleccionados.
   No se infieren cantidades, frecuencias ni compatibilidades no verificadas. */
function njGuideInstruction(p,role){
  if(p?.njRule?.protocol)return esc(p.njRule.protocol);
  const text={
    cleanser:'Limpieza. Sigue el modo de empleo y el aclarado indicado en la ficha.',
    toner:'Tras la limpieza y antes de los tratamientos. Si contiene ácidos, revisa la frecuencia y la compatibilidad.',
    exfoliant:'Tratamiento renovador: sigue la frecuencia y precauciones específicas del fabricante.',
    serum:'Tratamiento previo a la crema, según las instrucciones del fabricante.',
    retinoid:'Uso nocturno. Introduce de forma progresiva solo conforme a las instrucciones y precauciones verificadas.',
    moisturizer:'Crema después de los tratamientos compatibles; por la mañana, antes de la fotoprotección.',
    spf:'Fotoprotección al finalizar la rutina de mañana. Consulta las indicaciones de aplicación y reaplicación.',
    eye:'Cuidado del contorno: utiliza la zona y cantidad indicadas en la ficha del producto.',
    mask:'Mascarilla de uso complementario. Comprueba el momento, el tiempo y si debe aclararse.',
    conditioner:'Acondicionamiento del cabello. Consulta la zona de aplicación y el aclarado en la ficha.',
    treatment:'Tratamiento especial: comprueba si se usa antes o después del lavado y si necesita aclarado.',
    scalp:'Cuidado del cuero cabelludo. Consulta la forma de aplicación y la frecuencia en la ficha.',
    styling:'Acabado. Comprueba si se utiliza en húmedo o seco; no presupongas protección térmica.'
  };
  return esc(text[role]||'Consulta las instrucciones específicas del fabricante.');
}
function njGuideEntry(step){
  const p=step?.product||step;
  if(!p)return '';
  const role=step?.role||p.primaryRole;
  const href=esc(njProductUrl(p));
  return '<li><strong>'+esc(p.title)+'</strong><span class="nj-guide-usage">'+njGuideInstruction(p,role)+'</span><a href="'+href+'">Consultar ficha y modo de empleo</a></li>';
}
function njGuideHtml(selected,category,sourceSteps=[],plan=null){
  const ids=new Set((selected||[]).map(p=>String(p.variant?.id)));
  const active=sourceSteps.filter(x=>x?.product?.variant?.id&&ids.has(String(x.product.variant.id)));
  const added=selected.filter(p=>!active.some(x=>String(x.product.variant.id)===String(p.variant?.id)))
    .map(p=>({product:p,role:p.primaryRole}));
  const unique=steps=>[...new Map(steps.filter(x=>x?.product?.variant?.id).map(x=>[String(x.product.variant.id),x])).values()];
  const part=(heading,steps)=>steps.length?'<h4>'+heading+'</h4><ol class="nj-receta__uso">'+steps.map(njGuideEntry).join('')+'</ol>':'';
  let content='';
  if(category==='rostro'){
    const day=plan?.morning?plan.morning.filter(x=>ids.has(String(x.product.variant.id))):unique(active.filter(x=>x.product.time?.includes('am')));
    const night=plan?.night?plan.night.filter(x=>ids.has(String(x.product.variant.id))):unique(active.filter(x=>x.product.time?.includes('pm')&&x.role!=='spf'));
    const supplements=added.filter(x=>!['spf','retinoid'].includes(x.role));
    content=part('POR LA MAÑANA',day)+part('POR LA NOCHE',night)+part('CUIDADOS COMPLEMENTARIOS',supplements);
    if(!day.some(x=>x.role==='spf'))content+='<p class="nj-guide-note">Recuerda incorporar un fotoprotector adecuado a tu rutina de mañana, aunque no figure en esta selección.</p>';
  }else{
    const wash=unique(active.filter(x=>['cleanser','conditioner'].includes(x.role)));
    const specific=unique(active.filter(x=>!['cleanser','conditioner'].includes(x.role))).concat(added);
    content=part('EN EL LAVADO',wash)+part('TRATAMIENTOS Y ACABADO',specific);
  }
  if(!content)content='<p>Selecciona algún producto para ver cómo integrarlo en tu cuidado.</p>';
  return '<p class="nj-receta__btitle">TU RUTINA, PASO A PASO</p><p class="nj-guide-intro">Esta guía corresponde a los productos que has marcado.</p>'+content+'<p class="nj-guide-note">Las cantidades, los tiempos, la frecuencia y el aclarado deben seguir el modo de empleo de cada referencia. No combines nuevos tratamientos intensivos sin revisar su compatibilidad.</p>';
}
function njGuideSingle(p){
  return '<section class="nj-receta__guidance nj-usage-guide" data-nj-guide aria-label="Cómo usar el producto">'+
   '<p class="nj-receta__btitle">CÓMO INCORPORAR TU PRODUCTO</p><p>Este producto cumple un paso concreto; comprueba cómo combinarlo con tu rutina actual.</p><ol class="nj-receta__uso">'+njGuideEntry({product:p,role:p.primaryRole})+'</ol>'+ 
   '<p class="nj-guide-note">Sigue las instrucciones específicas antes de incorporarlo a tu cuidado diario.</p></section>';
}

/* =========================================================
   INSTRUCCIONES
========================================================= */

function instructions(
  plan
){

  const lines=[];

  if(
    plan.morning
      .some(
        item=>
          item.role===
          'cleanser'
      )
  )
    lines.push(
      'Comienza la mañana y la noche con la limpieza indicada.'
    );

  if(
    plan.night
      .some(
        item=>
          item.role===
          'exfoliant'
      )
  )
    lines.push(
      'La loción exfoliante se utiliza por la noche después de limpiar y antes del sérum.'
    );

  if(
    [
      ...plan.morning,
      ...plan.night
    ]
      .some(
        item=>
          item.role===
          'serum'
      )
  )
    lines.push(
      'Aplica el sérum después de la limpieza y antes de la crema.'
    );

  /*
   * Retinal SOLO si realmente
   * existe en el plan final.
  */

  const retinoid=
    plan.night
      .find(
        item=>
          item.role===
          'retinoid'
          &&
          isRet(
            item.product
          )
      );

  if(
    retinoid
  )
    lines.push(
      `Utiliza ${
        retinoid.product.title
      } únicamente por la noche, antes de la crema, con introducción progresiva.`
    );

  if(
    [
      ...plan.morning,
      ...plan.night
    ]
      .some(
        item=>
          item.role===
          'moisturizer'
      )
  )
    lines.push(
      'La crema completa el tratamiento antes de la fotoprotección por la mañana.'
    );

  if(
    plan.morning
      .some(
        item=>
          item.role===
          'spf'
      )
  )
    lines.push(
      'Por la mañana, el protector solar es siempre el último paso cosmético.'
    );

  return lines;
}

if(!document.getElementById('nj-analysis-progress-v146')){
  const st=document.createElement('style');
  st.id='nj-analysis-progress-v146';
  st.textContent="#nj-app .nj-analysis-shell{min-height:290px;box-sizing:border-box;background:linear-gradient(125deg,#f1f6f1,#fcfdfb 65%,#f5f8f3);border:1px solid #dce8dc;border-radius:5px;padding:clamp(38px,6vw,70px) 22px;display:flex;align-items:center;justify-content:center;flex-direction:column;text-align:center;color:#2b4232}#nj-app .nj-analysis-eyebrow{font-size:10px;letter-spacing:.21em;font-weight:600;text-transform:uppercase;color:#6b8574;margin:0 0 15px}#nj-app .nj-analysis-shell h3{font:400 clamp(28px,4vw,39px)/1.18 Baskerville,Georgia,serif!important;color:#293e30;letter-spacing:-.035em;margin:0 0 15px!important}#nj-app .nj-analysis-stage{font-size:14px;color:#627669;min-height:24px;line-height:1.6;margin:0 0 24px}#nj-app .nj-analysis-bar{position:relative;width:min(100%,390px);height:5px;border-radius:999px;background:#dce7dc;overflow:hidden}#nj-app .nj-analysis-bar::before{content:\"\";position:absolute;inset:0 auto 0 0;width:40%;border-radius:999px;background:linear-gradient(90deg,#9eb5a2,#597b64,#9eb5a2);animation:nj-analysis-sweep 1.6s ease-in-out infinite}#nj-app .nj-analysis-note{color:#89998b;font-size:11px;line-height:1.6;margin:17px 0 0}@keyframes nj-analysis-sweep{from{transform:translateX(-110%)}to{transform:translateX(350%)}}@media(max-width:640px){#nj-app .nj-analysis-shell{min-height:260px;padding:38px 18px}#nj-app .nj-analysis-stage{font-size:13px}}@media(prefers-reduced-motion:reduce){#nj-app .nj-analysis-bar::before{animation:none;width:100%;opacity:.8}}";
  document.head.appendChild(st);
}
function njAnalysisStage(message){
  const target=app.querySelector('[data-nj-analysis-status]');
  if(target)target.textContent=message;
}
function njAnalysisStart(){
  const title=S.modalidad==='producto'?'Preparando tu selección':'Estamos preparando tu rutina';
  app.innerHTML='<section class="nj-analysis-shell" role="status" aria-live="polite" aria-busy="true">'+
    '<p class="nj-analysis-eyebrow">MÉTODO NOELIA JIMÉNEZ</p><h3>'+title+'</h3>'+
    '<p class="nj-analysis-stage" data-nj-analysis-status>Consultando el catálogo profesional…</p>'+
    '<div class="nj-analysis-bar" role="progressbar" aria-label="Análisis en curso" aria-valuetext="Preparando la recomendación"></div>'+
    '<p class="nj-analysis-note">Seleccionamos productos que encajan con tus respuestas.</p></section>';
}

/* =========================================================
   RESULTADO
========================================================= */

async function recommend(){

  njAnalysisStart();
  // Duración mínima solo para evitar un destello con catálogo en caché.
  const minDisplay=new Promise(resolve=>setTimeout(resolve,850));
  setTimeout(()=>njAnalysisStage('Seguimos preparando tu selección. Puede tardar un poco…'),7000);

  const catalog=
    await fetchCatalog();

  njAnalysisStage('Contrastando tus respuestas con nuestros productos…');

  const currentProfile=
    profile();

  if(
    !catalog.length
  ){
    await minDisplay;
    return noMatch();
  }

  /* PRODUCTO ÚNICO */

  if(
    S.modalidad===
    'producto'
  ){

    const product=
      await single(
        catalog,
        currentProfile
      );

    if(!product){await minDisplay;return noMatch();}

    const candidates=!S.brandPreference
      ?await singleAlternatives(catalog,currentProfile,product)
      :[product];

    njAnalysisStage('Preparando tu selección personalizada…');
    await minDisplay;

    app.innerHTML=
      `
        <div class="nj-receta__result">

          <p class="nj-receta__rlabel">
            CONSULTA NOELIA JIMÉNEZ
          </p>

          <p class="nj-receta__rh3">
            ${
              esc(
                summary(
                  currentProfile
                )
              )
            }
          </p>

          ${brandText()}

          <div class="nj-receta__block">

            <p class="nj-receta__btitle">
              NUESTRA ELECCIÓN
            </p>

            ${
              candidates.map((candidate,index)=>renderProduct(
                {product:candidate,label:candidates.length>1?('OPCIÓN '+(index+1)+' · '+(index===0?'RECOMENDACIÓN PRINCIPAL':'ALTERNATIVA DE OTRA MARCA')):'NUESTRA ELECCIÓN'},
                currentProfile
              )).join('')
            }
            ${candidates.length>1?'<p class="nj-premium-note">Ambas opciones son alternativas para la misma necesidad. Elige una; no es necesario comprar las dos.</p>':''}
            ${candidates.length>1?'<div class="nj-receta__options" data-single-choice>'+candidates.map((p,i)=>'<button type="button" data-choice="'+i+'" aria-pressed="'+(i===0?'true':'false')+'">Elegir opción '+(i+1)+' · '+esc(p.vendor)+' · '+money(cents(p))+'</button>').join('')+'</div>':''}

            ${njGuideSingle(product)}

            ${actions(true)}

          </div>

          <div class="nj-receta__disclaimer" style="margin:24px 0;padding:18px;background:#f6f3ef;font-size:12px;line-height:1.7;color:#484039">
<strong>Importante sobre tu recomendación</strong><p>Esta selección es una orientación cosmética realizada exclusivamente a partir de tus respuestas, sin exploración presencial, valoración directa de tu piel o cabello ni acceso a tu historial completo. No constituye un diagnóstico ni sustituye una consulta profesional o médica. Los resultados pueden variar según las características individuales, el uso y la constancia; no podemos garantizar un resultado específico. La elección final de los productos corresponde al cliente. Si tienes caída intensa o repentina, irritación persistente o alguna patología, consulta con un profesional sanitario antes de usar nuevos tratamientos. Todo ello sin perjuicio de tus derechos legales como consumidor.</p></div>
<div class="nj-receta__firma">

            <span>
              Preparado según tus respuestas por el Método Noelia Jiménez
            </span>

            <small>
              Selección profesional · Salón de Madrid
            </small>

          </div>

        </div>
      `;

    bind([product]);
    if(candidates.length>1){
      app.querySelectorAll('[data-choice]').forEach(button=>{
        button.onclick=()=>{
          const chosen=candidates[Number(button.dataset.choice)];
          app.querySelectorAll('[data-choice]').forEach(el=>el.setAttribute('aria-pressed',el===button?'true':'false'));
          bind([chosen]);
          const guide=app.querySelector('[data-nj-guide]');if(guide)guide.outerHTML=njGuideSingle(chosen);
          const cart=app.querySelector('[data-cart]');
          if(cart)cart.textContent='AÑADIR MI OPCIÓN · '+money(cents(chosen));
        };
      });
      const cart=app.querySelector('[data-cart]');
      if(cart)cart.textContent='AÑADIR MI OPCIÓN · '+money(cents(product));
    }

    return;
  }

  /* CABELLO */

  if(
    currentProfile.category===
    'cabello'
  ){

    const routine=
      await hairRoutine(
        catalog,
        currentProfile
      );

    njAnalysisStage('Organizando los pasos de tu ritual capilar…');
    await minDisplay;
    return renderHair(
      currentProfile,
      njReduceHair(routine,currentProfile)
    );
  }

  /* ROSTRO */

  const plan=
    await facePlan(
      catalog,
      currentProfile
    );

  if(!njReduceFace(plan,currentProfile,catalog) && !S.brandPreference){
    await minDisplay;
    return noMatch();
  }
  njNightCreamPreference(plan,catalog,currentProfile);
  njEyePreference(plan,catalog,currentProfile);
  njAnalysisStage('Organizando los pasos de tu ritual facial…');
  await minDisplay;
  renderFace(
    currentProfile,
    plan
  );
}

/* =========================================================
   RESULTADO CABELLO
========================================================= */


/* Rutinas escalonadas: complementos solo verificados y no duplicados. */
function njPremiumUpgrades(core,type,profile,catalog){
 if(!catalog?.length||!profile)return [];
 const used=new Set(core.map(x=>String(x.product?.variant?.id)));
 const products=core.map(x=>x.product).filter(Boolean);
 const options=[];
 const preference=S.brandPreference||'';
 const initial=(type==='rostro'
  ?(S.nightCream?.startsWith('Quiero utilizar')?['mask','serum']:['mask','serum','moisturizer'])
  :['mask','conditioner','treatment','styling']);
 for(const role of initial){
  if(type==='rostro'&&role==='serum'&&!(profile.needs||[]).some(n=>n!==profile.principal))continue;
  if(type==='cabello'&&role==='conditioner'&&!core.some(x=>x.role==='mask'))continue;
  if(type==='cabello'&&role==='mask'&&core.some(x=>x.role==='mask'))continue;
  if(type==='cabello'&&role==='treatment'&&core.some(x=>x.role==='treatment'))continue;
  if(type==='cabello'&&role==='styling'&&core.some(x=>x.role==='styling'))continue;
  const moment=type==='rostro'?'pm':'';
  const candidates=catalog.filter(p=>p.njVerified&&p.category===type&&p.primaryRole===role
   &&p.variant?.id&&!used.has(String(p.variant.id))
   &&(!preference||p.vendorKey===preference)
   &&eligible(p,profile,role,moment)
   &&(p.needs||[]).some(n=>(profile.needs||[profile.principal]).includes(n))
   &&!(p.actives||[]).some(a=>['aha','bha','retinoid'].includes(a))
  ).map(p=>({p,s:score(p,profile,role,moment)+(p.needs.includes(profile.principal)?25:0)}))
  .filter(x=>x.s>0).sort((x,y)=>y.s-x.s);
  const safe=candidates.filter(x=>{
    if(type==='rostro'&&role==='serum'&&!x.p.needs.some(n=>n!==profile.principal&&profile.needs.includes(n)))return false;
    if(type==='rostro'&&role==='moisturizer'&&core.some(z=>z.role==='moisturizer'&&z.product?.variant?.id===x.p.variant.id))return false;
    return true;
  });
  const chosen=best(safe,products,profile,moment,Infinity);
  if(chosen){
   const label=type==='rostro'?(role==='mask'?'COMPLEMENTO SEMANAL · MASCARILLA':role==='moisturizer'?'ALTERNATIVA DE CREMA NOCTURNA':'TRATAMIENTO COMPLEMENTARIO DE NOCHE')
    :(role==='mask'?'CUIDADO SEMANAL · MASCARILLA':role==='conditioner'?'ACONDICIONAMIENTO COMPLEMENTARIO':role==='styling'?'ACABADO Y PROTECCIÓN':'TRATAMIENTO ADICIONAL');
   options.push({role,product:chosen,label,premiumExtra:true});
   used.add(String(chosen.variant.id));
   products.push(chosen);
   if(options.length>=2)break;
  }
 }
 return options;
}
function njShoppingExperience(items,type,profile,catalog,argumentsPlan=null){
 const result=app.querySelector('.nj-receta__result');
 if(!result||!items?.length)return;
 const original=[...new Map(items.filter(x=>x?.product?.variant?.id).map(x=>[String(x.product.variant.id),x])).values()];
 const extra=njPremiumUpgrades(original,type,profile,catalog);
 const unique=[...original,...extra];
 const selectedIds=new Set();
 const budget=NJ_MAX_BUDGET();
 const essential=type==='rostro'?['cleanser','moisturizer','spf']:['cleanser','conditioner','mask'];
 const balanced=type==='rostro'?['cleanser','toner','serum','moisturizer','spf','eye']:['cleanser','conditioner','mask','treatment','scalp'];
 const valueFor=tier=>{
  const arr=tier==='esencial'?original.filter(x=>essential.includes(x.role)):
   tier==='equilibrada'?original.filter(x=>balanced.includes(x.role)):unique;
  return arr.length?arr:original.slice(0,2);
 };
 const core=valueFor('equilibrada');
 const complete=valueFor('completo');
 const completeAdds=complete.some(x=>!core.some(y=>String(y.product.variant.id)===String(x.product.variant.id)));
 const completeTotal=njTotal(complete.map(x=>x.product));
 const completeAllowed=true; // El nivel completo siempre es seleccionable; el presupuesto se comprueba antes de permitir comprar.
 const pos=result.querySelector('.nj-receta__block');
 if(!pos)return;
 const panel=document.createElement('section');
 panel.className='nj-shop-editor nj-shop-v4';
 panel.innerHTML='<p class="nj-receta__rlabel">ELIGE TU EXPERIENCIA</p><h3>Un ritual que evoluciona contigo</h3><p class="muted">Empieza por lo esencial o incorpora los cuidados complementarios que realmente encajan con tu perfil.</p><div class="nj-shop-tiers" role="radiogroup" aria-label="Nivel de rutina"><button type="button" data-nj-tier="esencial" role="radio" aria-checked="false" tabindex="-1"><strong>01 · ESENCIAL</strong><small>Los pasos fundamentales</small></button><button type="button" data-nj-tier="equilibrada" role="radio" aria-checked="false" tabindex="-1"><strong>02 · EQUILIBRADA</strong><small>La selección diaria recomendada</small></button><button type="button" data-nj-tier="completo" role="radio" aria-checked="false" tabindex="-1"><strong>03 · COMPLETA</strong><small>Complementos de valor</small></button></div><p class="nj-tier-explanation" aria-live="polite"></p><div class="nj-shop-selection"></div><div class="nj-upgrades" hidden></div><section class="nj-receta__guidance nj-usage-guide" data-nj-guide aria-live="polite"></section><p class="nj-shop-hint">'+(type==='cabello'?'Los productos de tu selección se contabilizan una sola vez.':'Los productos utilizados mañana y noche se contabilizan una sola vez.')+'</p>';
 pos.parentNode.insertBefore(panel,pos);
 const upper=document.createElement('div');
 upper.className='nj-top-cart';
 upper.innerHTML='<div><span class="nj-top-cart-label">TU SELECCIÓN ACTUAL</span><strong data-nj-top-total></strong><small data-nj-top-count></small></div><button type="button" data-nj-top-cart>AÑADIR MI RITUAL AL CARRITO</button>';
 panel.appendChild(upper);
 const editorial=document.createElement('div');
 editorial.className='nj-expert-insight';
 editorial.innerHTML='<span class="nj-expert-tag">EL CRITERIO DE NOELIA</span><h4>Menos pasos innecesarios. Más coherencia.</h4><p>Tu ritual reúne productos con funciones complementarias, elegidos según tus respuestas. Puedes comenzar por los cuidados esenciales y ampliar la selección cuando te resulte útil.</p><p class="nj-expert-disclaimer">Orientación cosmética online; sigue las indicaciones de cada fabricante y adapta los tratamientos activos a tu tolerancia.</p>';
 panel.parentNode.insertBefore(editorial,panel);
 const topButton=upper.querySelector('[data-nj-top-cart]');
 topButton.onclick=()=>{const lower=result.querySelector('[data-cart]');if(lower&&!lower.disabled)lower.click();};
 const choices=panel.querySelector('.nj-shop-selection');
 const totalNode=result.querySelector('.nj-premium-total strong');
 const infoNode=panel.querySelector('.nj-shop-hint');
 const tiers=panel.querySelectorAll('[data-nj-tier]');
 const explanation=panel.querySelector('.nj-tier-explanation');
 const upgradesEl=panel.querySelector('.nj-upgrades');
 const guideEl=panel.querySelector('[data-nj-guide]');
 let tier='equilibrada';
 function update(){
  const chosen=unique.filter(x=>selectedIds.has(String(x.product.variant.id))).map(x=>x.product);
  const amount=njTotal(chosen),count=chosen.length;
  const withinBudget=budget===Infinity||amount<=budget;
  if(totalNode)totalNode.textContent=money(amount);
  result.querySelectorAll('.nj-lux-product[data-nj-product-id]').forEach(card=>{
   const included=selectedIds.has(card.dataset.njProductId);
   card.classList.toggle('nj-lux-excluded',!included);
   card.setAttribute('data-selection-status',included?'included':'excluded');
  });
  const extraSelected=extra.filter(x=>selectedIds.has(String(x.product.variant.id)));
  upgradesEl.hidden=!extraSelected.length; // Mostrar complementos seleccionados aunque la lista se haya personalizado.
  upgradesEl.innerHTML=extraSelected.length?'<p class="nj-receta__btitle">COMPLEMENTOS DE TU RITUAL COMPLETO</p>'+extraSelected.map(x=>renderProduct(x,profile)).join(''):'';
  upper.querySelector('[data-nj-top-total]').textContent=money(amount);
  upper.querySelector('[data-nj-top-count]').textContent=count+' producto'+(count===1?'':'s')+' seleccionado'+(count===1?'':'s');
  const warning=!withinBudget?' · Supera el presupuesto: desmarca algún producto antes de añadir al carrito.':'';
  infoNode.textContent=count+' producto'+(count===1?'':'s')+' · '+money(amount)+warning+' El carrito incluye únicamente los productos marcados.';
  choices.innerHTML=unique.map(x=>{
   const p=x.product,id=String(p.variant.id),isOn=selectedIds.has(id);
   return '<label class="nj-shop-item"><input type="checkbox" data-nj-product="'+esc(id)+'" '+(isOn?'checked':'')+'><span><strong>'+esc(p.title)+'</strong><small>'+money(cents(p))+(p.variant.title&&p.variant.title!=='Default Title'?' · '+esc(p.variant.title):'')+' · '+(isOn?'Incluido':'No incluido')+(x.premiumExtra?' · Complemento completo':'')+'</small></span></label>';
  }).join('');
  choices.querySelectorAll('[data-nj-product]').forEach(input=>{input.onchange=()=>{
    if(input.checked)selectedIds.add(input.dataset.njProduct);else selectedIds.delete(input.dataset.njProduct);
    tier='personalizada';
    tiers.forEach(b=>{b.setAttribute('aria-checked','false');b.tabIndex=-1;});
    explanation.textContent='Selección personalizada · has ajustado los productos manualmente.';
    update();
  };});
  guideEl.innerHTML=njGuideHtml(chosen,type,items,argumentsPlan);
  bind(chosen);
  const lower=result.querySelector('[data-cart]');
  if(lower){lower.disabled=!count||!withinBudget;lower.textContent=!count?'ELIGE AL MENOS UN PRODUCTO':withinBudget?'AÑADIR MI RITUAL AL CARRITO · '+money(amount):'AJUSTA LA SELECCIÓN A TU PRESUPUESTO';}
  topButton.disabled=!count||!withinBudget;topButton.textContent=!count?'ELIGE AL MENOS UN PRODUCTO':withinBudget?'AÑADIR MI RITUAL AL CARRITO':'SUPERA TU PRESUPUESTO';
  const printAndCopy=result.querySelectorAll('[data-copy],[data-print]');
  printAndCopy.forEach(x=>x.setAttribute('title','Se utilizará la selección actual de productos'));
 }
 function select(t){
  tier=t;
  selectedIds.clear();
  valueFor(t).forEach(x=>selectedIds.add(String(x.product.variant.id)));
  tiers.forEach(b=>{
   const active=b.dataset.njTier===t;
   b.setAttribute('aria-checked',active?'true':'false');
   b.tabIndex=active?0:-1;
   const rows=valueFor(b.dataset.njTier);
   b.querySelector('small').textContent=money(njTotal(rows.map(x=>x.product)))+' · '+(b.dataset.njTier==='completo'&&!completeAdds?'Sin adicionales necesarios':'Seleccionar ritual');
  });
  explanation.textContent=t==='esencial'?'Los cuidados fundamentales para empezar bien.':
   t==='equilibrada'?'Una rutina diaria con los pasos recomendados para tu perfil.':
   !completeAdds?'Ya tienes los pasos apropiados para una rutina completa. No añadimos productos innecesarios.':
   'Incorpora cuidados complementarios compatibles, cuando aportan una función diferente.';
  update();
 }
 const nav=Array.from(tiers);
 nav.forEach((b,i)=>{
  b.onclick=()=>select(b.dataset.njTier);
  b.onkeydown=e=>{
   if(!['ArrowRight','ArrowLeft','ArrowUp','ArrowDown'].includes(e.key))return;
   e.preventDefault();
   const next=nav[(i+(['ArrowRight','ArrowDown'].includes(e.key)?1:-1)+nav.length)%nav.length];
   select(next.dataset.njTier);next.focus();
  };
 });
 select('equilibrada');
}

function renderHair(
  profile,
  routine
){

  if(
    !routine.length
  )
    return noMatch();

  const products=
    routine
      .map(
        item=>
          item.product
      );

  app.innerHTML=
    `
      <div class="nj-receta__result">

        <p class="nj-receta__rlabel">
          CONSULTA NOELIA JIMÉNEZ
        </p>

        <p class="nj-receta__rh3">
          ${
            esc(
              summary(
                profile
              )
            )
          }
        </p>

<div class="nj-premium-intro nj-editorial-cover"><p class="nj-editorial-edition">NOELIA JIMÉNEZ · EDICIÓN PERSONAL</p><p class="nj-receta__rlabel">TU SELECCIÓN DE BELLEZA</p><h2>Tu ritual, <em>con intención.</em></h2><p>Una selección de cuidado adaptada a tus prioridades, explicada paso a paso para que puedas elegir con tranquilidad.</p><div class="nj-editorial-profile"><span>UN RITUAL PARA TI</span><strong>${esc(summary(profile))}</strong></div><p class="nj-editorial-signature">Noelia Jiménez · Madrid</p></div>

        ${brandText()}

        <div class="nj-receta__block">

          <p class="nj-receta__btitle">
            TU RECETA NOELIA JIMÉNEZ · CABELLO
          </p>

          ${
            routine
              .map(
                item=>
                  renderProduct(
                    item,
                    profile
                  )
              )
              .join('')
          }

          <div class="nj-premium-total"><span>Importe total de tu rutina capilar</span><strong>${money(njTotal(products))}</strong></div>
          <p class="nj-premium-note">El importe incluye cada producto una sola vez y corresponde a la selección completa.</p>

          ${actions(false)}

        </div>

        ${
          fallbackHtml(
            routine.brandFallbacks||[],products
          )
        }

        <div class="nj-receta__disclaimer" style="margin:24px 0;padding:18px;background:#f6f3ef;font-size:12px;line-height:1.7;color:#484039">
<strong>Importante sobre tu recomendación</strong><p>Esta selección es una orientación cosmética realizada exclusivamente a partir de tus respuestas, sin exploración presencial, valoración directa de tu piel o cabello ni acceso a tu historial completo. No constituye un diagnóstico ni sustituye una consulta profesional o médica. Los resultados pueden variar según las características individuales, el uso y la constancia; no podemos garantizar un resultado específico. La elección final de los productos corresponde al cliente. Si tienes caída intensa o repentina, irritación persistente o alguna patología, consulta con un profesional sanitario antes de usar nuevos tratamientos. Todo ello sin perjuicio de tus derechos legales como consumidor.</p></div>
<div class="nj-receta__firma">

          <span>
            Preparado según tus respuestas por el Método Noelia Jiménez
          </span>

          <small>
            Selección profesional · Salón de Madrid
          </small>

        </div>

      </div>
    `;

  bind(
    products
  );
  njShoppingExperience(routine,"cabello",profile,CATALOG);
}

/* =========================================================
   RESULTADO ROSTRO
========================================================= */

function renderFace(
  profile,
  plan
){

  const products=
    plan.uniqueProducts;

  if(
    !products.length
  )
    return noMatch();

  const total=
    products
      .reduce(
        (
          sum,
          product
        )=>
          sum
          +
          cents(
            product
          ),
        0
      );

  const budget=
    S.presupuesto===
    'none'
      ?Infinity
      :Number(
          S.presupuesto
        )
        *
        100;

  const budgetNote=plan.budgetReduced
    ?`<p class="nj-receta__objetivo">Hemos ajustado la selección a una rutina esencial para respetar tu presupuesto. Si no aparece tónico o sérum, se han priorizado la limpieza, la crema y el SPF. Puedes completar después los tratamientos.</p>`
    :budget!==Infinity
    &&
    total>budget
      ?`
        <p class="nj-receta__objetivo">
          La selección profesional supera el presupuesto indicado. Hemos mantenido la coherencia de la receta antes que sustituir productos por opciones menos adecuadas.
        </p>
      `
      :'';

  app.innerHTML=
    `
      <div class="nj-receta__result">

        <p class="nj-receta__rlabel">
          CONSULTA NOELIA JIMÉNEZ
        </p>

        <p class="nj-receta__rh3">
          ${
            esc(
              summary(
                profile
              )
            )
          }
        </p>

<div class="nj-premium-intro nj-editorial-cover"><p class="nj-editorial-edition">NOELIA JIMÉNEZ · EDICIÓN PERSONAL</p><p class="nj-receta__rlabel">TU SELECCIÓN DE BELLEZA</p><h2>Tu ritual, <em>con intención.</em></h2><p>Una selección de cuidado adaptada a tus prioridades, explicada paso a paso para que puedas elegir con tranquilidad.</p><div class="nj-editorial-profile"><span>UN RITUAL PARA TI</span><strong>${esc(summary(profile))}</strong></div><p class="nj-editorial-signature">Noelia Jiménez · Madrid</p></div>

        ${brandText()}

        ${budgetNote}

        <div class="nj-receta__block">

          <p class="nj-receta__btitle">
            MAÑANA
          </p>

          ${
            plan.morning
              .map(
                item=>
                  renderProduct(
                    item,
                    profile
                  )
              )
              .join('')
          }

        </div>

        <div class="nj-receta__block">

          <p class="nj-receta__btitle">
            NOCHE
          </p>

          ${
            plan.night
              .map(item=>{
                const alreadyInMorning=plan.morning.some(m=>
                  String(m.product?.variant?.id)===String(item.product?.variant?.id));
                if(!alreadyInMorning)return renderProduct(item,profile);
                return '<article class="nj-step nj-step--shared"><div style="grid-column:1/-1;padding:10px 0"><strong>'+esc(item.label||'PASO COMPARTIDO')+'</strong><p style="margin:8px 0"><b>'+esc(item.product.title)+'</b></p><p style="font-size:13px;color:#756a5e">Utiliza por la noche el mismo producto que por la mañana. Ya está incluido en tu selección: no necesitas comprar otra unidad.</p></div></article>';
              })
              .join('')
          }

<div class="nj-premium-total"><span>Importe de la selección</span><strong>${money(total)}</strong></div><p class="nj-premium-note">Los productos compartidos entre mañana y noche se cuentan una sola vez. El carrito añade una unidad de cada referencia, no dos.</p>
          ${actions(false)}

        </div>

        ${
          fallbackHtml(
            plan.brandFallbacks||[],plan.uniqueProducts
          )
        }

        <div class="nj-receta__disclaimer" style="margin:24px 0;padding:18px;background:#f6f3ef;font-size:12px;line-height:1.7;color:#484039">
<strong>Importante sobre tu recomendación</strong><p>Esta selección es una orientación cosmética realizada exclusivamente a partir de tus respuestas, sin exploración presencial, valoración directa de tu piel o cabello ni acceso a tu historial completo. No constituye un diagnóstico ni sustituye una consulta profesional o médica. Los resultados pueden variar según las características individuales, el uso y la constancia; no podemos garantizar un resultado específico. La elección final de los productos corresponde al cliente. Si tienes caída intensa o repentina, irritación persistente o alguna patología, consulta con un profesional sanitario antes de usar nuevos tratamientos. Todo ello sin perjuicio de tus derechos legales como consumidor.</p></div>
<div class="nj-receta__firma">

          <span>
            Preparado según tus respuestas por el Método Noelia Jiménez
          </span>

          <small>
            Selección profesional · Salón de Madrid
          </small>

        </div>

      </div>
    `;

  bind(
    products
  );
  njShoppingExperience([...plan.morning,...plan.night],"rostro",profile,CATALOG,plan);
}

/* =========================================================
   SIN RECOMENDACIÓN
========================================================= */

function noMatch(){

  app.innerHTML=
    `
      <div class="nj-receta__result">

        <p class="nj-receta__rlabel">
          CONSULTA NOELIA JIMÉNEZ
        </p>

        <p class="nj-receta__rh3">
          Preferimos no forzar una recomendación.
        </p>

        <p>
          No hemos encontrado una selección disponible que cumpla con suficiente precisión tu perfil y nuestro criterio profesional.
        </p>

        <div class="nj-actions">

          <button
            class="primary"
            type="button"
            data-restart
          >
            REPETIR CONSULTA
          </button>

        </div>

      </div>
    `;

  app.querySelector(
    '[data-restart]'
  )
    .onclick=
      start;
}

/* =========================================================
   RESET
========================================================= */

function reset(){

  Object.assign(
    S,
    {
      categoria:'',
      modalidad:'',
      singleRole:'',
      brandPreference:'',
      p1:'',
      p2:'',
      p3:'',
      p4:'',
      p5:'',
      nightCream:'recommend',
      eyeChoice:'No, prefiero no incluirlo',
      eyeNeed:'',
      extra:'',
      presupuesto:'none'
    }
  );
}

/* =========================================================
   INICIO
========================================================= */

function start(){

  reset();

  app.innerHTML=
    `
      <div class="nj-lux-hero"><p class="nj-lux-eyebrow">MÉTODO NOELIA JIMÉNEZ · BEAUTY ROUTINE</p><p class="nj-receta__rlabel">
        CONSULTA NOELIA JIMÉNEZ
      </p>

      <h3>
        ¿Qué quieres cuidar hoy?
      </h3>

      <p class="muted">
        Empezamos por entender qué necesitas. Puedes combinar varias preocupaciones para una recomendación más ajustada. Esta orientación online no sustituye una evaluación presencial.
      </p>

      <div class="nj-receta__options">

        <button
          type="button"
          data-category="cabello"
        >
          Cabello
        </button>

        <button
          type="button"
          data-category="rostro"
        >
          Rostro
        </button>

      </div>
      <p class="nj-lux-signature">Una selección experta. Solo para ti.</p></div>
    `;

  app
    .querySelectorAll(
      '[data-category]'
    )
    .forEach(
      button=>

        button.onclick=
          ()=>{

            S.categoria=
              button.dataset
                .category;

            modality();
          }
    );
}

/* =========================================================
   MODALIDAD
========================================================= */

function modality(){

  app.innerHTML=
    `
      <button
        class="nj-back"
        type="button"
        data-back
      >
        ← Volver
      </button>

      <p class="nj-receta__progress">
        TU CONSULTA
      </p>

      <h3>
        ¿Qué necesitas hoy?
      </h3>

      <div class="nj-receta__options">

        <button
          type="button"
          data-mode="rutina"
        >
          Una rutina completa
        </button>

        <button
          type="button"
          data-mode="producto"
        >
          Solo un producto
        </button>

      </div>
    `;

  app
    .querySelectorAll(
      '[data-mode]'
    )
    .forEach(
      button=>

        button.onclick=
          ()=>{

            S.modalidad=
              button.dataset
                .mode;

            ask(
              0
            );
          }
    );

  app.querySelector(
    '[data-back]'
  )
    .onclick=
      start;
}

/* =========================================================
   PREGUNTAS
========================================================= */

function njVisibleQuestions(){
  return Q[S.categoria].filter(q=>
    !(S.modalidad==='producto'&&['nightCream','eyeChoice','eyeNeed'].includes(q.k)) &&
    !(q.k==='eyeNeed'&&S.eyeChoice!=='Sí, quiero cuidar el contorno de ojos')
  );
}

function ask(index){
  const questions=njVisibleQuestions(), question=questions[index];
  const multi=!!question.multi;
  const previous=(S[question.k]||'').split(' | ').filter(Boolean);
  app.innerHTML=`
    <section class="nj-lux-question"><button class="nj-back" type="button" data-back>← Volver</button>
    <p class="nj-receta__progress">PASO ${index+1} DE ${questions.length} · ${esc(question.e)}</p><div class="nj-lux-progress" aria-hidden="true"><span style="width:${Math.round((index+1)/questions.length*100)}%"></span></div>
    <h3>${esc(question.q)}</h3>
    ${multi?'<p class="muted">Puedes marcar varias opciones. La selección se combinará para orientar la recomendación.</p>':''}
    <div class="nj-receta__options">
      ${question.o.map(option=>`
        <button type="button" data-value="${esc(option)}" aria-pressed="${multi&&previous.includes(option)?'true':'false'}"
          style="${multi&&previous.includes(option)?'border:2px solid #292520;background:#f5f0e9':''}">${esc(option)}${multi&&previous.includes(option)?' ✓':''}</button>
      `).join('')}
    </div>
    ${multi?'<button class="primary" type="button" data-continue>CONTINUAR →</button>':''}
    </section>
  `;
  const next=()=>{
    // La respuesta ya está guardada cuando se ejecuta next().
    // Al elegir Sí, eyeNeed debe aparecer antes de continuar.
    // Localizar la pregunta por su clave evita depender de un índice anterior.
    const updatedQuestions=njVisibleQuestions();
    const currentIndex=updatedQuestions.findIndex(q=>q.k===question.k);
    if(currentIndex>=0&&currentIndex<updatedQuestions.length-1)ask(currentIndex+1);
    else if(S.modalidad==='producto')singleRole();
    else brand();
  };
  app.querySelectorAll('[data-value]').forEach(button=>{
    button.onclick=()=>{
      const option=button.dataset.value;
      if(!multi){S[question.k]=option;if(question.k==='eyeChoice'&&option!=='Sí, quiero cuidar el contorno de ojos')S.eyeNeed='';next();return;}
      const current=(S[question.k]||'').split(' | ').filter(Boolean);
      const updated=current.includes(option)?current.filter(v=>v!==option):[...current,option];
      S[question.k]=updated.join(' | ');
      button.setAttribute('aria-pressed',updated.includes(option)?'true':'false');
      button.style.border=updated.includes(option)?'2px solid #292520':'';
      button.style.background=updated.includes(option)?'#f5f0e9':'';
      button.textContent=option+(updated.includes(option)?' ✓':'');
    };
  });
  if(multi)app.querySelector('[data-continue]').onclick=()=>{
    if(!(S[question.k]||'').trim()){
      alert('Selecciona al menos una opción para continuar.');
      return;
    }
    next();
  };
  app.querySelector('[data-back]').onclick=()=>index===0?modality():ask(index-1);
}

/* =========================================================
   PRODUCTO ÚNICO
========================================================= */

function singleRole(){

  const options=
    S.categoria===
    'rostro'
      ?[
          [
            'cleanser',
            'Limpiador'
          ],
          [
            'serum',
            'Sérum / tratamiento'
          ],
          [
            'moisturizer',
            'Crema'
          ],
          [
            'spf',
            'Protector solar'
          ],
          [
            'exfoliant',
            'Loción / exfoliante'
          ],
          [
            'auto',
            'No lo sé · recomiéndame el más importante'
          ]
        ]
      :[
          [
            'cleanser',
            'Champú'
          ],
          [
            'conditioner',
            'Acondicionador'
          ],
          [
            'mask',
            'Mascarilla'
          ],
          [
            'treatment',
            'Tratamiento'
          ],
          [
            'scalp',
            'Tratamiento de cuero cabelludo'
          ],
          [
            'styling',
            'Protector / leave-in / styling'
          ],
          [
            'auto',
            'No lo sé · recomiéndame el más importante'
          ]
        ];

  app.innerHTML=
    `
      <button
        class="nj-back"
        type="button"
        data-back
      >
        ← Volver
      </button>

      <p class="nj-receta__progress">
        EL PRODUCTO QUE BUSCAS
      </p>

      <h3>
        ¿Qué tipo de producto necesitas?
      </h3>

      <p class="muted">
        Así podemos recomendarte la mejor opción para ese paso concreto.
      </p>

      <div class="nj-receta__options">

        ${
          options
            .map(
              (
                [
                  value,
                  label
                ]
              )=>
                `
                  <button
                    type="button"
                    data-role="${value}"
                  >
                    ${label}
                  </button>
                `
            )
            .join('')
        }

      </div>
    `;

  app
    .querySelectorAll(
      '[data-role]'
    )
    .forEach(
      button=>

        button.onclick=
          ()=>{

            S.singleRole=
              button.dataset
                .role;

            brand();
          }
    );

  app.querySelector(
    '[data-back]'
  )
    .onclick=
      ()=>
        ask(njVisibleQuestions().length-1);
}

/* =========================================================
   PREFERENCIA DE MARCA
========================================================= */

function brand(){

  const options=
    BRAND[
      S.categoria
    ]
    ||
    [];

  app.innerHTML=
    `
      <button
        class="nj-back"
        type="button"
        data-back
      >
        ← Volver
      </button>

      <p class="nj-receta__progress">
        PREFERENCIA DE MARCA
      </p>

      <h3>
        ¿Tienes preferencia por alguna de nuestras marcas?
      </h3>

      <p class="muted">
        Si eliges una marca, intentaremos mantener la recomendación dentro de ella siempre que cada producto cumpla realmente la función que necesita tu perfil.
      </p>

      <div class="nj-receta__options">

        <button
          type="button"
          data-brand=""
        >
          No · elegid la mejor combinación para mí
        </button>

        ${
          options
            .map(
              (
                [
                  value,
                  label
                ]
              )=>
                `
                  <button
                    type="button"
                    data-brand="${value}"
                  >
                    ${label}
                  </button>
                `
            )
            .join('')
        }

      </div>
    `;

  app
    .querySelectorAll(
      '[data-brand]'
    )
    .forEach(
      button=>

        button.onclick=
          ()=>{

            S.brandPreference=
              button.dataset
                .brand
              ||
              '';

            askExtra();
          }
    );

  app.querySelector(
    '[data-back]'
  )
    .onclick=
      ()=>{

        if(
          S.modalidad===
          'producto'
        )
          singleRole();

        else
          ask(njVisibleQuestions().length-1);
      };
}

/* =========================================================
   TEXTO LIBRE
========================================================= */

function askExtra(){

  app.innerHTML=
    `
      <button
        class="nj-back"
        type="button"
        data-back
      >
        ← Volver
      </button>

      <p class="nj-receta__progress">
        ALGO MÁS QUE DEBAMOS SABER
      </p>

      <h3>
        ¿Quieres contarnos algo más?
      </h3>

      <p class="muted">
        Es opcional. Puedes indicar productos que ya utilizas, tratamientos recientes, sensibilidad, natación, uso de plancha o cualquier dato importante.
      </p>

      <textarea
        id="nj-extra"
        maxlength="400"
        placeholder="Por ejemplo: utilizo retinal tres noches por semana..."
        style="
          width:100%;
          max-width:620px;
          display:block;
          margin:24px auto;
          min-height:130px;
          padding:16px;
          border:1px solid #d9d1c8;
          background:#fff;
        "
      ></textarea>

      <button
        class="primary"
        type="button"
        data-next
      >
        CONTINUAR
      </button>
    `;

  app.querySelector(
    '[data-next]'
  )
    .onclick=
      ()=>{

        S.extra=
          app.querySelector(
            '#nj-extra'
          )
            .value
            .trim();

        budget();
      };

  app.querySelector(
    '[data-back]'
  )
    .onclick=
      brand;
}

/* =========================================================
   PRESUPUESTO
========================================================= */

function budget(){

  const options=
    S.modalidad===
    'producto'
      ?[
          [
            '50',
            'Hasta 50 €'
          ],
          [
            '100',
            'Hasta 100 €'
          ],
          [
            'none',
            'Sin presupuesto fijado'
          ]
        ]
      :[
          [
            '100',
            'Hasta 100 €'
          ],
          [
            '200',
            'Hasta 200 €'
          ],
          [
            'none',
            'Sin presupuesto fijado'
          ]
        ];

  app.innerHTML=
    `
      <button
        class="nj-back"
        type="button"
        data-back
      >
        ← Volver
      </button>

      <p class="nj-receta__progress">
        TU INVERSIÓN
      </p>

      <h3>
        ¿Qué presupuesto quieres destinar?
      </h3>

      <p class="muted">
        El presupuesto es un límite, no un objetivo de gasto.
      </p>

      <div class="nj-receta__options">

        ${
          options
            .map(
              (
                [
                  value,
                  label
                ]
              )=>
                `
                  <button
                    type="button"
                    data-budget="${value}"
                  >
                    ${label}
                  </button>
                `
            )
            .join('')
        }

      </div>
    `;

  app
    .querySelectorAll(
      '[data-budget]'
    )
    .forEach(
      button=>

        button.onclick=
          ()=>{

            S.presupuesto=
              button.dataset
                .budget;

            recommend();
          }
    );

  app.querySelector(
    '[data-back]'
  )
    .onclick=
      askExtra;
}

/* =========================================================
   ARRANQUE
========================================================= */

const startButton=
  app.querySelector(
    '[data-start]'
  );

if(
  startButton
)
  startButton.onclick=
    start;

})();